(function () {

// Evite un bug JS
var $90d4a3efe8d7ad9d$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $90d4a3efe8d7ad9d$var$runtime = function(exports) {
    "use strict";
    var define = function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    };
    var wrap = function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    };
    var tryCatch = // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    };
    var Generator = // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {};
    var GeneratorFunction = function GeneratorFunction() {};
    var GeneratorFunctionPrototype = function GeneratorFunctionPrototype() {};
    var defineIteratorMethods = // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    };
    var AsyncIterator = function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    };
    var makeInvokeMethod = function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    };
    var pushTryEntry = function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    };
    var resetTryEntry = function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    };
    var Context = function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    };
    var values = function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    };
    var doneResult = function doneResult() {
        return {
            value: undefined,
            done: true
        };
    };
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    exports.wrap = wrap;
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    exports.values = values;
    Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function stop() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            var handle = function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            };
            if (this.done) throw exception;
            var context = this;
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $90d4a3efe8d7ad9d$exports));
try {
    regeneratorRuntime = $90d4a3efe8d7ad9d$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $90d4a3efe8d7ad9d$var$runtime;
    else Function("r", "regeneratorRuntime = r")($90d4a3efe8d7ad9d$var$runtime);
}


window.addEventListener("DOMContentLoaded", function() {
    //////// MENU BURGER
    var burger = document.querySelector("#btn-menu");
    var menu = document.querySelector(".Header");
    if (burger && menu) burger.addEventListener("click", function() {
        var menuOpen = burger.getAttribute("aria-expanded") === "true";
        if (!menuOpen) {
            burger.setAttribute("aria-expanded", true);
            menu.classList.add("open");
        } else {
            burger.setAttribute("aria-expanded", false);
            menu.classList.remove("open");
        }
    });
});
if (window.innerWidth <= 992) {
    // Code JavaScript pour ajouter un bouton après chaque élément du menu ayant la classe "menu-item-has-children"
    document.addEventListener("DOMContentLoaded", function() {
        // Sélectionner tous les éléments du menu ayant la classe "menu-item-has-children"
        var menuItemsWithChildren = document.querySelectorAll(".menu-item-has-children");
        // Parcourir chaque élément du menu ayant la classe "menu-item-has-children"
        menuItemsWithChildren.forEach(function(menuItem) {
            // Créer un nouvel élément de bouton (button)
            var button = document.createElement("button");
            button.textContent = "+"; // Texte initial du bouton
            // Ajouter une classe CSS au bouton si nécessaire
            button.classList.add("custom-button");
            // Ajouter le bouton après l'élément du menu
            menuItem.appendChild(button);
        });
    });
    // Gestionnaire d'événement "click" pour tout le menu
    document.addEventListener("click", function(event) {
        // Vérifier si l'élément cliqué est un bouton avec la classe "custom-button"
        if (event.target.classList.contains("custom-button")) {
            // Récupérer l'élément du menu parent (li) du bouton cliqué
            var menuItem = event.target.parentElement;
            // Basculer la classe "show" sur l'élément du menu parent pour afficher/masquer le sous-menu
            menuItem.classList.toggle("show");
            // Mettre à jour le texte du bouton en fonction de l'état du sous-menu
            var button = event.target;
            if (menuItem.classList.contains("show")) button.textContent = "-"; // Texte du bouton lorsque le sous-menu est ouvert
            else button.textContent = "+"; // Texte du bouton lorsque le sous-menu est fermé
            // Fermer tous les autres sous-menus sauf celui cliqué
            var menuItems = document.querySelectorAll(".menu-item-has-children");
            menuItems.forEach(function(otherMenuItem) {
                if (otherMenuItem !== menuItem && otherMenuItem.classList.contains("show")) {
                    otherMenuItem.classList.remove("show");
                    var otherButton = otherMenuItem.querySelector(".custom-button");
                    otherButton.textContent = "+"; // Remettre le texte du bouton à "+"
                }
            });
        }
    });
}
var $458767e8bf442525$var$SousMenus = document.querySelectorAll(".menu-item-has-children");
function $458767e8bf442525$var$addMouseoverListener() {
    if (window.innerWidth >= 992) $458767e8bf442525$var$SousMenus.forEach(function(SousMenu) {
        SousMenu.addEventListener("mouseover", function() {
            this.classList.add("open");
        });
        SousMenu.addEventListener("mouseout", function() {
            this.classList.remove("open");
        });
    });
}
$458767e8bf442525$var$addMouseoverListener(); // Call the function initially
window.addEventListener("resize", $458767e8bf442525$var$addMouseoverListener); // Add event listener for window resize
var $458767e8bf442525$var$SousMenu = document.querySelectorAll(".menu-item-has-children");
$458767e8bf442525$var$SousMenu.forEach(function(index, value) {
    index.addEventListener("mouseover", function() {
        this.classList.add("open");
    });
    index.addEventListener("mouseout", function() {
        this.classList.remove("open");
    });
});
// Sous Menu
var $458767e8bf442525$var$SousMenuP = document.querySelector(".sousMenuP");
var $458767e8bf442525$var$SousMenuOpen = document.querySelector(".sousMenu");
if ($458767e8bf442525$var$SousMenuP && $458767e8bf442525$var$SousMenuOpen) $458767e8bf442525$var$SousMenuP.addEventListener("click", function() {
    var OpenIt = $458767e8bf442525$var$SousMenuP.getAttribute("aria-expanded") == "true";
    if (!OpenIt) {
        $458767e8bf442525$var$SousMenuP.setAttribute("aria-expanded", true);
        $458767e8bf442525$var$SousMenuOpen.classList.add("open");
    } else {
        $458767e8bf442525$var$SousMenuP.setAttribute("aria-expanded", false);
        $458767e8bf442525$var$SousMenuOpen.classList.remove("open");
    }
});


/**
 * RingoSelect
 * @type {NodeListOf<HTMLElementTagNameMap[string]> | NodeListOf<Element> | NodeListOf<SVGElementTagNameMap[string]>}
 */ var $3846f8aff324d436$var$RSelect = document.querySelectorAll(".Ringo-Select");
if (typeof $3846f8aff324d436$var$RSelect != "undefined") {
    $3846f8aff324d436$var$RSelect.forEach(function(elem) {
        var ul = document.createElement("ul");
        ul.classList.add("Ringo-Select__generated");
        var longueur = elem.getElementsByTagName("option").length;
        var divSelect = document.createElement("div");
        divSelect.classList.add("Ringo-Select__divSelect");
        for(var i = 0; i < longueur; i++){
            var opt = document.createElement("li");
            opt.innerHTML = elem.getElementsByTagName("option")[i].innerHTML;
            opt.setAttribute("data-value", elem.getElementsByTagName("option")[i].value);
            opt.setAttribute("data-index", elem.getElementsByTagName("option")[i].index);
            opt.value = elem.getElementsByTagName("option")[i].value;
            if (elem.getElementsByTagName("option")[i].selected === true) {
                opt.classList.add("selected");
                divSelect.innerHTML = elem.getElementsByTagName("option")[i].innerHTML;
            }
            ul.appendChild(opt);
        }
        elem.getElementsByTagName("select")[0].style.display = "none";
        elem.append(divSelect);
        elem.append(ul);
        var newOpt = ul.getElementsByTagName("li");
        for(var i1 = 0; i1 < newOpt.length; i1++)newOpt[i1].addEventListener("click", function() {
            ul.parentNode.querySelector("select").selectedIndex = this.getAttribute("data-index");
            ul.parentNode.querySelector(".Ringo-Select__divSelect").innerHTML = this.innerHTML;
        });
        // CLASS OPENED
        divSelect.addEventListener("click", function(e) {
            e.stopPropagation();
            divSelect.parentNode.classList.toggle("opened");
        });
        ul.addEventListener("click", function(e) {
            e.stopPropagation();
            divSelect.parentNode.classList.remove("opened");
        });
    });
    window.addEventListener("click", function(e) {
        var RSelectUL = document.querySelectorAll(".Ringo-Select ul");
        RSelectUL.forEach(function(elem) {
            e.stopPropagation();
            if (elem.parentNode.classList.contains("opened")) elem.parentNode.classList.remove("opened");
        });
    });
}
// Exemple de Onchange pour select
// let toto2 = document.getElementById('select2').parentNode.querySelector('ul');
// toto2.addEventListener('click', function () {
//     console.log('click marche')
// })
if (document.querySelector(".letter-space")) {
    var $3846f8aff324d436$var$titre = document.querySelector("h1").textContent;
    var $3846f8aff324d436$var$content = $3846f8aff324d436$var$titre.split(" ");
    var $3846f8aff324d436$var$newTitle = "";
    if ($3846f8aff324d436$var$content.length > 1) {
        $3846f8aff324d436$var$newTitle += "<span>" + $3846f8aff324d436$var$content[0] + "</span><br>" + $3846f8aff324d436$var$content[1] + "<br>";
        for(var $3846f8aff324d436$var$i = 2; $3846f8aff324d436$var$i < $3846f8aff324d436$var$content.length; $3846f8aff324d436$var$i++)$3846f8aff324d436$var$newTitle += " " + $3846f8aff324d436$var$content[$3846f8aff324d436$var$i];
    } else if ($3846f8aff324d436$var$content.length >= 2) {
        $3846f8aff324d436$var$newTitle += "<span>" + $3846f8aff324d436$var$content[0] + " " + $3846f8aff324d436$var$content[1] + "</span><br>";
        for(var $3846f8aff324d436$var$i1 = 2; $3846f8aff324d436$var$i1 < $3846f8aff324d436$var$content.length; $3846f8aff324d436$var$i1++)$3846f8aff324d436$var$newTitle += " " + $3846f8aff324d436$var$content[$3846f8aff324d436$var$i1];
    } else $3846f8aff324d436$var$newTitle = $3846f8aff324d436$var$content[0];
    document.querySelector("h1").innerHTML = $3846f8aff324d436$var$newTitle;
}
// if(document.querySelector('.FrontPage')){
//   let titre = document.querySelectorAll('h2').firstChild.nodeValue; 
//   console.log(titre);
//   content = titre.split(" ");
//   content[0] = '<span>' +content[0]+ '</span></br>';
//   console.log(content[0]);
//   document.querySelector('h1').innerHTML = content[0] + content[1];
// }
// const spans = document.querySelectorAll('.page--list--item--text');
// // Parcourez les éléments et ajustez le padding si la hauteur est supérieure à 40px
// spans.forEach(span => {
//   const hauteur = span.offsetHeight;
//   if (hauteur > 30) {
//     spans.style.padding = '2rem';
//   }
// });
// Sélectionnez tous les éléments <li> de la classe .page--list--item
var $3846f8aff324d436$var$liItems = document.querySelectorAll(".page--list--item");
// Parcourez les éléments et ajustez le padding si la hauteur de l'élément span est supérieure à 40px
$3846f8aff324d436$var$liItems.forEach(function(li) {
    var span = li.querySelector(".page--list--item--text span"); // Sélectionnez l'élément <span> à l'intérieur de chaque <li>
    var text = li.querySelector(".page--list--item--text"); // Sélectionnez l'élément <span> à l'intérieur de chaque <li>
    if (span) {
        var hauteur = span.offsetHeight;
        if (hauteur > 20) text.style.padding = "3rem 4rem";
        if (hauteur > 40) text.style.padding = "2rem 4rem";
    }
});


function $bc42fe4e0dfcb3f7$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


function $7bbd5095d4c1197b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7bbd5095d4c1197b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7bbd5095d4c1197b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7bbd5095d4c1197b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ var $7bbd5095d4c1197b$var$MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var $7bbd5095d4c1197b$var$CREATED = 1;
var $7bbd5095d4c1197b$var$MOUNTED = 2;
var $7bbd5095d4c1197b$var$IDLE = 3;
var $7bbd5095d4c1197b$var$MOVING = 4;
var $7bbd5095d4c1197b$var$SCROLLING = 5;
var $7bbd5095d4c1197b$var$DRAGGING = 6;
var $7bbd5095d4c1197b$var$DESTROYED = 7;
var $7bbd5095d4c1197b$var$STATES = {
    CREATED: $7bbd5095d4c1197b$var$CREATED,
    MOUNTED: $7bbd5095d4c1197b$var$MOUNTED,
    IDLE: $7bbd5095d4c1197b$var$IDLE,
    MOVING: $7bbd5095d4c1197b$var$MOVING,
    SCROLLING: $7bbd5095d4c1197b$var$SCROLLING,
    DRAGGING: $7bbd5095d4c1197b$var$DRAGGING,
    DESTROYED: $7bbd5095d4c1197b$var$DESTROYED
};
function $7bbd5095d4c1197b$var$empty(array) {
    array.length = 0;
}
function $7bbd5095d4c1197b$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $7bbd5095d4c1197b$var$apply(func) {
    return func.bind.apply(func, [
        null
    ].concat($7bbd5095d4c1197b$var$slice(arguments, 1)));
}
var $7bbd5095d4c1197b$var$nextTick = setTimeout;
var $7bbd5095d4c1197b$var$noop = function noop() {};
function $7bbd5095d4c1197b$var$raf(func) {
    return requestAnimationFrame(func);
}
function $7bbd5095d4c1197b$var$typeOf(type, subject) {
    return (typeof subject === "undefined" ? "undefined" : (0, $bc42fe4e0dfcb3f7$export$5f0017c582d45a2d)(subject)) === type;
}
function $7bbd5095d4c1197b$var$isObject(subject) {
    return !$7bbd5095d4c1197b$var$isNull(subject) && $7bbd5095d4c1197b$var$typeOf("object", subject);
}
var $7bbd5095d4c1197b$var$isArray = Array.isArray;
var $7bbd5095d4c1197b$var$isFunction = $7bbd5095d4c1197b$var$apply($7bbd5095d4c1197b$var$typeOf, "function");
var $7bbd5095d4c1197b$var$isString = $7bbd5095d4c1197b$var$apply($7bbd5095d4c1197b$var$typeOf, "string");
var $7bbd5095d4c1197b$var$isUndefined = $7bbd5095d4c1197b$var$apply($7bbd5095d4c1197b$var$typeOf, "undefined");
function $7bbd5095d4c1197b$var$isNull(subject) {
    return subject === null;
}
function $7bbd5095d4c1197b$var$isHTMLElement(subject) {
    try {
        return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
    } catch (e) {
        return false;
    }
}
function $7bbd5095d4c1197b$var$toArray(value) {
    return $7bbd5095d4c1197b$var$isArray(value) ? value : [
        value
    ];
}
function $7bbd5095d4c1197b$var$forEach(values, iteratee) {
    $7bbd5095d4c1197b$var$toArray(values).forEach(iteratee);
}
function $7bbd5095d4c1197b$var$includes(array, value) {
    return array.indexOf(value) > -1;
}
function $7bbd5095d4c1197b$var$push(array, items) {
    array.push.apply(array, $7bbd5095d4c1197b$var$toArray(items));
    return array;
}
function $7bbd5095d4c1197b$var$toggleClass(elm, classes, add) {
    if (elm) $7bbd5095d4c1197b$var$forEach(classes, function(name) {
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
function $7bbd5095d4c1197b$var$addClass(elm, classes) {
    $7bbd5095d4c1197b$var$toggleClass(elm, $7bbd5095d4c1197b$var$isString(classes) ? classes.split(" ") : classes, true);
}
function $7bbd5095d4c1197b$var$append(parent, children) {
    $7bbd5095d4c1197b$var$forEach(children, parent.appendChild.bind(parent));
}
function $7bbd5095d4c1197b$var$before(nodes, ref) {
    $7bbd5095d4c1197b$var$forEach(nodes, function(node) {
        var parent = (ref || node).parentNode;
        if (parent) parent.insertBefore(node, ref);
    });
}
function $7bbd5095d4c1197b$var$matches(elm, selector) {
    return $7bbd5095d4c1197b$var$isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function $7bbd5095d4c1197b$var$children(parent, selector) {
    var children2 = parent ? $7bbd5095d4c1197b$var$slice(parent.children) : [];
    return selector ? children2.filter(function(child) {
        return $7bbd5095d4c1197b$var$matches(child, selector);
    }) : children2;
}
function $7bbd5095d4c1197b$var$child(parent, selector) {
    return selector ? $7bbd5095d4c1197b$var$children(parent, selector)[0] : parent.firstElementChild;
}
var $7bbd5095d4c1197b$var$ownKeys = Object.keys;
function $7bbd5095d4c1197b$var$forOwn(object, iteratee, right) {
    if (object) (right ? $7bbd5095d4c1197b$var$ownKeys(object).reverse() : $7bbd5095d4c1197b$var$ownKeys(object)).forEach(function(key) {
        key !== "__proto__" && iteratee(object[key], key);
    });
    return object;
}
function $7bbd5095d4c1197b$var$assign(object) {
    $7bbd5095d4c1197b$var$slice(arguments, 1).forEach(function(source) {
        $7bbd5095d4c1197b$var$forOwn(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
function $7bbd5095d4c1197b$var$merge(object) {
    $7bbd5095d4c1197b$var$slice(arguments, 1).forEach(function(source) {
        $7bbd5095d4c1197b$var$forOwn(source, function(value, key) {
            if ($7bbd5095d4c1197b$var$isArray(value)) object[key] = value.slice();
            else if ($7bbd5095d4c1197b$var$isObject(value)) object[key] = $7bbd5095d4c1197b$var$merge({}, $7bbd5095d4c1197b$var$isObject(object[key]) ? object[key] : {}, value);
            else object[key] = value;
        });
    });
    return object;
}
function $7bbd5095d4c1197b$var$omit(object, keys) {
    $7bbd5095d4c1197b$var$forEach(keys || $7bbd5095d4c1197b$var$ownKeys(object), function(key) {
        delete object[key];
    });
}
function $7bbd5095d4c1197b$var$removeAttribute(elms, attrs) {
    $7bbd5095d4c1197b$var$forEach(elms, function(elm) {
        $7bbd5095d4c1197b$var$forEach(attrs, function(attr) {
            elm && elm.removeAttribute(attr);
        });
    });
}
function $7bbd5095d4c1197b$var$setAttribute(elms, attrs, value) {
    if ($7bbd5095d4c1197b$var$isObject(attrs)) $7bbd5095d4c1197b$var$forOwn(attrs, function(value2, name) {
        $7bbd5095d4c1197b$var$setAttribute(elms, name, value2);
    });
    else $7bbd5095d4c1197b$var$forEach(elms, function(elm) {
        $7bbd5095d4c1197b$var$isNull(value) || value === "" ? $7bbd5095d4c1197b$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
function $7bbd5095d4c1197b$var$create(tag, attrs, parent) {
    var elm = document.createElement(tag);
    if (attrs) $7bbd5095d4c1197b$var$isString(attrs) ? $7bbd5095d4c1197b$var$addClass(elm, attrs) : $7bbd5095d4c1197b$var$setAttribute(elm, attrs);
    parent && $7bbd5095d4c1197b$var$append(parent, elm);
    return elm;
}
function $7bbd5095d4c1197b$var$style(elm, prop, value) {
    if ($7bbd5095d4c1197b$var$isUndefined(value)) return getComputedStyle(elm)[prop];
    if (!$7bbd5095d4c1197b$var$isNull(value)) elm.style[prop] = "" + value;
}
function $7bbd5095d4c1197b$var$display(elm, display2) {
    $7bbd5095d4c1197b$var$style(elm, "display", display2);
}
function $7bbd5095d4c1197b$var$focus(elm) {
    elm["setActive"] && elm["setActive"]() || elm.focus({
        preventScroll: true
    });
}
function $7bbd5095d4c1197b$var$getAttribute(elm, attr) {
    return elm.getAttribute(attr);
}
function $7bbd5095d4c1197b$var$hasClass(elm, className) {
    return elm && elm.classList.contains(className);
}
function $7bbd5095d4c1197b$var$rect(target) {
    return target.getBoundingClientRect();
}
function $7bbd5095d4c1197b$var$remove(nodes) {
    $7bbd5095d4c1197b$var$forEach(nodes, function(node) {
        if (node && node.parentNode) node.parentNode.removeChild(node);
    });
}
function $7bbd5095d4c1197b$var$parseHtml(html) {
    return $7bbd5095d4c1197b$var$child(new DOMParser().parseFromString(html, "text/html").body);
}
function $7bbd5095d4c1197b$var$prevent(e, stopPropagation) {
    e.preventDefault();
    if (stopPropagation) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
}
function $7bbd5095d4c1197b$var$query(parent, selector) {
    return parent && parent.querySelector(selector);
}
function $7bbd5095d4c1197b$var$queryAll(parent, selector) {
    return selector ? $7bbd5095d4c1197b$var$slice(parent.querySelectorAll(selector)) : [];
}
function $7bbd5095d4c1197b$var$removeClass(elm, classes) {
    $7bbd5095d4c1197b$var$toggleClass(elm, classes, false);
}
function $7bbd5095d4c1197b$var$timeOf(e) {
    return e.timeStamp;
}
function $7bbd5095d4c1197b$var$unit(value) {
    return $7bbd5095d4c1197b$var$isString(value) ? value : value ? value + "px" : "";
}
var $7bbd5095d4c1197b$var$PROJECT_CODE = "splide";
var $7bbd5095d4c1197b$var$DATA_ATTRIBUTE = "data-" + $7bbd5095d4c1197b$var$PROJECT_CODE;
function $7bbd5095d4c1197b$var$assert(condition, message) {
    if (!condition) throw new Error("[" + $7bbd5095d4c1197b$var$PROJECT_CODE + "] " + (message || ""));
}
var $7bbd5095d4c1197b$var$min = Math.min, $7bbd5095d4c1197b$var$max = Math.max, $7bbd5095d4c1197b$var$floor = Math.floor, $7bbd5095d4c1197b$var$ceil = Math.ceil, $7bbd5095d4c1197b$var$abs = Math.abs;
function $7bbd5095d4c1197b$var$approximatelyEqual(x, y, epsilon) {
    return $7bbd5095d4c1197b$var$abs(x - y) < epsilon;
}
function $7bbd5095d4c1197b$var$between(number, x, y, exclusive) {
    var minimum = $7bbd5095d4c1197b$var$min(x, y);
    var maximum = $7bbd5095d4c1197b$var$max(x, y);
    return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function $7bbd5095d4c1197b$var$clamp(number, x, y) {
    var minimum = $7bbd5095d4c1197b$var$min(x, y);
    var maximum = $7bbd5095d4c1197b$var$max(x, y);
    return $7bbd5095d4c1197b$var$min($7bbd5095d4c1197b$var$max(minimum, number), maximum);
}
function $7bbd5095d4c1197b$var$sign(x) {
    return +(x > 0) - +(x < 0);
}
function $7bbd5095d4c1197b$var$camelToKebab(string) {
    return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
function $7bbd5095d4c1197b$var$format(string, replacements) {
    $7bbd5095d4c1197b$var$forEach(replacements, function(replacement) {
        string = string.replace("%s", "" + replacement);
    });
    return string;
}
function $7bbd5095d4c1197b$var$pad(number) {
    return number < 10 ? "0" + number : "" + number;
}
var $7bbd5095d4c1197b$var$ids = {};
function $7bbd5095d4c1197b$var$uniqueId(prefix) {
    return "" + prefix + $7bbd5095d4c1197b$var$pad($7bbd5095d4c1197b$var$ids[prefix] = ($7bbd5095d4c1197b$var$ids[prefix] || 0) + 1);
}
function $7bbd5095d4c1197b$export$c473e36ef1bda729() {
    var bind = function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    };
    var unbind = function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    };
    var dispatch = function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    };
    var forEachEvent = function forEachEvent(targets, events, iteratee) {
        $7bbd5095d4c1197b$var$forEach(targets, function(target) {
            target && $7bbd5095d4c1197b$var$forEach(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    };
    var destroy = function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $7bbd5095d4c1197b$var$empty(listeners);
    };
    var listeners = [];
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $7bbd5095d4c1197b$export$d300dc1a2634364b = "mounted";
var $7bbd5095d4c1197b$export$d8dac49b4532735a = "ready";
var $7bbd5095d4c1197b$export$2aa493d7c3275167 = "move";
var $7bbd5095d4c1197b$export$fe5802204b967f0d = "moved";
var $7bbd5095d4c1197b$export$5adb665701eda1ce = "click";
var $7bbd5095d4c1197b$export$92e3eae133acac4c = "active";
var $7bbd5095d4c1197b$export$6bcbb81035c12cea = "inactive";
var $7bbd5095d4c1197b$export$6a5b3445e4066a53 = "visible";
var $7bbd5095d4c1197b$export$8c5c7a21d54563e9 = "hidden";
var $7bbd5095d4c1197b$export$7f4701ac5e05e39f = "refresh";
var $7bbd5095d4c1197b$export$db40ab7c0855fa5c = "updated";
var $7bbd5095d4c1197b$export$7e019dae5103a285 = "resize";
var $7bbd5095d4c1197b$export$d637eba1e9e28482 = "resized";
var $7bbd5095d4c1197b$export$e84bf5065c9087ac = "drag";
var $7bbd5095d4c1197b$export$8e9f636d2c722196 = "dragging";
var $7bbd5095d4c1197b$export$90ea576bd3fdeb60 = "dragged";
var $7bbd5095d4c1197b$export$49801896908b5e33 = "scroll";
var $7bbd5095d4c1197b$export$ff8164bff3202b9 = "scrolled";
var $7bbd5095d4c1197b$export$6cbac5b662a31e1b = "overflow";
var $7bbd5095d4c1197b$export$88c4cf7419e470cd = "destroy";
var $7bbd5095d4c1197b$export$8647f6b043e04e9d = "arrows:mounted";
var $7bbd5095d4c1197b$export$d467f9343b961f75 = "arrows:updated";
var $7bbd5095d4c1197b$export$bf89a4e4349c9778 = "pagination:mounted";
var $7bbd5095d4c1197b$export$eb2019082ed6de0b = "pagination:updated";
var $7bbd5095d4c1197b$export$84015c33508f94ec = "navigation:mounted";
var $7bbd5095d4c1197b$export$23663268a31b79e2 = "autoplay:play";
var $7bbd5095d4c1197b$export$185723258309b608 = "autoplay:playing";
var $7bbd5095d4c1197b$export$16a1e4f3d0368265 = "autoplay:pause";
var $7bbd5095d4c1197b$export$9f64346e17f0ec8e = "lazyload:loaded";
var $7bbd5095d4c1197b$export$6d5af59619d10e6a = "sk";
var $7bbd5095d4c1197b$export$f0af896383d5adff = "sh";
var $7bbd5095d4c1197b$export$28dea85f216954dc = "ei";
function $7bbd5095d4c1197b$export$f188226459c8a3ff(Splide2) {
    var on = function on(events, callback) {
        binder.bind(bus, $7bbd5095d4c1197b$var$toArray(events).join(" "), function(e) {
            callback.apply(callback, $7bbd5095d4c1197b$var$isArray(e.detail) ? e.detail : []);
        });
    };
    var emit = function emit(event) {
        binder.dispatch(bus, event, $7bbd5095d4c1197b$var$slice(arguments, 1));
    };
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $7bbd5095d4c1197b$export$c473e36ef1bda729();
    if (Splide2) Splide2.event.on($7bbd5095d4c1197b$export$88c4cf7419e470cd, binder.destroy);
    return $7bbd5095d4c1197b$var$assign(binder, {
        bus: bus,
        on: on,
        off: $7bbd5095d4c1197b$var$apply(binder.unbind, bus),
        emit: emit
    });
}
function $7bbd5095d4c1197b$export$46ad21b25b6dccf0(interval, onInterval, onUpdate, limit) {
    var start = function start(resume) {
        resume || cancel();
        startTime = now() - (resume ? rate * interval : 0);
        paused = false;
        id = $7bbd5095d4c1197b$var$raf(update);
    };
    var pause = function pause() {
        paused = true;
    };
    var rewind = function rewind() {
        startTime = now();
        rate = 0;
        if (onUpdate) onUpdate(rate);
    };
    var cancel = function cancel() {
        id && cancelAnimationFrame(id);
        rate = 0;
        id = 0;
        paused = true;
    };
    var set = function set(time) {
        interval = time;
    };
    var isPaused = function isPaused() {
        return paused;
    };
    var now = Date.now;
    var startTime;
    var rate = 0;
    var id;
    var paused = true;
    var count = 0;
    function update() {
        if (!paused) {
            rate = interval ? $7bbd5095d4c1197b$var$min((now() - startTime) / interval, 1) : 1;
            onUpdate && onUpdate(rate);
            if (rate >= 1) {
                onInterval();
                startTime = now();
                if (limit && ++count >= limit) return pause();
            }
            id = $7bbd5095d4c1197b$var$raf(update);
        }
    }
    return {
        start: start,
        rewind: rewind,
        pause: pause,
        cancel: cancel,
        set: set,
        isPaused: isPaused
    };
}
function $7bbd5095d4c1197b$export$7254cc27399e90bd(initialState) {
    var set = function set(value) {
        state = value;
    };
    var is = function is(states) {
        return $7bbd5095d4c1197b$var$includes($7bbd5095d4c1197b$var$toArray(states), state);
    };
    var state = initialState;
    return {
        set: set,
        is: is
    };
}
function $7bbd5095d4c1197b$export$efff0f5979573c99(func, duration) {
    var interval = $7bbd5095d4c1197b$export$46ad21b25b6dccf0(duration || 0, func, null, 1);
    return function() {
        interval.isPaused() && interval.start();
    };
}
function $7bbd5095d4c1197b$var$Media(Splide2, Components2, options) {
    var setup = function setup() {
        var isMin = options.mediaQuery === "min";
        $7bbd5095d4c1197b$var$ownKeys(breakpoints).sort(function(n, m) {
            return isMin ? +n - +m : +m - +n;
        }).forEach(function(key) {
            register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
        });
        register(reducedMotion, $7bbd5095d4c1197b$var$MEDIA_PREFERS_REDUCED_MOTION);
        update();
    };
    var destroy = function destroy(completely) {
        if (completely) binder.destroy();
    };
    var register = function register(options2, query) {
        var queryList = matchMedia(query);
        binder.bind(queryList, "change", update);
        queries.push([
            options2,
            queryList
        ]);
    };
    var update = function update() {
        var destroyed = state.is($7bbd5095d4c1197b$var$DESTROYED);
        var direction = options.direction;
        var merged = queries.reduce(function(merged2, entry) {
            return $7bbd5095d4c1197b$var$merge(merged2, entry[1].matches ? entry[0] : {});
        }, {});
        $7bbd5095d4c1197b$var$omit(options);
        set(merged);
        if (options.destroy) Splide2.destroy(options.destroy === "completely");
        else if (destroyed) {
            destroy(true);
            Splide2.mount();
        } else direction !== options.direction && Splide2.refresh();
    };
    var reduce = function reduce(enable) {
        if (matchMedia($7bbd5095d4c1197b$var$MEDIA_PREFERS_REDUCED_MOTION).matches) enable ? $7bbd5095d4c1197b$var$merge(options, reducedMotion) : $7bbd5095d4c1197b$var$omit(options, $7bbd5095d4c1197b$var$ownKeys(reducedMotion));
    };
    var set = function set(opts, base, notify) {
        $7bbd5095d4c1197b$var$merge(options, opts);
        base && $7bbd5095d4c1197b$var$merge(Object.getPrototypeOf(options), opts);
        if (notify || !state.is($7bbd5095d4c1197b$var$CREATED)) Splide2.emit($7bbd5095d4c1197b$export$db40ab7c0855fa5c, options);
    };
    var state = Splide2.state;
    var breakpoints = options.breakpoints || {};
    var reducedMotion = options.reducedMotion || {};
    var binder = $7bbd5095d4c1197b$export$c473e36ef1bda729();
    var queries = [];
    return {
        setup: setup,
        destroy: destroy,
        reduce: reduce,
        set: set
    };
}
var $7bbd5095d4c1197b$var$ARROW = "Arrow";
var $7bbd5095d4c1197b$var$ARROW_LEFT = $7bbd5095d4c1197b$var$ARROW + "Left";
var $7bbd5095d4c1197b$var$ARROW_RIGHT = $7bbd5095d4c1197b$var$ARROW + "Right";
var $7bbd5095d4c1197b$var$ARROW_UP = $7bbd5095d4c1197b$var$ARROW + "Up";
var $7bbd5095d4c1197b$var$ARROW_DOWN = $7bbd5095d4c1197b$var$ARROW + "Down";
var $7bbd5095d4c1197b$export$373e92e0788ff06e = "ltr";
var $7bbd5095d4c1197b$export$850f7749a2909601 = "rtl";
var $7bbd5095d4c1197b$export$97170d9824b89709 = "ttb";
var $7bbd5095d4c1197b$var$ORIENTATION_MAP = {
    width: [
        "height"
    ],
    left: [
        "top",
        "right"
    ],
    right: [
        "bottom",
        "left"
    ],
    x: [
        "y"
    ],
    X: [
        "Y"
    ],
    Y: [
        "X"
    ],
    ArrowLeft: [
        $7bbd5095d4c1197b$var$ARROW_UP,
        $7bbd5095d4c1197b$var$ARROW_RIGHT
    ],
    ArrowRight: [
        $7bbd5095d4c1197b$var$ARROW_DOWN,
        $7bbd5095d4c1197b$var$ARROW_LEFT
    ]
};
function $7bbd5095d4c1197b$var$Direction(Splide2, Components2, options) {
    var resolve = function resolve(prop, axisOnly, direction) {
        direction = direction || options.direction;
        var index = direction === $7bbd5095d4c1197b$export$850f7749a2909601 && !axisOnly ? 1 : direction === $7bbd5095d4c1197b$export$97170d9824b89709 ? 0 : -1;
        return $7bbd5095d4c1197b$var$ORIENTATION_MAP[prop] && $7bbd5095d4c1197b$var$ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
            var replacement = $7bbd5095d4c1197b$var$ORIENTATION_MAP[match.toLowerCase()][index] || match;
            return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
        });
    };
    var orient = function orient(value) {
        return value * (options.direction === $7bbd5095d4c1197b$export$850f7749a2909601 ? 1 : -1);
    };
    return {
        resolve: resolve,
        orient: orient
    };
}
var $7bbd5095d4c1197b$var$ROLE = "role";
var $7bbd5095d4c1197b$var$TAB_INDEX = "tabindex";
var $7bbd5095d4c1197b$var$DISABLED = "disabled";
var $7bbd5095d4c1197b$var$ARIA_PREFIX = "aria-";
var $7bbd5095d4c1197b$var$ARIA_CONTROLS = $7bbd5095d4c1197b$var$ARIA_PREFIX + "controls";
var $7bbd5095d4c1197b$var$ARIA_CURRENT = $7bbd5095d4c1197b$var$ARIA_PREFIX + "current";
var $7bbd5095d4c1197b$var$ARIA_SELECTED = $7bbd5095d4c1197b$var$ARIA_PREFIX + "selected";
var $7bbd5095d4c1197b$var$ARIA_LABEL = $7bbd5095d4c1197b$var$ARIA_PREFIX + "label";
var $7bbd5095d4c1197b$var$ARIA_LABELLEDBY = $7bbd5095d4c1197b$var$ARIA_PREFIX + "labelledby";
var $7bbd5095d4c1197b$var$ARIA_HIDDEN = $7bbd5095d4c1197b$var$ARIA_PREFIX + "hidden";
var $7bbd5095d4c1197b$var$ARIA_ORIENTATION = $7bbd5095d4c1197b$var$ARIA_PREFIX + "orientation";
var $7bbd5095d4c1197b$var$ARIA_ROLEDESCRIPTION = $7bbd5095d4c1197b$var$ARIA_PREFIX + "roledescription";
var $7bbd5095d4c1197b$var$ARIA_LIVE = $7bbd5095d4c1197b$var$ARIA_PREFIX + "live";
var $7bbd5095d4c1197b$var$ARIA_BUSY = $7bbd5095d4c1197b$var$ARIA_PREFIX + "busy";
var $7bbd5095d4c1197b$var$ARIA_ATOMIC = $7bbd5095d4c1197b$var$ARIA_PREFIX + "atomic";
var $7bbd5095d4c1197b$var$ALL_ATTRIBUTES = [
    $7bbd5095d4c1197b$var$ROLE,
    $7bbd5095d4c1197b$var$TAB_INDEX,
    $7bbd5095d4c1197b$var$DISABLED,
    $7bbd5095d4c1197b$var$ARIA_CONTROLS,
    $7bbd5095d4c1197b$var$ARIA_CURRENT,
    $7bbd5095d4c1197b$var$ARIA_LABEL,
    $7bbd5095d4c1197b$var$ARIA_LABELLEDBY,
    $7bbd5095d4c1197b$var$ARIA_HIDDEN,
    $7bbd5095d4c1197b$var$ARIA_ORIENTATION,
    $7bbd5095d4c1197b$var$ARIA_ROLEDESCRIPTION
];
var $7bbd5095d4c1197b$var$CLASS_PREFIX = $7bbd5095d4c1197b$var$PROJECT_CODE + "__";
var $7bbd5095d4c1197b$var$STATUS_CLASS_PREFIX = "is-";
var $7bbd5095d4c1197b$export$93b21159ad85c843 = $7bbd5095d4c1197b$var$PROJECT_CODE;
var $7bbd5095d4c1197b$export$7738b09ac0a98952 = $7bbd5095d4c1197b$var$CLASS_PREFIX + "track";
var $7bbd5095d4c1197b$export$19cc2a5451235cae = $7bbd5095d4c1197b$var$CLASS_PREFIX + "list";
var $7bbd5095d4c1197b$export$8d922915837a38d3 = $7bbd5095d4c1197b$var$CLASS_PREFIX + "slide";
var $7bbd5095d4c1197b$export$2c1ba4a4f1aa4947 = $7bbd5095d4c1197b$export$8d922915837a38d3 + "--clone";
var $7bbd5095d4c1197b$export$e9ba7e444ba60a12 = $7bbd5095d4c1197b$export$8d922915837a38d3 + "__container";
var $7bbd5095d4c1197b$export$a26cbd955fecf11e = $7bbd5095d4c1197b$var$CLASS_PREFIX + "arrows";
var $7bbd5095d4c1197b$export$516e7d18e13a2dca = $7bbd5095d4c1197b$var$CLASS_PREFIX + "arrow";
var $7bbd5095d4c1197b$export$58ea3db24c33b76 = $7bbd5095d4c1197b$export$516e7d18e13a2dca + "--prev";
var $7bbd5095d4c1197b$export$4885afd7098a65c2 = $7bbd5095d4c1197b$export$516e7d18e13a2dca + "--next";
var $7bbd5095d4c1197b$export$cbf8e5a0ab95eda3 = $7bbd5095d4c1197b$var$CLASS_PREFIX + "pagination";
var $7bbd5095d4c1197b$export$52f2cca6a5eee805 = $7bbd5095d4c1197b$export$cbf8e5a0ab95eda3 + "__page";
var $7bbd5095d4c1197b$export$4c82dc32b1c4ace5 = $7bbd5095d4c1197b$var$CLASS_PREFIX + "progress";
var $7bbd5095d4c1197b$export$2c9b091c749f4409 = $7bbd5095d4c1197b$export$4c82dc32b1c4ace5 + "__bar";
var $7bbd5095d4c1197b$export$a29701deef84b825 = $7bbd5095d4c1197b$var$CLASS_PREFIX + "toggle";
var $7bbd5095d4c1197b$export$d9d247d51b430dbb = $7bbd5095d4c1197b$export$a29701deef84b825 + "__play";
var $7bbd5095d4c1197b$export$3529f201a419925b = $7bbd5095d4c1197b$export$a29701deef84b825 + "__pause";
var $7bbd5095d4c1197b$export$3e5381ee3fab8374 = $7bbd5095d4c1197b$var$CLASS_PREFIX + "spinner";
var $7bbd5095d4c1197b$export$bb78d7c200da8960 = $7bbd5095d4c1197b$var$CLASS_PREFIX + "sr";
var $7bbd5095d4c1197b$export$7761661e2d5b9388 = $7bbd5095d4c1197b$var$STATUS_CLASS_PREFIX + "initialized";
var $7bbd5095d4c1197b$export$72d36ecf3758cb4b = $7bbd5095d4c1197b$var$STATUS_CLASS_PREFIX + "active";
var $7bbd5095d4c1197b$export$e423ac4972f5e196 = $7bbd5095d4c1197b$var$STATUS_CLASS_PREFIX + "prev";
var $7bbd5095d4c1197b$export$457a2d20827a2779 = $7bbd5095d4c1197b$var$STATUS_CLASS_PREFIX + "next";
var $7bbd5095d4c1197b$export$53ca4621bbab9a = $7bbd5095d4c1197b$var$STATUS_CLASS_PREFIX + "visible";
var $7bbd5095d4c1197b$export$d22ec4ccb7996ba2 = $7bbd5095d4c1197b$var$STATUS_CLASS_PREFIX + "loading";
var $7bbd5095d4c1197b$export$b6f202a162a09100 = $7bbd5095d4c1197b$var$STATUS_CLASS_PREFIX + "focus-in";
var $7bbd5095d4c1197b$export$cd908cd1dd625e29 = $7bbd5095d4c1197b$var$STATUS_CLASS_PREFIX + "overflow";
var $7bbd5095d4c1197b$export$49f9eaea10ebf193 = [
    $7bbd5095d4c1197b$export$72d36ecf3758cb4b,
    $7bbd5095d4c1197b$export$53ca4621bbab9a,
    $7bbd5095d4c1197b$export$e423ac4972f5e196,
    $7bbd5095d4c1197b$export$457a2d20827a2779,
    $7bbd5095d4c1197b$export$d22ec4ccb7996ba2,
    $7bbd5095d4c1197b$export$b6f202a162a09100,
    $7bbd5095d4c1197b$export$cd908cd1dd625e29
];
var $7bbd5095d4c1197b$export$ba41d43e4a419565 = {
    slide: $7bbd5095d4c1197b$export$8d922915837a38d3,
    clone: $7bbd5095d4c1197b$export$2c1ba4a4f1aa4947,
    arrows: $7bbd5095d4c1197b$export$a26cbd955fecf11e,
    arrow: $7bbd5095d4c1197b$export$516e7d18e13a2dca,
    prev: $7bbd5095d4c1197b$export$58ea3db24c33b76,
    next: $7bbd5095d4c1197b$export$4885afd7098a65c2,
    pagination: $7bbd5095d4c1197b$export$cbf8e5a0ab95eda3,
    page: $7bbd5095d4c1197b$export$52f2cca6a5eee805,
    spinner: $7bbd5095d4c1197b$export$3e5381ee3fab8374
};
function $7bbd5095d4c1197b$var$closest(from, selector) {
    if ($7bbd5095d4c1197b$var$isFunction(from.closest)) return from.closest(selector);
    var elm = from;
    while(elm && elm.nodeType === 1){
        if ($7bbd5095d4c1197b$var$matches(elm, selector)) break;
        elm = elm.parentElement;
    }
    return elm;
}
var $7bbd5095d4c1197b$var$FRICTION = 5;
var $7bbd5095d4c1197b$var$LOG_INTERVAL = 200;
var $7bbd5095d4c1197b$var$POINTER_DOWN_EVENTS = "touchstart mousedown";
var $7bbd5095d4c1197b$var$POINTER_MOVE_EVENTS = "touchmove mousemove";
var $7bbd5095d4c1197b$var$POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function $7bbd5095d4c1197b$var$Elements(Splide2, Components2, options) {
    var setup = function setup() {
        collect();
        init();
        update();
    };
    var mount = function mount() {
        on($7bbd5095d4c1197b$export$7f4701ac5e05e39f, destroy);
        on($7bbd5095d4c1197b$export$7f4701ac5e05e39f, setup);
        on($7bbd5095d4c1197b$export$db40ab7c0855fa5c, update);
        bind(document, $7bbd5095d4c1197b$var$POINTER_DOWN_EVENTS + " keydown", function(e) {
            isUsingKey = e.type === "keydown";
        }, {
            capture: true
        });
        bind(root, "focusin", function() {
            $7bbd5095d4c1197b$var$toggleClass(root, $7bbd5095d4c1197b$export$b6f202a162a09100, !!isUsingKey);
        });
    };
    var destroy = function destroy(completely) {
        var attrs = $7bbd5095d4c1197b$var$ALL_ATTRIBUTES.concat("style");
        $7bbd5095d4c1197b$var$empty(slides);
        $7bbd5095d4c1197b$var$removeClass(root, rootClasses);
        $7bbd5095d4c1197b$var$removeClass(track, trackClasses);
        $7bbd5095d4c1197b$var$removeAttribute([
            track,
            list
        ], attrs);
        $7bbd5095d4c1197b$var$removeAttribute(root, completely ? attrs : [
            "style",
            $7bbd5095d4c1197b$var$ARIA_ROLEDESCRIPTION
        ]);
    };
    var update = function update() {
        $7bbd5095d4c1197b$var$removeClass(root, rootClasses);
        $7bbd5095d4c1197b$var$removeClass(track, trackClasses);
        rootClasses = getClasses($7bbd5095d4c1197b$export$93b21159ad85c843);
        trackClasses = getClasses($7bbd5095d4c1197b$export$7738b09ac0a98952);
        $7bbd5095d4c1197b$var$addClass(root, rootClasses);
        $7bbd5095d4c1197b$var$addClass(track, trackClasses);
        $7bbd5095d4c1197b$var$setAttribute(root, $7bbd5095d4c1197b$var$ARIA_LABEL, options.label);
        $7bbd5095d4c1197b$var$setAttribute(root, $7bbd5095d4c1197b$var$ARIA_LABELLEDBY, options.labelledby);
    };
    var collect = function collect() {
        track = find("." + $7bbd5095d4c1197b$export$7738b09ac0a98952);
        list = $7bbd5095d4c1197b$var$child(track, "." + $7bbd5095d4c1197b$export$19cc2a5451235cae);
        $7bbd5095d4c1197b$var$assert(track && list, "A track/list element is missing.");
        $7bbd5095d4c1197b$var$push(slides, $7bbd5095d4c1197b$var$children(list, "." + $7bbd5095d4c1197b$export$8d922915837a38d3 + ":not(." + $7bbd5095d4c1197b$export$2c1ba4a4f1aa4947 + ")"));
        $7bbd5095d4c1197b$var$forOwn({
            arrows: $7bbd5095d4c1197b$export$a26cbd955fecf11e,
            pagination: $7bbd5095d4c1197b$export$cbf8e5a0ab95eda3,
            prev: $7bbd5095d4c1197b$export$58ea3db24c33b76,
            next: $7bbd5095d4c1197b$export$4885afd7098a65c2,
            bar: $7bbd5095d4c1197b$export$2c9b091c749f4409,
            toggle: $7bbd5095d4c1197b$export$a29701deef84b825
        }, function(className, key) {
            elements[key] = find("." + className);
        });
        $7bbd5095d4c1197b$var$assign(elements, {
            root: root,
            track: track,
            list: list,
            slides: slides
        });
    };
    var init = function init() {
        var id = root.id || $7bbd5095d4c1197b$var$uniqueId($7bbd5095d4c1197b$var$PROJECT_CODE);
        var role = options.role;
        root.id = id;
        track.id = track.id || id + "-track";
        list.id = list.id || id + "-list";
        if (!$7bbd5095d4c1197b$var$getAttribute(root, $7bbd5095d4c1197b$var$ROLE) && root.tagName !== "SECTION" && role) $7bbd5095d4c1197b$var$setAttribute(root, $7bbd5095d4c1197b$var$ROLE, role);
        $7bbd5095d4c1197b$var$setAttribute(root, $7bbd5095d4c1197b$var$ARIA_ROLEDESCRIPTION, i18n.carousel);
        $7bbd5095d4c1197b$var$setAttribute(list, $7bbd5095d4c1197b$var$ROLE, "presentation");
    };
    var find = function find(selector) {
        var elm = $7bbd5095d4c1197b$var$query(root, selector);
        return elm && $7bbd5095d4c1197b$var$closest(elm, "." + $7bbd5095d4c1197b$export$93b21159ad85c843) === root ? elm : void 0;
    };
    var getClasses = function getClasses(base) {
        return [
            base + "--" + options.type,
            base + "--" + options.direction,
            options.drag && base + "--draggable",
            options.isNavigation && base + "--nav",
            base === $7bbd5095d4c1197b$export$93b21159ad85c843 && $7bbd5095d4c1197b$export$72d36ecf3758cb4b
        ];
    };
    var _EventInterface = $7bbd5095d4c1197b$export$f188226459c8a3ff(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
    var root = Splide2.root;
    var i18n = options.i18n;
    var elements = {};
    var slides = [];
    var rootClasses = [];
    var trackClasses = [];
    var track;
    var list;
    var isUsingKey;
    return $7bbd5095d4c1197b$var$assign(elements, {
        setup: setup,
        mount: mount,
        destroy: destroy
    });
}
var $7bbd5095d4c1197b$export$e5a58a5ee5b54c22 = "slide";
var $7bbd5095d4c1197b$export$f42383286ed1223d = "loop";
var $7bbd5095d4c1197b$export$742b62a5690c060 = "fade";
function $7bbd5095d4c1197b$var$Slide$1(Splide2, index, slideIndex, slide) {
    var mount = function mount() {
        if (!isClone) {
            slide.id = root.id + "-slide" + $7bbd5095d4c1197b$var$pad(index + 1);
            $7bbd5095d4c1197b$var$setAttribute(slide, $7bbd5095d4c1197b$var$ROLE, pagination ? "tabpanel" : "group");
            $7bbd5095d4c1197b$var$setAttribute(slide, $7bbd5095d4c1197b$var$ARIA_ROLEDESCRIPTION, i18n.slide);
            $7bbd5095d4c1197b$var$setAttribute(slide, $7bbd5095d4c1197b$var$ARIA_LABEL, label || $7bbd5095d4c1197b$var$format(i18n.slideLabel, [
                index + 1,
                Splide2.length
            ]));
        }
        listen();
    };
    var listen = function listen() {
        bind(slide, "click", $7bbd5095d4c1197b$var$apply(emit, $7bbd5095d4c1197b$export$5adb665701eda1ce, self));
        bind(slide, "keydown", $7bbd5095d4c1197b$var$apply(emit, $7bbd5095d4c1197b$export$6d5af59619d10e6a, self));
        on([
            $7bbd5095d4c1197b$export$fe5802204b967f0d,
            $7bbd5095d4c1197b$export$f0af896383d5adff,
            $7bbd5095d4c1197b$export$ff8164bff3202b9
        ], update);
        on($7bbd5095d4c1197b$export$84015c33508f94ec, initNavigation);
        if (updateOnMove) on($7bbd5095d4c1197b$export$2aa493d7c3275167, onMove);
    };
    var destroy = function destroy() {
        destroyed = true;
        event.destroy();
        $7bbd5095d4c1197b$var$removeClass(slide, $7bbd5095d4c1197b$export$49f9eaea10ebf193);
        $7bbd5095d4c1197b$var$removeAttribute(slide, $7bbd5095d4c1197b$var$ALL_ATTRIBUTES);
        $7bbd5095d4c1197b$var$setAttribute(slide, "style", styles);
        $7bbd5095d4c1197b$var$setAttribute(slide, $7bbd5095d4c1197b$var$ARIA_LABEL, label || "");
    };
    var initNavigation = function initNavigation() {
        var controls = Splide2.splides.map(function(target) {
            var Slide2 = target.splide.Components.Slides.getAt(index);
            return Slide2 ? Slide2.slide.id : "";
        }).join(" ");
        $7bbd5095d4c1197b$var$setAttribute(slide, $7bbd5095d4c1197b$var$ARIA_LABEL, $7bbd5095d4c1197b$var$format(i18n.slideX, (isClone ? slideIndex : index) + 1));
        $7bbd5095d4c1197b$var$setAttribute(slide, $7bbd5095d4c1197b$var$ARIA_CONTROLS, controls);
        $7bbd5095d4c1197b$var$setAttribute(slide, $7bbd5095d4c1197b$var$ROLE, slideFocus ? "button" : "");
        slideFocus && $7bbd5095d4c1197b$var$removeAttribute(slide, $7bbd5095d4c1197b$var$ARIA_ROLEDESCRIPTION);
    };
    var onMove = function onMove() {
        if (!destroyed) update();
    };
    var update = function update() {
        if (!destroyed) {
            var curr = Splide2.index;
            updateActivity();
            updateVisibility();
            $7bbd5095d4c1197b$var$toggleClass(slide, $7bbd5095d4c1197b$export$e423ac4972f5e196, index === curr - 1);
            $7bbd5095d4c1197b$var$toggleClass(slide, $7bbd5095d4c1197b$export$457a2d20827a2779, index === curr + 1);
        }
    };
    var updateActivity = function updateActivity() {
        var active = isActive();
        if (active !== $7bbd5095d4c1197b$var$hasClass(slide, $7bbd5095d4c1197b$export$72d36ecf3758cb4b)) {
            $7bbd5095d4c1197b$var$toggleClass(slide, $7bbd5095d4c1197b$export$72d36ecf3758cb4b, active);
            $7bbd5095d4c1197b$var$setAttribute(slide, $7bbd5095d4c1197b$var$ARIA_CURRENT, isNavigation && active || "");
            emit(active ? $7bbd5095d4c1197b$export$92e3eae133acac4c : $7bbd5095d4c1197b$export$6bcbb81035c12cea, self);
        }
    };
    var updateVisibility = function updateVisibility() {
        var visible = isVisible();
        var hidden = !visible && (!isActive() || isClone);
        if (!Splide2.state.is([
            $7bbd5095d4c1197b$var$MOVING,
            $7bbd5095d4c1197b$var$SCROLLING
        ])) $7bbd5095d4c1197b$var$setAttribute(slide, $7bbd5095d4c1197b$var$ARIA_HIDDEN, hidden || "");
        $7bbd5095d4c1197b$var$setAttribute($7bbd5095d4c1197b$var$queryAll(slide, options.focusableNodes || ""), $7bbd5095d4c1197b$var$TAB_INDEX, hidden ? -1 : "");
        if (slideFocus) $7bbd5095d4c1197b$var$setAttribute(slide, $7bbd5095d4c1197b$var$TAB_INDEX, hidden ? -1 : 0);
        if (visible !== $7bbd5095d4c1197b$var$hasClass(slide, $7bbd5095d4c1197b$export$53ca4621bbab9a)) {
            $7bbd5095d4c1197b$var$toggleClass(slide, $7bbd5095d4c1197b$export$53ca4621bbab9a, visible);
            emit(visible ? $7bbd5095d4c1197b$export$6a5b3445e4066a53 : $7bbd5095d4c1197b$export$8c5c7a21d54563e9, self);
        }
        if (!visible && document.activeElement === slide) {
            var Slide2 = Components.Slides.getAt(Splide2.index);
            Slide2 && $7bbd5095d4c1197b$var$focus(Slide2.slide);
        }
    };
    var style$1 = function style$1(prop, value, useContainer) {
        $7bbd5095d4c1197b$var$style(useContainer && container || slide, prop, value);
    };
    var isActive = function isActive() {
        var curr = Splide2.index;
        return curr === index || options.cloneStatus && curr === slideIndex;
    };
    var isVisible = function isVisible() {
        if (Splide2.is($7bbd5095d4c1197b$export$742b62a5690c060)) return isActive();
        var trackRect = $7bbd5095d4c1197b$var$rect(Components.Elements.track);
        var slideRect = $7bbd5095d4c1197b$var$rect(slide);
        var left = resolve("left", true);
        var right = resolve("right", true);
        return $7bbd5095d4c1197b$var$floor(trackRect[left]) <= $7bbd5095d4c1197b$var$ceil(slideRect[left]) && $7bbd5095d4c1197b$var$floor(slideRect[right]) <= $7bbd5095d4c1197b$var$ceil(trackRect[right]);
    };
    var isWithin = function isWithin(from, distance) {
        var diff = $7bbd5095d4c1197b$var$abs(from - index);
        if (!isClone && (options.rewind || Splide2.is($7bbd5095d4c1197b$export$f42383286ed1223d))) diff = $7bbd5095d4c1197b$var$min(diff, Splide2.length - diff);
        return diff <= distance;
    };
    var event = $7bbd5095d4c1197b$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
    var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
    var resolve = Components.Direction.resolve;
    var styles = $7bbd5095d4c1197b$var$getAttribute(slide, "style");
    var label = $7bbd5095d4c1197b$var$getAttribute(slide, $7bbd5095d4c1197b$var$ARIA_LABEL);
    var isClone = slideIndex > -1;
    var container = $7bbd5095d4c1197b$var$child(slide, "." + $7bbd5095d4c1197b$export$e9ba7e444ba60a12);
    var destroyed;
    var self = {
        index: index,
        slideIndex: slideIndex,
        slide: slide,
        container: container,
        isClone: isClone,
        mount: mount,
        destroy: destroy,
        update: update,
        style: style$1,
        isWithin: isWithin
    };
    return self;
}
function $7bbd5095d4c1197b$var$Slides(Splide2, Components2, options) {
    var mount = function mount() {
        init();
        on($7bbd5095d4c1197b$export$7f4701ac5e05e39f, destroy);
        on($7bbd5095d4c1197b$export$7f4701ac5e05e39f, init);
    };
    var init = function init() {
        slides.forEach(function(slide, index) {
            register(slide, index, -1);
        });
    };
    var destroy = function destroy() {
        forEach$1(function(Slide2) {
            Slide2.destroy();
        });
        $7bbd5095d4c1197b$var$empty(Slides2);
    };
    var update = function update() {
        forEach$1(function(Slide2) {
            Slide2.update();
        });
    };
    var register = function register(slide, index, slideIndex) {
        var object = $7bbd5095d4c1197b$var$Slide$1(Splide2, index, slideIndex, slide);
        object.mount();
        Slides2.push(object);
        Slides2.sort(function(Slide1, Slide2) {
            return Slide1.index - Slide2.index;
        });
    };
    var get = function get(excludeClones) {
        return excludeClones ? filter(function(Slide2) {
            return !Slide2.isClone;
        }) : Slides2;
    };
    var getIn = function getIn(page) {
        var _$Controller = Components2.Controller;
        var index = _$Controller.toIndex(page);
        var max = _$Controller.hasFocus() ? 1 : options.perPage;
        return filter(function(Slide2) {
            return $7bbd5095d4c1197b$var$between(Slide2.index, index, index + max - 1);
        });
    };
    var getAt = function getAt(index) {
        return filter(index)[0];
    };
    var add = function add(items, index) {
        $7bbd5095d4c1197b$var$forEach(items, function(slide) {
            if ($7bbd5095d4c1197b$var$isString(slide)) slide = $7bbd5095d4c1197b$var$parseHtml(slide);
            if ($7bbd5095d4c1197b$var$isHTMLElement(slide)) {
                var ref = slides[index];
                ref ? $7bbd5095d4c1197b$var$before(slide, ref) : $7bbd5095d4c1197b$var$append(list, slide);
                $7bbd5095d4c1197b$var$addClass(slide, options.classes.slide);
                observeImages(slide, $7bbd5095d4c1197b$var$apply(emit, $7bbd5095d4c1197b$export$7e019dae5103a285));
            }
        });
        emit($7bbd5095d4c1197b$export$7f4701ac5e05e39f);
    };
    var remove$1 = function remove$1(matcher) {
        $7bbd5095d4c1197b$var$remove(filter(matcher).map(function(Slide2) {
            return Slide2.slide;
        }));
        emit($7bbd5095d4c1197b$export$7f4701ac5e05e39f);
    };
    var forEach$1 = function forEach$1(iteratee, excludeClones) {
        get(excludeClones).forEach(iteratee);
    };
    var filter = function filter(matcher) {
        return Slides2.filter($7bbd5095d4c1197b$var$isFunction(matcher) ? matcher : function(Slide2) {
            return $7bbd5095d4c1197b$var$isString(matcher) ? $7bbd5095d4c1197b$var$matches(Slide2.slide, matcher) : $7bbd5095d4c1197b$var$includes($7bbd5095d4c1197b$var$toArray(matcher), Slide2.index);
        });
    };
    var style = function style(prop, value, useContainer) {
        forEach$1(function(Slide2) {
            Slide2.style(prop, value, useContainer);
        });
    };
    var observeImages = function observeImages(elm, callback) {
        var images = $7bbd5095d4c1197b$var$queryAll(elm, "img");
        var length = images.length;
        if (length) images.forEach(function(img) {
            bind(img, "load error", function() {
                if (!--length) callback();
            });
        });
        else callback();
    };
    var getLength = function getLength(excludeClones) {
        return excludeClones ? slides.length : Slides2.length;
    };
    var isEnough = function isEnough() {
        return Slides2.length > options.perPage;
    };
    var _EventInterface2 = $7bbd5095d4c1197b$export$f188226459c8a3ff(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
    var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
    var Slides2 = [];
    return {
        mount: mount,
        destroy: destroy,
        update: update,
        register: register,
        get: get,
        getIn: getIn,
        getAt: getAt,
        add: add,
        remove: remove$1,
        forEach: forEach$1,
        filter: filter,
        style: style,
        getLength: getLength,
        isEnough: isEnough
    };
}
function $7bbd5095d4c1197b$var$Layout(Splide2, Components2, options) {
    var mount = function mount() {
        init();
        bind(window, "resize load", $7bbd5095d4c1197b$export$efff0f5979573c99($7bbd5095d4c1197b$var$apply(emit, $7bbd5095d4c1197b$export$7e019dae5103a285)));
        on([
            $7bbd5095d4c1197b$export$db40ab7c0855fa5c,
            $7bbd5095d4c1197b$export$7f4701ac5e05e39f
        ], init);
        on($7bbd5095d4c1197b$export$7e019dae5103a285, resize);
    };
    var init = function init() {
        vertical = options.direction === $7bbd5095d4c1197b$export$97170d9824b89709;
        $7bbd5095d4c1197b$var$style(root, "maxWidth", $7bbd5095d4c1197b$var$unit(options.width));
        $7bbd5095d4c1197b$var$style(track, resolve("paddingLeft"), cssPadding(false));
        $7bbd5095d4c1197b$var$style(track, resolve("paddingRight"), cssPadding(true));
        resize(true);
    };
    var resize = function resize(force) {
        var newRect = $7bbd5095d4c1197b$var$rect(root);
        if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
            $7bbd5095d4c1197b$var$style(track, "height", cssTrackHeight());
            styleSlides(resolve("marginRight"), $7bbd5095d4c1197b$var$unit(options.gap));
            styleSlides("width", cssSlideWidth());
            styleSlides("height", cssSlideHeight(), true);
            rootRect = newRect;
            emit($7bbd5095d4c1197b$export$d637eba1e9e28482);
            if (overflow !== (overflow = isOverflow())) {
                $7bbd5095d4c1197b$var$toggleClass(root, $7bbd5095d4c1197b$export$cd908cd1dd625e29, overflow);
                emit($7bbd5095d4c1197b$export$6cbac5b662a31e1b, overflow);
            }
        }
    };
    var cssPadding = function cssPadding(right) {
        var padding = options.padding;
        var prop = resolve(right ? "right" : "left");
        return padding && $7bbd5095d4c1197b$var$unit(padding[prop] || ($7bbd5095d4c1197b$var$isObject(padding) ? 0 : padding)) || "0px";
    };
    var cssTrackHeight = function cssTrackHeight() {
        var height = "";
        if (vertical) {
            height = cssHeight();
            $7bbd5095d4c1197b$var$assert(height, "height or heightRatio is missing.");
            height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
        }
        return height;
    };
    var cssHeight = function cssHeight() {
        return $7bbd5095d4c1197b$var$unit(options.height || $7bbd5095d4c1197b$var$rect(list).width * options.heightRatio);
    };
    var cssSlideWidth = function cssSlideWidth() {
        return options.autoWidth ? null : $7bbd5095d4c1197b$var$unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
    };
    var cssSlideHeight = function cssSlideHeight() {
        return $7bbd5095d4c1197b$var$unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
    };
    var cssSlideSize = function cssSlideSize() {
        var gap = $7bbd5095d4c1197b$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    };
    var listSize = function listSize() {
        return $7bbd5095d4c1197b$var$rect(list)[resolve("width")];
    };
    var slideSize = function slideSize(index, withoutGap) {
        var Slide = getAt(index || 0);
        return Slide ? $7bbd5095d4c1197b$var$rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
    };
    var totalSize = function totalSize(index, withoutGap) {
        var Slide = getAt(index);
        if (Slide) {
            var right = $7bbd5095d4c1197b$var$rect(Slide.slide)[resolve("right")];
            var left = $7bbd5095d4c1197b$var$rect(list)[resolve("left")];
            return $7bbd5095d4c1197b$var$abs(right - left) + (withoutGap ? 0 : getGap());
        }
        return 0;
    };
    var sliderSize = function sliderSize(withoutGap) {
        return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
    };
    var getGap = function getGap() {
        var Slide = getAt(0);
        return Slide && parseFloat($7bbd5095d4c1197b$var$style(Slide.slide, resolve("marginRight"))) || 0;
    };
    var getPadding = function getPadding(right) {
        return parseFloat($7bbd5095d4c1197b$var$style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
    };
    var isOverflow = function isOverflow() {
        return Splide2.is($7bbd5095d4c1197b$export$742b62a5690c060) || sliderSize(true) > listSize();
    };
    var _EventInterface3 = $7bbd5095d4c1197b$export$f188226459c8a3ff(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
    var _$Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
    var getAt = _$Slides.getAt, styleSlides = _$Slides.style;
    var vertical;
    var rootRect;
    var overflow;
    return {
        mount: mount,
        resize: resize,
        listSize: listSize,
        slideSize: slideSize,
        sliderSize: sliderSize,
        totalSize: totalSize,
        getPadding: getPadding,
        isOverflow: isOverflow
    };
}
var $7bbd5095d4c1197b$var$MULTIPLIER = 2;
function $7bbd5095d4c1197b$var$Clones(Splide2, Components2, options) {
    var mount = function mount() {
        on($7bbd5095d4c1197b$export$7f4701ac5e05e39f, remount);
        on([
            $7bbd5095d4c1197b$export$db40ab7c0855fa5c,
            $7bbd5095d4c1197b$export$7e019dae5103a285
        ], observe);
        if (cloneCount = computeCloneCount()) {
            generate(cloneCount);
            Components2.Layout.resize(true);
        }
    };
    var remount = function remount() {
        destroy();
        mount();
    };
    var destroy = function destroy() {
        $7bbd5095d4c1197b$var$remove(clones);
        $7bbd5095d4c1197b$var$empty(clones);
        event.destroy();
    };
    var observe = function observe() {
        var count = computeCloneCount();
        if (cloneCount !== count) {
            if (cloneCount < count || !count) event.emit($7bbd5095d4c1197b$export$7f4701ac5e05e39f);
        }
    };
    var generate = function generate(count) {
        var slides = _$Slides.get().slice();
        var length = slides.length;
        if (length) {
            while(slides.length < count)$7bbd5095d4c1197b$var$push(slides, slides);
            $7bbd5095d4c1197b$var$push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide, index) {
                var isHead = index < count;
                var clone = cloneDeep(Slide.slide, index);
                isHead ? $7bbd5095d4c1197b$var$before(clone, slides[0].slide) : $7bbd5095d4c1197b$var$append(_$Elements.list, clone);
                $7bbd5095d4c1197b$var$push(clones, clone);
                _$Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
            });
        }
    };
    var cloneDeep = function cloneDeep(elm, index) {
        var clone = elm.cloneNode(true);
        $7bbd5095d4c1197b$var$addClass(clone, options.classes.clone);
        clone.id = Splide2.root.id + "-clone" + $7bbd5095d4c1197b$var$pad(index + 1);
        return clone;
    };
    var computeCloneCount = function computeCloneCount() {
        var clones2 = options.clones;
        if (!Splide2.is($7bbd5095d4c1197b$export$f42383286ed1223d)) clones2 = 0;
        else if ($7bbd5095d4c1197b$var$isUndefined(clones2)) {
            var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
            var fixedCount = fixedSize && $7bbd5095d4c1197b$var$ceil($7bbd5095d4c1197b$var$rect(_$Elements.track)[resolve("width")] / fixedSize);
            clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * $7bbd5095d4c1197b$var$MULTIPLIER;
        }
        return clones2;
    };
    var event = $7bbd5095d4c1197b$export$f188226459c8a3ff(Splide2);
    var on = event.on;
    var _$Elements = Components2.Elements, _$Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var clones = [];
    var cloneCount;
    return {
        mount: mount,
        destroy: destroy
    };
}
function $7bbd5095d4c1197b$var$Move(Splide2, Components2, options) {
    var mount = function mount() {
        Transition = Components2.Transition;
        on([
            $7bbd5095d4c1197b$export$d300dc1a2634364b,
            $7bbd5095d4c1197b$export$d637eba1e9e28482,
            $7bbd5095d4c1197b$export$db40ab7c0855fa5c,
            $7bbd5095d4c1197b$export$7f4701ac5e05e39f
        ], reposition);
    };
    var reposition = function reposition() {
        if (!Components2.Controller.isBusy()) {
            Components2.Scroll.cancel();
            jump(Splide2.index);
            Components2.Slides.update();
        }
    };
    var move = function move(dest, index, prev, callback) {
        if (dest !== index && canShift(dest > prev)) {
            cancel();
            translate(shift(getPosition(), dest > prev), true);
        }
        set($7bbd5095d4c1197b$var$MOVING);
        emit($7bbd5095d4c1197b$export$2aa493d7c3275167, index, prev, dest);
        Transition.start(index, function() {
            set($7bbd5095d4c1197b$var$IDLE);
            emit($7bbd5095d4c1197b$export$fe5802204b967f0d, index, prev, dest);
            callback && callback();
        });
    };
    var jump = function jump(index) {
        translate(toPosition(index, true));
    };
    var translate = function translate(position, preventLoop) {
        if (!Splide2.is($7bbd5095d4c1197b$export$742b62a5690c060)) {
            var destination = preventLoop ? position : loop(position);
            $7bbd5095d4c1197b$var$style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
            position !== destination && emit($7bbd5095d4c1197b$export$f0af896383d5adff);
        }
    };
    var loop = function loop(position) {
        if (Splide2.is($7bbd5095d4c1197b$export$f42383286ed1223d)) {
            var index = toIndex(position);
            var exceededMax = index > Components2.Controller.getEnd();
            var exceededMin = index < 0;
            if (exceededMin || exceededMax) position = shift(position, exceededMax);
        }
        return position;
    };
    var shift = function shift(position, backwards) {
        var excess = position - getLimit(backwards);
        var size = sliderSize();
        position -= orient(size * ($7bbd5095d4c1197b$var$ceil($7bbd5095d4c1197b$var$abs(excess) / size) || 1)) * (backwards ? 1 : -1);
        return position;
    };
    var cancel = function cancel() {
        translate(getPosition(), true);
        Transition.cancel();
    };
    var toIndex = function toIndex(position) {
        var _$Slides = Components2.Slides.get();
        var index = 0;
        var minDistance = Infinity;
        for(var i = 0; i < _$Slides.length; i++){
            var slideIndex = _$Slides[i].index;
            var distance = $7bbd5095d4c1197b$var$abs(toPosition(slideIndex, true) - position);
            if (distance <= minDistance) {
                minDistance = distance;
                index = slideIndex;
            } else break;
        }
        return index;
    };
    var toPosition = function toPosition(index, trimming) {
        var position = orient(totalSize(index - 1) - offset(index));
        return trimming ? trim(position) : position;
    };
    var getPosition = function getPosition() {
        var left = resolve("left");
        return $7bbd5095d4c1197b$var$rect(list)[left] - $7bbd5095d4c1197b$var$rect(track)[left] + orient(getPadding(false));
    };
    var trim = function trim(position) {
        if (options.trimSpace && Splide2.is($7bbd5095d4c1197b$export$e5a58a5ee5b54c22)) position = $7bbd5095d4c1197b$var$clamp(position, 0, orient(sliderSize(true) - listSize()));
        return position;
    };
    var offset = function offset(index) {
        var focus = options.focus;
        return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
    };
    var getLimit = function getLimit(max) {
        return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
    };
    var canShift = function canShift(backwards) {
        var shifted = orient(shift(getPosition(), backwards));
        return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - $7bbd5095d4c1197b$var$rect(track)[resolve("width")];
    };
    var exceededLimit = function exceededLimit(max, position) {
        position = $7bbd5095d4c1197b$var$isUndefined(position) ? getPosition() : position;
        var exceededMin = max !== true && orient(position) < orient(getLimit(false));
        var exceededMax = max !== false && orient(position) > orient(getLimit(true));
        return exceededMin || exceededMax;
    };
    var _EventInterface4 = $7bbd5095d4c1197b$export$f188226459c8a3ff(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
    var set = Splide2.state.set;
    var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
    var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
    var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
    var Transition;
    return {
        mount: mount,
        move: move,
        jump: jump,
        translate: translate,
        shift: shift,
        cancel: cancel,
        toIndex: toIndex,
        toPosition: toPosition,
        getPosition: getPosition,
        getLimit: getLimit,
        exceededLimit: exceededLimit,
        reposition: reposition
    };
}
function $7bbd5095d4c1197b$var$Controller(Splide2, Components2, options) {
    var mount = function mount() {
        init();
        on([
            $7bbd5095d4c1197b$export$db40ab7c0855fa5c,
            $7bbd5095d4c1197b$export$7f4701ac5e05e39f,
            $7bbd5095d4c1197b$export$28dea85f216954dc
        ], init);
        on($7bbd5095d4c1197b$export$d637eba1e9e28482, onResized);
    };
    var init = function init() {
        slideCount = getLength(true);
        perMove = options.perMove;
        perPage = options.perPage;
        endIndex = getEnd();
        var index = $7bbd5095d4c1197b$var$clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
        if (index !== currIndex) {
            currIndex = index;
            _$Move.reposition();
        }
    };
    var onResized = function onResized() {
        if (endIndex !== getEnd()) emit($7bbd5095d4c1197b$export$28dea85f216954dc);
    };
    var go = function go(control, allowSameIndex, callback) {
        if (!isBusy()) {
            var dest = parse(control);
            var index = loop(dest);
            if (index > -1 && (allowSameIndex || index !== currIndex)) {
                setIndex(index);
                _$Move.move(dest, index, prevIndex, callback);
            }
        }
    };
    var scroll = function scroll(destination, duration, snap, callback) {
        Components2.Scroll.scroll(destination, duration, snap, function() {
            var index = loop(_$Move.toIndex(getPosition()));
            setIndex(omitEnd ? $7bbd5095d4c1197b$var$min(index, endIndex) : index);
            callback && callback();
        });
    };
    var parse = function parse(control) {
        var index = currIndex;
        if ($7bbd5095d4c1197b$var$isString(control)) {
            var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
            if (indicator === "+" || indicator === "-") index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
            else if (indicator === ">") index = number ? toIndex(+number) : getNext(true);
            else if (indicator === "<") index = getPrev(true);
        } else index = isLoop ? control : $7bbd5095d4c1197b$var$clamp(control, 0, endIndex);
        return index;
    };
    var getAdjacent = function getAdjacent(prev, destination) {
        var number = perMove || (hasFocus() ? 1 : perPage);
        var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
        if (dest === -1 && isSlide) {
            if (!$7bbd5095d4c1197b$var$approximatelyEqual(getPosition(), getLimit(!prev), 1)) return prev ? 0 : endIndex;
        }
        return destination ? dest : loop(dest);
    };
    var computeDestIndex = function computeDestIndex(dest, from, snapPage) {
        if (isEnough() || hasFocus()) {
            var index = computeMovableDestIndex(dest);
            if (index !== dest) {
                from = dest;
                dest = index;
                snapPage = false;
            }
            if (dest < 0 || dest > endIndex) {
                if (!perMove && ($7bbd5095d4c1197b$var$between(0, dest, from, true) || $7bbd5095d4c1197b$var$between(endIndex, from, dest, true))) dest = toIndex(toPage(dest));
                else {
                    if (isLoop) dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
                    else if (options.rewind) dest = dest < 0 ? endIndex : 0;
                    else dest = -1;
                }
            } else if (snapPage && dest !== from) dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        } else dest = -1;
        return dest;
    };
    var computeMovableDestIndex = function computeMovableDestIndex(dest) {
        if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
            var position = getPosition();
            while(position === toPosition(dest, true) && $7bbd5095d4c1197b$var$between(dest, 0, Splide2.length - 1, !options.rewind))dest < currIndex ? --dest : ++dest;
        }
        return dest;
    };
    var loop = function loop(index) {
        return isLoop ? (index + slideCount) % slideCount || 0 : index;
    };
    var getEnd = function getEnd() {
        var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
        while(omitEnd && end-- > 0)if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
            end++;
            break;
        }
        return $7bbd5095d4c1197b$var$clamp(end, 0, slideCount - 1);
    };
    var toIndex = function toIndex(page) {
        return $7bbd5095d4c1197b$var$clamp(hasFocus() ? page : perPage * page, 0, endIndex);
    };
    var toPage = function toPage(index) {
        return hasFocus() ? $7bbd5095d4c1197b$var$min(index, endIndex) : $7bbd5095d4c1197b$var$floor((index >= endIndex ? slideCount - 1 : index) / perPage);
    };
    var toDest = function toDest(destination) {
        var closest = _$Move.toIndex(destination);
        return isSlide ? $7bbd5095d4c1197b$var$clamp(closest, 0, endIndex) : closest;
    };
    var setIndex = function setIndex(index) {
        if (index !== currIndex) {
            prevIndex = currIndex;
            currIndex = index;
        }
    };
    var getIndex = function getIndex(prev) {
        return prev ? prevIndex : currIndex;
    };
    var hasFocus = function hasFocus() {
        return !$7bbd5095d4c1197b$var$isUndefined(options.focus) || options.isNavigation;
    };
    var isBusy = function isBusy() {
        return Splide2.state.is([
            $7bbd5095d4c1197b$var$MOVING,
            $7bbd5095d4c1197b$var$SCROLLING
        ]) && !!options.waitForTransition;
    };
    var _EventInterface5 = $7bbd5095d4c1197b$export$f188226459c8a3ff(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
    var _$Move = Components2.Move;
    var getPosition = _$Move.getPosition, getLimit = _$Move.getLimit, toPosition = _$Move.toPosition;
    var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
    var omitEnd = options.omitEnd;
    var isLoop = Splide2.is($7bbd5095d4c1197b$export$f42383286ed1223d);
    var isSlide = Splide2.is($7bbd5095d4c1197b$export$e5a58a5ee5b54c22);
    var getNext = $7bbd5095d4c1197b$var$apply(getAdjacent, false);
    var getPrev = $7bbd5095d4c1197b$var$apply(getAdjacent, true);
    var currIndex = options.start || 0;
    var endIndex;
    var prevIndex = currIndex;
    var slideCount;
    var perMove;
    var perPage;
    return {
        mount: mount,
        go: go,
        scroll: scroll,
        getNext: getNext,
        getPrev: getPrev,
        getAdjacent: getAdjacent,
        getEnd: getEnd,
        setIndex: setIndex,
        getIndex: getIndex,
        toIndex: toIndex,
        toPage: toPage,
        toDest: toDest,
        hasFocus: hasFocus,
        isBusy: isBusy
    };
}
var $7bbd5095d4c1197b$var$XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var $7bbd5095d4c1197b$var$PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var $7bbd5095d4c1197b$var$SIZE = 40;
function $7bbd5095d4c1197b$var$Arrows(Splide2, Components2, options) {
    var mount = function mount() {
        init();
        on($7bbd5095d4c1197b$export$db40ab7c0855fa5c, remount);
    };
    var remount = function remount() {
        destroy();
        mount();
    };
    var init = function init() {
        var enabled = options.arrows;
        if (enabled && !(prev && next)) createArrows();
        if (prev && next) {
            $7bbd5095d4c1197b$var$assign(arrows, {
                prev: prev,
                next: next
            });
            $7bbd5095d4c1197b$var$display(wrapper, enabled ? "" : "none");
            $7bbd5095d4c1197b$var$addClass(wrapper, wrapperClasses = $7bbd5095d4c1197b$export$a26cbd955fecf11e + "--" + options.direction);
            if (enabled) {
                listen();
                update();
                $7bbd5095d4c1197b$var$setAttribute([
                    prev,
                    next
                ], $7bbd5095d4c1197b$var$ARIA_CONTROLS, track.id);
                emit($7bbd5095d4c1197b$export$8647f6b043e04e9d, prev, next);
            }
        }
    };
    var destroy = function destroy() {
        event.destroy();
        $7bbd5095d4c1197b$var$removeClass(wrapper, wrapperClasses);
        if (created) {
            $7bbd5095d4c1197b$var$remove(placeholder ? [
                prev,
                next
            ] : wrapper);
            prev = next = null;
        } else $7bbd5095d4c1197b$var$removeAttribute([
            prev,
            next
        ], $7bbd5095d4c1197b$var$ALL_ATTRIBUTES);
    };
    var listen = function listen() {
        on([
            $7bbd5095d4c1197b$export$d300dc1a2634364b,
            $7bbd5095d4c1197b$export$fe5802204b967f0d,
            $7bbd5095d4c1197b$export$7f4701ac5e05e39f,
            $7bbd5095d4c1197b$export$ff8164bff3202b9,
            $7bbd5095d4c1197b$export$28dea85f216954dc
        ], update);
        bind(next, "click", $7bbd5095d4c1197b$var$apply(go, ">"));
        bind(prev, "click", $7bbd5095d4c1197b$var$apply(go, "<"));
    };
    var go = function go(control) {
        _$Controller.go(control, true);
    };
    var createArrows = function createArrows() {
        wrapper = placeholder || $7bbd5095d4c1197b$var$create("div", classes.arrows);
        prev = createArrow(true);
        next = createArrow(false);
        created = true;
        $7bbd5095d4c1197b$var$append(wrapper, [
            prev,
            next
        ]);
        !placeholder && $7bbd5095d4c1197b$var$before(wrapper, track);
    };
    var createArrow = function createArrow(prev2) {
        var arrow = '<button class="' + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + '" type="button"><svg xmlns="' + $7bbd5095d4c1197b$var$XML_NAME_SPACE + '" viewBox="0 0 ' + $7bbd5095d4c1197b$var$SIZE + " " + $7bbd5095d4c1197b$var$SIZE + '" width="' + $7bbd5095d4c1197b$var$SIZE + '" height="' + $7bbd5095d4c1197b$var$SIZE + '" focusable="false"><path d="' + (options.arrowPath || $7bbd5095d4c1197b$var$PATH) + '" />';
        return $7bbd5095d4c1197b$var$parseHtml(arrow);
    };
    var update = function update() {
        if (prev && next) {
            var index = Splide2.index;
            var prevIndex = _$Controller.getPrev();
            var nextIndex = _$Controller.getNext();
            var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
            var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
            prev.disabled = prevIndex < 0;
            next.disabled = nextIndex < 0;
            $7bbd5095d4c1197b$var$setAttribute(prev, $7bbd5095d4c1197b$var$ARIA_LABEL, prevLabel);
            $7bbd5095d4c1197b$var$setAttribute(next, $7bbd5095d4c1197b$var$ARIA_LABEL, nextLabel);
            emit($7bbd5095d4c1197b$export$d467f9343b961f75, prev, next, prevIndex, nextIndex);
        }
    };
    var event = $7bbd5095d4c1197b$export$f188226459c8a3ff(Splide2);
    var on = event.on, bind = event.bind, emit = event.emit;
    var classes = options.classes, i18n = options.i18n;
    var _$Elements = Components2.Elements, _$Controller = Components2.Controller;
    var placeholder = _$Elements.arrows, track = _$Elements.track;
    var wrapper = placeholder;
    var prev = _$Elements.prev;
    var next = _$Elements.next;
    var created;
    var wrapperClasses;
    var arrows = {};
    return {
        arrows: arrows,
        mount: mount,
        destroy: destroy,
        update: update
    };
}
var $7bbd5095d4c1197b$var$INTERVAL_DATA_ATTRIBUTE = $7bbd5095d4c1197b$var$DATA_ATTRIBUTE + "-interval";
function $7bbd5095d4c1197b$var$Autoplay(Splide2, Components2, options) {
    var mount = function mount() {
        if (autoplay) {
            listen();
            toggle && $7bbd5095d4c1197b$var$setAttribute(toggle, $7bbd5095d4c1197b$var$ARIA_CONTROLS, _$Elements.track.id);
            stopped || play();
            update();
        }
    };
    var listen = function listen() {
        if (options.pauseOnHover) bind(root, "mouseenter mouseleave", function(e) {
            hovered = e.type === "mouseenter";
            autoToggle();
        });
        if (options.pauseOnFocus) bind(root, "focusin focusout", function(e) {
            focused = e.type === "focusin";
            autoToggle();
        });
        if (toggle) bind(toggle, "click", function() {
            stopped ? play() : pause(true);
        });
        on([
            $7bbd5095d4c1197b$export$2aa493d7c3275167,
            $7bbd5095d4c1197b$export$49801896908b5e33,
            $7bbd5095d4c1197b$export$7f4701ac5e05e39f
        ], interval.rewind);
        on($7bbd5095d4c1197b$export$2aa493d7c3275167, onMove);
    };
    var play = function play() {
        if (isPaused() && Components2.Slides.isEnough()) {
            interval.start(!options.resetProgress);
            focused = hovered = stopped = false;
            update();
            emit($7bbd5095d4c1197b$export$23663268a31b79e2);
        }
    };
    var pause = function pause(stop) {
        if (stop === void 0) stop = true;
        stopped = !!stop;
        update();
        if (!isPaused()) {
            interval.pause();
            emit($7bbd5095d4c1197b$export$16a1e4f3d0368265);
        }
    };
    var autoToggle = function autoToggle() {
        if (!stopped) hovered || focused ? pause(false) : play();
    };
    var update = function update() {
        if (toggle) {
            $7bbd5095d4c1197b$var$toggleClass(toggle, $7bbd5095d4c1197b$export$72d36ecf3758cb4b, !stopped);
            $7bbd5095d4c1197b$var$setAttribute(toggle, $7bbd5095d4c1197b$var$ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
        }
    };
    var onAnimationFrame = function onAnimationFrame(rate) {
        var bar = _$Elements.bar;
        bar && $7bbd5095d4c1197b$var$style(bar, "width", rate * 100 + "%");
        emit($7bbd5095d4c1197b$export$185723258309b608, rate);
    };
    var onMove = function onMove(index) {
        var Slide = Components2.Slides.getAt(index);
        interval.set(Slide && +$7bbd5095d4c1197b$var$getAttribute(Slide.slide, $7bbd5095d4c1197b$var$INTERVAL_DATA_ATTRIBUTE) || options.interval);
    };
    var _EventInterface6 = $7bbd5095d4c1197b$export$f188226459c8a3ff(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
    var interval = $7bbd5095d4c1197b$export$46ad21b25b6dccf0(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
    var isPaused = interval.isPaused;
    var _$Elements = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
    var autoplay = options.autoplay;
    var hovered;
    var focused;
    var stopped = autoplay === "pause";
    return {
        mount: mount,
        destroy: interval.cancel,
        play: play,
        pause: pause,
        isPaused: isPaused
    };
}
function $7bbd5095d4c1197b$var$Cover(Splide2, Components2, options) {
    var mount = function mount() {
        if (options.cover) {
            on($7bbd5095d4c1197b$export$9f64346e17f0ec8e, $7bbd5095d4c1197b$var$apply(toggle, true));
            on([
                $7bbd5095d4c1197b$export$d300dc1a2634364b,
                $7bbd5095d4c1197b$export$db40ab7c0855fa5c,
                $7bbd5095d4c1197b$export$7f4701ac5e05e39f
            ], $7bbd5095d4c1197b$var$apply(cover, true));
        }
    };
    var cover = function cover(cover2) {
        Components2.Slides.forEach(function(Slide) {
            var img = $7bbd5095d4c1197b$var$child(Slide.container || Slide.slide, "img");
            if (img && img.src) toggle(cover2, img, Slide);
        });
    };
    var toggle = function toggle(cover2, img, Slide) {
        Slide.style("background", cover2 ? 'center/cover no-repeat url("' + img.src + '")' : "", true);
        $7bbd5095d4c1197b$var$display(img, cover2 ? "none" : "");
    };
    var _EventInterface7 = $7bbd5095d4c1197b$export$f188226459c8a3ff(Splide2), on = _EventInterface7.on;
    return {
        mount: mount,
        destroy: $7bbd5095d4c1197b$var$apply(cover, false)
    };
}
var $7bbd5095d4c1197b$var$BOUNCE_DIFF_THRESHOLD = 10;
var $7bbd5095d4c1197b$var$BOUNCE_DURATION = 600;
var $7bbd5095d4c1197b$var$FRICTION_FACTOR = 0.6;
var $7bbd5095d4c1197b$var$BASE_VELOCITY = 1.5;
var $7bbd5095d4c1197b$var$MIN_DURATION = 800;
function $7bbd5095d4c1197b$var$Scroll(Splide2, Components2, options) {
    var mount = function mount() {
        on($7bbd5095d4c1197b$export$2aa493d7c3275167, clear);
        on([
            $7bbd5095d4c1197b$export$db40ab7c0855fa5c,
            $7bbd5095d4c1197b$export$7f4701ac5e05e39f
        ], cancel);
    };
    var scroll = function scroll(destination, duration, snap, onScrolled, noConstrain) {
        var from = getPosition();
        clear();
        if (snap && (!isSlide || !exceededLimit())) {
            var size = Components2.Layout.sliderSize();
            var offset = $7bbd5095d4c1197b$var$sign(destination) * size * $7bbd5095d4c1197b$var$floor($7bbd5095d4c1197b$var$abs(destination) / size) || 0;
            destination = _$Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
        }
        var noDistance = $7bbd5095d4c1197b$var$approximatelyEqual(from, destination, 1);
        friction = 1;
        duration = noDistance ? 0 : duration || $7bbd5095d4c1197b$var$max($7bbd5095d4c1197b$var$abs(destination - from) / $7bbd5095d4c1197b$var$BASE_VELOCITY, $7bbd5095d4c1197b$var$MIN_DURATION);
        callback = onScrolled;
        interval = $7bbd5095d4c1197b$export$46ad21b25b6dccf0(duration, onEnd, $7bbd5095d4c1197b$var$apply(update, from, destination, noConstrain), 1);
        set($7bbd5095d4c1197b$var$SCROLLING);
        emit($7bbd5095d4c1197b$export$49801896908b5e33);
        interval.start();
    };
    var onEnd = function onEnd() {
        set($7bbd5095d4c1197b$var$IDLE);
        callback && callback();
        emit($7bbd5095d4c1197b$export$ff8164bff3202b9);
    };
    var update = function update(from, to, noConstrain, rate) {
        var position = getPosition();
        var target = from + (to - from) * easing(rate);
        var diff = (target - position) * friction;
        translate(position + diff);
        if (isSlide && !noConstrain && exceededLimit()) {
            friction *= $7bbd5095d4c1197b$var$FRICTION_FACTOR;
            if ($7bbd5095d4c1197b$var$abs(diff) < $7bbd5095d4c1197b$var$BOUNCE_DIFF_THRESHOLD) scroll(getLimit(exceededLimit(true)), $7bbd5095d4c1197b$var$BOUNCE_DURATION, false, callback, true);
        }
    };
    var clear = function clear() {
        if (interval) interval.cancel();
    };
    var cancel = function cancel() {
        if (interval && !interval.isPaused()) {
            clear();
            onEnd();
        }
    };
    var easing = function easing(t) {
        var easingFunc = options.easingFunc;
        return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
    };
    var _EventInterface8 = $7bbd5095d4c1197b$export$f188226459c8a3ff(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
    var set = Splide2.state.set;
    var _$Move = Components2.Move;
    var getPosition = _$Move.getPosition, getLimit = _$Move.getLimit, exceededLimit = _$Move.exceededLimit, translate = _$Move.translate;
    var isSlide = Splide2.is($7bbd5095d4c1197b$export$e5a58a5ee5b54c22);
    var interval;
    var callback;
    var friction = 1;
    return {
        mount: mount,
        destroy: clear,
        scroll: scroll,
        cancel: cancel
    };
}
var $7bbd5095d4c1197b$var$SCROLL_LISTENER_OPTIONS = {
    passive: false,
    capture: true
};
function $7bbd5095d4c1197b$var$Drag(Splide2, Components2, options) {
    var mount = function mount() {
        bind(track, $7bbd5095d4c1197b$var$POINTER_MOVE_EVENTS, $7bbd5095d4c1197b$var$noop, $7bbd5095d4c1197b$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $7bbd5095d4c1197b$var$POINTER_UP_EVENTS, $7bbd5095d4c1197b$var$noop, $7bbd5095d4c1197b$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $7bbd5095d4c1197b$var$POINTER_DOWN_EVENTS, onPointerDown, $7bbd5095d4c1197b$var$SCROLL_LISTENER_OPTIONS);
        bind(track, "click", onClick, {
            capture: true
        });
        bind(track, "dragstart", $7bbd5095d4c1197b$var$prevent);
        on([
            $7bbd5095d4c1197b$export$d300dc1a2634364b,
            $7bbd5095d4c1197b$export$db40ab7c0855fa5c
        ], init);
    };
    var init = function init() {
        var drag = options.drag;
        disable(!drag);
        isFree = drag === "free";
    };
    var onPointerDown = function onPointerDown(e) {
        clickPrevented = false;
        if (!disabled) {
            var isTouch = isTouchEvent(e);
            if (isDraggable(e.target) && (isTouch || !e.button)) {
                if (!_$Controller.isBusy()) {
                    target = isTouch ? track : window;
                    dragging = state.is([
                        $7bbd5095d4c1197b$var$MOVING,
                        $7bbd5095d4c1197b$var$SCROLLING
                    ]);
                    prevBaseEvent = null;
                    bind(target, $7bbd5095d4c1197b$var$POINTER_MOVE_EVENTS, onPointerMove, $7bbd5095d4c1197b$var$SCROLL_LISTENER_OPTIONS);
                    bind(target, $7bbd5095d4c1197b$var$POINTER_UP_EVENTS, onPointerUp, $7bbd5095d4c1197b$var$SCROLL_LISTENER_OPTIONS);
                    _$Move.cancel();
                    _$Scroll.cancel();
                    save(e);
                } else $7bbd5095d4c1197b$var$prevent(e, true);
            }
        }
    };
    var onPointerMove = function onPointerMove(e) {
        if (!state.is($7bbd5095d4c1197b$var$DRAGGING)) {
            state.set($7bbd5095d4c1197b$var$DRAGGING);
            emit($7bbd5095d4c1197b$export$e84bf5065c9087ac);
        }
        if (e.cancelable) {
            if (dragging) {
                _$Move.translate(basePosition + constrain(diffCoord(e)));
                var expired = diffTime(e) > $7bbd5095d4c1197b$var$LOG_INTERVAL;
                var hasExceeded = exceeded !== (exceeded = exceededLimit());
                if (expired || hasExceeded) save(e);
                clickPrevented = true;
                emit($7bbd5095d4c1197b$export$8e9f636d2c722196);
                $7bbd5095d4c1197b$var$prevent(e);
            } else if (isSliderDirection(e)) {
                dragging = shouldStart(e);
                $7bbd5095d4c1197b$var$prevent(e);
            }
        }
    };
    var onClick = function onClick(e) {
        if (!disabled && clickPrevented) $7bbd5095d4c1197b$var$prevent(e, true);
    };
    var save = function save(e) {
        prevBaseEvent = baseEvent;
        baseEvent = e;
        basePosition = getPosition();
    };
    var move = function move(e) {
        var velocity = computeVelocity(e);
        var destination = computeDestination(velocity);
        var rewind = options.rewind && options.rewindByDrag;
        reduce(false);
        if (isFree) _$Controller.scroll(destination, 0, options.snap);
        else if (Splide2.is($7bbd5095d4c1197b$export$742b62a5690c060)) _$Controller.go(orient($7bbd5095d4c1197b$var$sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
        else if (Splide2.is($7bbd5095d4c1197b$export$e5a58a5ee5b54c22) && exceeded && rewind) _$Controller.go(exceededLimit(true) ? ">" : "<");
        else _$Controller.go(_$Controller.toDest(destination), true);
        reduce(true);
    };
    var shouldStart = function shouldStart(e) {
        var thresholds = options.dragMinThreshold;
        var isObj = $7bbd5095d4c1197b$var$isObject(thresholds);
        var mouse = isObj && thresholds.mouse || 0;
        var touch = (isObj ? thresholds.touch : +thresholds) || 10;
        return $7bbd5095d4c1197b$var$abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
    };
    var isSliderDirection = function isSliderDirection(e) {
        return $7bbd5095d4c1197b$var$abs(diffCoord(e)) > $7bbd5095d4c1197b$var$abs(diffCoord(e, true));
    };
    var computeVelocity = function computeVelocity(e) {
        if (Splide2.is($7bbd5095d4c1197b$export$f42383286ed1223d) || !exceeded) {
            var time = diffTime(e);
            if (time && time < $7bbd5095d4c1197b$var$LOG_INTERVAL) return diffCoord(e) / time;
        }
        return 0;
    };
    var computeDestination = function computeDestination(velocity) {
        return getPosition() + $7bbd5095d4c1197b$var$sign(velocity) * $7bbd5095d4c1197b$var$min($7bbd5095d4c1197b$var$abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
    };
    var diffCoord = function diffCoord(e, orthogonal) {
        return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
    };
    var diffTime = function diffTime(e) {
        return $7bbd5095d4c1197b$var$timeOf(e) - $7bbd5095d4c1197b$var$timeOf(getBaseEvent(e));
    };
    var getBaseEvent = function getBaseEvent(e) {
        return baseEvent === e && prevBaseEvent || baseEvent;
    };
    var coordOf = function coordOf(e, orthogonal) {
        return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
    };
    var constrain = function constrain(diff) {
        return diff / (exceeded && Splide2.is($7bbd5095d4c1197b$export$e5a58a5ee5b54c22) ? $7bbd5095d4c1197b$var$FRICTION : 1);
    };
    var isDraggable = function isDraggable(target2) {
        var noDrag = options.noDrag;
        return !$7bbd5095d4c1197b$var$matches(target2, "." + $7bbd5095d4c1197b$export$52f2cca6a5eee805 + ", ." + $7bbd5095d4c1197b$export$516e7d18e13a2dca) && (!noDrag || !$7bbd5095d4c1197b$var$matches(target2, noDrag));
    };
    var isTouchEvent = function isTouchEvent(e) {
        return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
    };
    var isDragging = function isDragging() {
        return dragging;
    };
    var disable = function disable(value) {
        disabled = value;
    };
    var _EventInterface9 = $7bbd5095d4c1197b$export$f188226459c8a3ff(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
    var state = Splide2.state;
    var _$Move = Components2.Move, _$Scroll = Components2.Scroll, _$Controller = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
    var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
    var getPosition = _$Move.getPosition, exceededLimit = _$Move.exceededLimit;
    var basePosition;
    var baseEvent;
    var prevBaseEvent;
    var isFree;
    var dragging;
    var exceeded = false;
    var clickPrevented;
    var disabled;
    var target;
    function onPointerUp(e) {
        if (state.is($7bbd5095d4c1197b$var$DRAGGING)) {
            state.set($7bbd5095d4c1197b$var$IDLE);
            emit($7bbd5095d4c1197b$export$90ea576bd3fdeb60);
        }
        if (dragging) {
            move(e);
            $7bbd5095d4c1197b$var$prevent(e);
        }
        unbind(target, $7bbd5095d4c1197b$var$POINTER_MOVE_EVENTS, onPointerMove);
        unbind(target, $7bbd5095d4c1197b$var$POINTER_UP_EVENTS, onPointerUp);
        dragging = false;
    }
    return {
        mount: mount,
        disable: disable,
        isDragging: isDragging
    };
}
var $7bbd5095d4c1197b$var$NORMALIZATION_MAP = {
    Spacebar: " ",
    Right: $7bbd5095d4c1197b$var$ARROW_RIGHT,
    Left: $7bbd5095d4c1197b$var$ARROW_LEFT,
    Up: $7bbd5095d4c1197b$var$ARROW_UP,
    Down: $7bbd5095d4c1197b$var$ARROW_DOWN
};
function $7bbd5095d4c1197b$var$normalizeKey(key) {
    key = $7bbd5095d4c1197b$var$isString(key) ? key : key.key;
    return $7bbd5095d4c1197b$var$NORMALIZATION_MAP[key] || key;
}
var $7bbd5095d4c1197b$var$KEYBOARD_EVENT = "keydown";
function $7bbd5095d4c1197b$var$Keyboard(Splide2, Components2, options) {
    var mount = function mount() {
        init();
        on($7bbd5095d4c1197b$export$db40ab7c0855fa5c, destroy);
        on($7bbd5095d4c1197b$export$db40ab7c0855fa5c, init);
        on($7bbd5095d4c1197b$export$2aa493d7c3275167, onMove);
    };
    var init = function init() {
        var keyboard = options.keyboard;
        if (keyboard) {
            target = keyboard === "global" ? window : root;
            bind(target, $7bbd5095d4c1197b$var$KEYBOARD_EVENT, onKeydown);
        }
    };
    var destroy = function destroy() {
        unbind(target, $7bbd5095d4c1197b$var$KEYBOARD_EVENT);
    };
    var disable = function disable(value) {
        disabled = value;
    };
    var onMove = function onMove() {
        var _disabled = disabled;
        disabled = true;
        $7bbd5095d4c1197b$var$nextTick(function() {
            disabled = _disabled;
        });
    };
    var onKeydown = function onKeydown(e) {
        if (!disabled) {
            var key = $7bbd5095d4c1197b$var$normalizeKey(e);
            if (key === resolve($7bbd5095d4c1197b$var$ARROW_LEFT)) Splide2.go("<");
            else if (key === resolve($7bbd5095d4c1197b$var$ARROW_RIGHT)) Splide2.go(">");
        }
    };
    var _EventInterface10 = $7bbd5095d4c1197b$export$f188226459c8a3ff(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
    var root = Splide2.root;
    var resolve = Components2.Direction.resolve;
    var target;
    var disabled;
    return {
        mount: mount,
        destroy: destroy,
        disable: disable
    };
}
var $7bbd5095d4c1197b$var$SRC_DATA_ATTRIBUTE = $7bbd5095d4c1197b$var$DATA_ATTRIBUTE + "-lazy";
var $7bbd5095d4c1197b$var$SRCSET_DATA_ATTRIBUTE = $7bbd5095d4c1197b$var$SRC_DATA_ATTRIBUTE + "-srcset";
var $7bbd5095d4c1197b$var$IMAGE_SELECTOR = "[" + $7bbd5095d4c1197b$var$SRC_DATA_ATTRIBUTE + "], [" + $7bbd5095d4c1197b$var$SRCSET_DATA_ATTRIBUTE + "]";
function $7bbd5095d4c1197b$var$LazyLoad(Splide2, Components2, options) {
    var mount = function mount() {
        if (options.lazyLoad) {
            init();
            on($7bbd5095d4c1197b$export$7f4701ac5e05e39f, init);
        }
    };
    var init = function init() {
        $7bbd5095d4c1197b$var$empty(entries);
        register();
        if (isSequential) loadNext();
        else {
            off(events);
            on(events, check);
            check();
        }
    };
    var register = function register() {
        Components2.Slides.forEach(function(Slide) {
            $7bbd5095d4c1197b$var$queryAll(Slide.slide, $7bbd5095d4c1197b$var$IMAGE_SELECTOR).forEach(function(img) {
                var src = $7bbd5095d4c1197b$var$getAttribute(img, $7bbd5095d4c1197b$var$SRC_DATA_ATTRIBUTE);
                var srcset = $7bbd5095d4c1197b$var$getAttribute(img, $7bbd5095d4c1197b$var$SRCSET_DATA_ATTRIBUTE);
                if (src !== img.src || srcset !== img.srcset) {
                    var className = options.classes.spinner;
                    var parent = img.parentElement;
                    var spinner = $7bbd5095d4c1197b$var$child(parent, "." + className) || $7bbd5095d4c1197b$var$create("span", className, parent);
                    entries.push([
                        img,
                        Slide,
                        spinner
                    ]);
                    img.src || $7bbd5095d4c1197b$var$display(img, "none");
                }
            });
        });
    };
    var check = function check() {
        entries = entries.filter(function(data) {
            var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
            return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
        });
        entries.length || off(events);
    };
    var load = function load(data) {
        var img = data[0];
        $7bbd5095d4c1197b$var$addClass(data[1].slide, $7bbd5095d4c1197b$export$d22ec4ccb7996ba2);
        bind(img, "load error", $7bbd5095d4c1197b$var$apply(onLoad, data));
        $7bbd5095d4c1197b$var$setAttribute(img, "src", $7bbd5095d4c1197b$var$getAttribute(img, $7bbd5095d4c1197b$var$SRC_DATA_ATTRIBUTE));
        $7bbd5095d4c1197b$var$setAttribute(img, "srcset", $7bbd5095d4c1197b$var$getAttribute(img, $7bbd5095d4c1197b$var$SRCSET_DATA_ATTRIBUTE));
        $7bbd5095d4c1197b$var$removeAttribute(img, $7bbd5095d4c1197b$var$SRC_DATA_ATTRIBUTE);
        $7bbd5095d4c1197b$var$removeAttribute(img, $7bbd5095d4c1197b$var$SRCSET_DATA_ATTRIBUTE);
    };
    var onLoad = function onLoad(data, e) {
        var img = data[0], Slide = data[1];
        $7bbd5095d4c1197b$var$removeClass(Slide.slide, $7bbd5095d4c1197b$export$d22ec4ccb7996ba2);
        if (e.type !== "error") {
            $7bbd5095d4c1197b$var$remove(data[2]);
            $7bbd5095d4c1197b$var$display(img, "");
            emit($7bbd5095d4c1197b$export$9f64346e17f0ec8e, img, Slide);
            emit($7bbd5095d4c1197b$export$7e019dae5103a285);
        }
        isSequential && loadNext();
    };
    var loadNext = function loadNext() {
        entries.length && load(entries.shift());
    };
    var _EventInterface11 = $7bbd5095d4c1197b$export$f188226459c8a3ff(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
    var isSequential = options.lazyLoad === "sequential";
    var events = [
        $7bbd5095d4c1197b$export$fe5802204b967f0d,
        $7bbd5095d4c1197b$export$ff8164bff3202b9
    ];
    var entries = [];
    return {
        mount: mount,
        destroy: $7bbd5095d4c1197b$var$apply($7bbd5095d4c1197b$var$empty, entries),
        check: check
    };
}
function $7bbd5095d4c1197b$var$Pagination(Splide2, Components2, options) {
    var destroy = function destroy() {
        if (list) {
            $7bbd5095d4c1197b$var$remove(placeholder ? $7bbd5095d4c1197b$var$slice(list.children) : list);
            $7bbd5095d4c1197b$var$removeClass(list, paginationClasses);
            $7bbd5095d4c1197b$var$empty(items);
            list = null;
        }
        event.destroy();
    };
    var createPagination = function createPagination() {
        var length = Splide2.length;
        var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
        var max = hasFocus() ? _$Controller.getEnd() + 1 : $7bbd5095d4c1197b$var$ceil(length / perPage);
        list = placeholder || $7bbd5095d4c1197b$var$create("ul", classes.pagination, _$Elements.track.parentElement);
        $7bbd5095d4c1197b$var$addClass(list, paginationClasses = $7bbd5095d4c1197b$export$cbf8e5a0ab95eda3 + "--" + getDirection());
        $7bbd5095d4c1197b$var$setAttribute(list, $7bbd5095d4c1197b$var$ROLE, "tablist");
        $7bbd5095d4c1197b$var$setAttribute(list, $7bbd5095d4c1197b$var$ARIA_LABEL, i18n.select);
        $7bbd5095d4c1197b$var$setAttribute(list, $7bbd5095d4c1197b$var$ARIA_ORIENTATION, getDirection() === $7bbd5095d4c1197b$export$97170d9824b89709 ? "vertical" : "");
        for(var i = 0; i < max; i++){
            var li = $7bbd5095d4c1197b$var$create("li", null, list);
            var button = $7bbd5095d4c1197b$var$create("button", {
                "class": classes.page,
                type: "button"
            }, li);
            var controls = _$Slides.getIn(i).map(function(Slide) {
                return Slide.slide.id;
            });
            var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
            bind(button, "click", $7bbd5095d4c1197b$var$apply(onClick, i));
            if (options.paginationKeyboard) bind(button, "keydown", $7bbd5095d4c1197b$var$apply(onKeydown, i));
            $7bbd5095d4c1197b$var$setAttribute(li, $7bbd5095d4c1197b$var$ROLE, "presentation");
            $7bbd5095d4c1197b$var$setAttribute(button, $7bbd5095d4c1197b$var$ROLE, "tab");
            $7bbd5095d4c1197b$var$setAttribute(button, $7bbd5095d4c1197b$var$ARIA_CONTROLS, controls.join(" "));
            $7bbd5095d4c1197b$var$setAttribute(button, $7bbd5095d4c1197b$var$ARIA_LABEL, $7bbd5095d4c1197b$var$format(text, i + 1));
            $7bbd5095d4c1197b$var$setAttribute(button, $7bbd5095d4c1197b$var$TAB_INDEX, -1);
            items.push({
                li: li,
                button: button,
                page: i
            });
        }
    };
    var onClick = function onClick(page) {
        go(">" + page, true);
    };
    var onKeydown = function onKeydown(page, e) {
        var length = items.length;
        var key = $7bbd5095d4c1197b$var$normalizeKey(e);
        var dir = getDirection();
        var nextPage = -1;
        if (key === resolve($7bbd5095d4c1197b$var$ARROW_RIGHT, false, dir)) nextPage = ++page % length;
        else if (key === resolve($7bbd5095d4c1197b$var$ARROW_LEFT, false, dir)) nextPage = (--page + length) % length;
        else if (key === "Home") nextPage = 0;
        else if (key === "End") nextPage = length - 1;
        var item = items[nextPage];
        if (item) {
            $7bbd5095d4c1197b$var$focus(item.button);
            go(">" + nextPage);
            $7bbd5095d4c1197b$var$prevent(e, true);
        }
    };
    var getDirection = function getDirection() {
        return options.paginationDirection || options.direction;
    };
    var getAt = function getAt(index) {
        return items[_$Controller.toPage(index)];
    };
    var update = function update() {
        var prev = getAt(getIndex(true));
        var curr = getAt(getIndex());
        if (prev) {
            var button = prev.button;
            $7bbd5095d4c1197b$var$removeClass(button, $7bbd5095d4c1197b$export$72d36ecf3758cb4b);
            $7bbd5095d4c1197b$var$removeAttribute(button, $7bbd5095d4c1197b$var$ARIA_SELECTED);
            $7bbd5095d4c1197b$var$setAttribute(button, $7bbd5095d4c1197b$var$TAB_INDEX, -1);
        }
        if (curr) {
            var _button = curr.button;
            $7bbd5095d4c1197b$var$addClass(_button, $7bbd5095d4c1197b$export$72d36ecf3758cb4b);
            $7bbd5095d4c1197b$var$setAttribute(_button, $7bbd5095d4c1197b$var$ARIA_SELECTED, true);
            $7bbd5095d4c1197b$var$setAttribute(_button, $7bbd5095d4c1197b$var$TAB_INDEX, "");
        }
        emit($7bbd5095d4c1197b$export$eb2019082ed6de0b, {
            list: list,
            items: items
        }, prev, curr);
    };
    var event = $7bbd5095d4c1197b$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var _$Slides = Components2.Slides, _$Elements = Components2.Elements, _$Controller = Components2.Controller;
    var hasFocus = _$Controller.hasFocus, getIndex = _$Controller.getIndex, go = _$Controller.go;
    var resolve = Components2.Direction.resolve;
    var placeholder = _$Elements.pagination;
    var items = [];
    var list;
    var paginationClasses;
    function mount() {
        destroy();
        on([
            $7bbd5095d4c1197b$export$db40ab7c0855fa5c,
            $7bbd5095d4c1197b$export$7f4701ac5e05e39f,
            $7bbd5095d4c1197b$export$28dea85f216954dc
        ], mount);
        var enabled = options.pagination;
        placeholder && $7bbd5095d4c1197b$var$display(placeholder, enabled ? "" : "none");
        if (enabled) {
            on([
                $7bbd5095d4c1197b$export$2aa493d7c3275167,
                $7bbd5095d4c1197b$export$49801896908b5e33,
                $7bbd5095d4c1197b$export$ff8164bff3202b9
            ], update);
            createPagination();
            update();
            emit($7bbd5095d4c1197b$export$bf89a4e4349c9778, {
                list: list,
                items: items
            }, getAt(Splide2.index));
        }
    }
    return {
        items: items,
        mount: mount,
        destroy: destroy,
        getAt: getAt,
        update: update
    };
}
var $7bbd5095d4c1197b$var$TRIGGER_KEYS = [
    " ",
    "Enter"
];
function $7bbd5095d4c1197b$var$Sync(Splide2, Components2, options) {
    var mount = function mount() {
        Splide2.splides.forEach(function(target) {
            if (!target.isParent) {
                sync(Splide2, target.splide);
                sync(target.splide, Splide2);
            }
        });
        if (isNavigation) navigate();
    };
    var destroy = function destroy() {
        events.forEach(function(event) {
            event.destroy();
        });
        $7bbd5095d4c1197b$var$empty(events);
    };
    var remount = function remount() {
        destroy();
        mount();
    };
    var sync = function sync(splide, target) {
        var event = $7bbd5095d4c1197b$export$f188226459c8a3ff(splide);
        event.on($7bbd5095d4c1197b$export$2aa493d7c3275167, function(index, prev, dest) {
            target.go(target.is($7bbd5095d4c1197b$export$f42383286ed1223d) ? dest : index);
        });
        events.push(event);
    };
    var navigate = function navigate() {
        var event = $7bbd5095d4c1197b$export$f188226459c8a3ff(Splide2);
        var on = event.on;
        on($7bbd5095d4c1197b$export$5adb665701eda1ce, onClick);
        on($7bbd5095d4c1197b$export$6d5af59619d10e6a, onKeydown);
        on([
            $7bbd5095d4c1197b$export$d300dc1a2634364b,
            $7bbd5095d4c1197b$export$db40ab7c0855fa5c
        ], update);
        events.push(event);
        event.emit($7bbd5095d4c1197b$export$84015c33508f94ec, Splide2.splides);
    };
    var update = function update() {
        $7bbd5095d4c1197b$var$setAttribute(Components2.Elements.list, $7bbd5095d4c1197b$var$ARIA_ORIENTATION, options.direction === $7bbd5095d4c1197b$export$97170d9824b89709 ? "vertical" : "");
    };
    var onClick = function onClick(Slide) {
        Splide2.go(Slide.index);
    };
    var onKeydown = function onKeydown(Slide, e) {
        if ($7bbd5095d4c1197b$var$includes($7bbd5095d4c1197b$var$TRIGGER_KEYS, $7bbd5095d4c1197b$var$normalizeKey(e))) {
            onClick(Slide);
            $7bbd5095d4c1197b$var$prevent(e);
        }
    };
    var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
    var events = [];
    return {
        setup: $7bbd5095d4c1197b$var$apply(Components2.Media.set, {
            slideFocus: $7bbd5095d4c1197b$var$isUndefined(slideFocus) ? isNavigation : slideFocus
        }, true),
        mount: mount,
        destroy: destroy,
        remount: remount
    };
}
function $7bbd5095d4c1197b$var$Wheel(Splide2, Components2, options) {
    var mount = function mount() {
        if (options.wheel) bind(Components2.Elements.track, "wheel", onWheel, $7bbd5095d4c1197b$var$SCROLL_LISTENER_OPTIONS);
    };
    var onWheel = function onWheel(e) {
        if (e.cancelable) {
            var deltaY = e.deltaY;
            var backwards = deltaY < 0;
            var timeStamp = $7bbd5095d4c1197b$var$timeOf(e);
            var _min = options.wheelMinThreshold || 0;
            var sleep = options.wheelSleep || 0;
            if ($7bbd5095d4c1197b$var$abs(deltaY) > _min && timeStamp - lastTime > sleep) {
                Splide2.go(backwards ? "<" : ">");
                lastTime = timeStamp;
            }
            shouldPrevent(backwards) && $7bbd5095d4c1197b$var$prevent(e);
        }
    };
    var shouldPrevent = function shouldPrevent(backwards) {
        return !options.releaseWheel || Splide2.state.is($7bbd5095d4c1197b$var$MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
    };
    var _EventInterface12 = $7bbd5095d4c1197b$export$f188226459c8a3ff(Splide2), bind = _EventInterface12.bind;
    var lastTime = 0;
    return {
        mount: mount
    };
}
var $7bbd5095d4c1197b$var$SR_REMOVAL_DELAY = 90;
function $7bbd5095d4c1197b$var$Live(Splide2, Components2, options) {
    var mount = function mount() {
        if (enabled) {
            disable(!Components2.Autoplay.isPaused());
            $7bbd5095d4c1197b$var$setAttribute(track, $7bbd5095d4c1197b$var$ARIA_ATOMIC, true);
            sr.textContent = "…";
            on($7bbd5095d4c1197b$export$23663268a31b79e2, $7bbd5095d4c1197b$var$apply(disable, true));
            on($7bbd5095d4c1197b$export$16a1e4f3d0368265, $7bbd5095d4c1197b$var$apply(disable, false));
            on([
                $7bbd5095d4c1197b$export$fe5802204b967f0d,
                $7bbd5095d4c1197b$export$ff8164bff3202b9
            ], $7bbd5095d4c1197b$var$apply(toggle, true));
        }
    };
    var toggle = function toggle(active) {
        $7bbd5095d4c1197b$var$setAttribute(track, $7bbd5095d4c1197b$var$ARIA_BUSY, active);
        if (active) {
            $7bbd5095d4c1197b$var$append(track, sr);
            interval.start();
        } else {
            $7bbd5095d4c1197b$var$remove(sr);
            interval.cancel();
        }
    };
    var destroy = function destroy() {
        $7bbd5095d4c1197b$var$removeAttribute(track, [
            $7bbd5095d4c1197b$var$ARIA_LIVE,
            $7bbd5095d4c1197b$var$ARIA_ATOMIC,
            $7bbd5095d4c1197b$var$ARIA_BUSY
        ]);
        $7bbd5095d4c1197b$var$remove(sr);
    };
    var disable = function disable(disabled) {
        if (enabled) $7bbd5095d4c1197b$var$setAttribute(track, $7bbd5095d4c1197b$var$ARIA_LIVE, disabled ? "off" : "polite");
    };
    var _EventInterface13 = $7bbd5095d4c1197b$export$f188226459c8a3ff(Splide2), on = _EventInterface13.on;
    var track = Components2.Elements.track;
    var enabled = options.live && !options.isNavigation;
    var sr = $7bbd5095d4c1197b$var$create("span", $7bbd5095d4c1197b$export$bb78d7c200da8960);
    var interval = $7bbd5095d4c1197b$export$46ad21b25b6dccf0($7bbd5095d4c1197b$var$SR_REMOVAL_DELAY, $7bbd5095d4c1197b$var$apply(toggle, false));
    return {
        mount: mount,
        disable: disable,
        destroy: destroy
    };
}
var $7bbd5095d4c1197b$var$ComponentConstructors = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Media: $7bbd5095d4c1197b$var$Media,
    Direction: $7bbd5095d4c1197b$var$Direction,
    Elements: $7bbd5095d4c1197b$var$Elements,
    Slides: $7bbd5095d4c1197b$var$Slides,
    Layout: $7bbd5095d4c1197b$var$Layout,
    Clones: $7bbd5095d4c1197b$var$Clones,
    Move: $7bbd5095d4c1197b$var$Move,
    Controller: $7bbd5095d4c1197b$var$Controller,
    Arrows: $7bbd5095d4c1197b$var$Arrows,
    Autoplay: $7bbd5095d4c1197b$var$Autoplay,
    Cover: $7bbd5095d4c1197b$var$Cover,
    Scroll: $7bbd5095d4c1197b$var$Scroll,
    Drag: $7bbd5095d4c1197b$var$Drag,
    Keyboard: $7bbd5095d4c1197b$var$Keyboard,
    LazyLoad: $7bbd5095d4c1197b$var$LazyLoad,
    Pagination: $7bbd5095d4c1197b$var$Pagination,
    Sync: $7bbd5095d4c1197b$var$Sync,
    Wheel: $7bbd5095d4c1197b$var$Wheel,
    Live: $7bbd5095d4c1197b$var$Live
});
var $7bbd5095d4c1197b$var$I18N = {
    prev: "Previous slide",
    next: "Next slide",
    first: "Go to first slide",
    last: "Go to last slide",
    slideX: "Go to slide %s",
    pageX: "Go to page %s",
    play: "Start autoplay",
    pause: "Pause autoplay",
    carousel: "carousel",
    slide: "slide",
    select: "Select a slide to show",
    slideLabel: "%s of %s"
};
var $7bbd5095d4c1197b$export$f484e977a69c6ba6 = {
    type: "slide",
    role: "region",
    speed: 400,
    perPage: 1,
    cloneStatus: true,
    arrows: true,
    pagination: true,
    paginationKeyboard: true,
    interval: 5e3,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: true,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    drag: true,
    direction: "ltr",
    trimSpace: true,
    focusableNodes: "a, button, textarea, input, select, iframe",
    live: true,
    classes: $7bbd5095d4c1197b$export$ba41d43e4a419565,
    i18n: $7bbd5095d4c1197b$var$I18N,
    reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: "pause"
    }
};
function $7bbd5095d4c1197b$var$Fade(Splide2, Components2, options) {
    var mount = function mount() {
        $7bbd5095d4c1197b$export$f188226459c8a3ff(Splide2).on([
            $7bbd5095d4c1197b$export$d300dc1a2634364b,
            $7bbd5095d4c1197b$export$7f4701ac5e05e39f
        ], init);
    };
    var init = function init() {
        _$Slides.forEach(function(Slide) {
            Slide.style("transform", "translateX(-" + 100 * Slide.index + "%)");
        });
    };
    var start = function start(index, done) {
        _$Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);
        $7bbd5095d4c1197b$var$nextTick(done);
    };
    var _$Slides = Components2.Slides;
    return {
        mount: mount,
        start: start,
        cancel: $7bbd5095d4c1197b$var$noop
    };
}
function $7bbd5095d4c1197b$var$Slide(Splide2, Components2, options) {
    var mount = function mount() {
        $7bbd5095d4c1197b$export$f188226459c8a3ff(Splide2).bind(list, "transitionend", function(e) {
            if (e.target === list && endCallback) {
                cancel();
                endCallback();
            }
        });
    };
    var start = function start(index, done) {
        var destination = _$Move.toPosition(index, true);
        var position = _$Move.getPosition();
        var speed = getSpeed(index);
        if ($7bbd5095d4c1197b$var$abs(destination - position) >= 1 && speed >= 1) {
            if (options.useScroll) _$Scroll.scroll(destination, speed, false, done);
            else {
                transition("transform " + speed + "ms " + options.easing);
                _$Move.translate(destination, true);
                endCallback = done;
            }
        } else {
            _$Move.jump(index);
            done();
        }
    };
    var cancel = function cancel() {
        transition("");
        _$Scroll.cancel();
    };
    var getSpeed = function getSpeed(index) {
        var rewindSpeed = options.rewindSpeed;
        if (Splide2.is($7bbd5095d4c1197b$export$e5a58a5ee5b54c22) && rewindSpeed) {
            var prev = _$Controller.getIndex(true);
            var end = _$Controller.getEnd();
            if (prev === 0 && index >= end || prev >= end && index === 0) return rewindSpeed;
        }
        return options.speed;
    };
    var _$Move = Components2.Move, _$Controller = Components2.Controller, _$Scroll = Components2.Scroll;
    var list = Components2.Elements.list;
    var transition = $7bbd5095d4c1197b$var$apply($7bbd5095d4c1197b$var$style, list, "transition");
    var endCallback;
    return {
        mount: mount,
        start: start,
        cancel: cancel
    };
}
var $7bbd5095d4c1197b$var$_Splide = /*#__PURE__*/ function() {
    function _Splide(target, options) {
        this.event = $7bbd5095d4c1197b$export$f188226459c8a3ff();
        this.Components = {};
        this.state = $7bbd5095d4c1197b$export$7254cc27399e90bd($7bbd5095d4c1197b$var$CREATED);
        this.splides = [];
        this._o = {};
        this._E = {};
        var root = $7bbd5095d4c1197b$var$isString(target) ? $7bbd5095d4c1197b$var$query(document, target) : target;
        $7bbd5095d4c1197b$var$assert(root, root + " is invalid.");
        this.root = root;
        options = $7bbd5095d4c1197b$var$merge({
            label: $7bbd5095d4c1197b$var$getAttribute(root, $7bbd5095d4c1197b$var$ARIA_LABEL) || "",
            labelledby: $7bbd5095d4c1197b$var$getAttribute(root, $7bbd5095d4c1197b$var$ARIA_LABELLEDBY) || ""
        }, $7bbd5095d4c1197b$export$f484e977a69c6ba6, _Splide.defaults, options || {});
        try {
            $7bbd5095d4c1197b$var$merge(options, JSON.parse($7bbd5095d4c1197b$var$getAttribute(root, $7bbd5095d4c1197b$var$DATA_ATTRIBUTE)));
        } catch (e) {
            $7bbd5095d4c1197b$var$assert(false, "Invalid JSON");
        }
        this._o = Object.create($7bbd5095d4c1197b$var$merge({}, options));
    }
    var _proto = _Splide.prototype;
    _proto.mount = function mount(Extensions, Transition) {
        var _this = this;
        var state = this.state, Components2 = this.Components;
        $7bbd5095d4c1197b$var$assert(state.is([
            $7bbd5095d4c1197b$var$CREATED,
            $7bbd5095d4c1197b$var$DESTROYED
        ]), "Already mounted!");
        state.set($7bbd5095d4c1197b$var$CREATED);
        this._C = Components2;
        this._T = Transition || this._T || (this.is($7bbd5095d4c1197b$export$742b62a5690c060) ? $7bbd5095d4c1197b$var$Fade : $7bbd5095d4c1197b$var$Slide);
        this._E = Extensions || this._E;
        var Constructors = $7bbd5095d4c1197b$var$assign({}, $7bbd5095d4c1197b$var$ComponentConstructors, this._E, {
            Transition: this._T
        });
        $7bbd5095d4c1197b$var$forOwn(Constructors, function(Component, key) {
            var component = Component(_this, Components2, _this._o);
            Components2[key] = component;
            component.setup && component.setup();
        });
        $7bbd5095d4c1197b$var$forOwn(Components2, function(component) {
            component.mount && component.mount();
        });
        this.emit($7bbd5095d4c1197b$export$d300dc1a2634364b);
        $7bbd5095d4c1197b$var$addClass(this.root, $7bbd5095d4c1197b$export$7761661e2d5b9388);
        state.set($7bbd5095d4c1197b$var$IDLE);
        this.emit($7bbd5095d4c1197b$export$d8dac49b4532735a);
        return this;
    };
    _proto.sync = function sync(splide) {
        this.splides.push({
            splide: splide
        });
        splide.splides.push({
            splide: this,
            isParent: true
        });
        if (this.state.is($7bbd5095d4c1197b$var$IDLE)) {
            this._C.Sync.remount();
            splide.Components.Sync.remount();
        }
        return this;
    };
    _proto.go = function go(control) {
        this._C.Controller.go(control);
        return this;
    };
    _proto.on = function on(events, callback) {
        this.event.on(events, callback);
        return this;
    };
    _proto.off = function off(events) {
        this.event.off(events);
        return this;
    };
    _proto.emit = function emit(event) {
        var _this$event;
        (_this$event = this.event).emit.apply(_this$event, [
            event
        ].concat($7bbd5095d4c1197b$var$slice(arguments, 1)));
        return this;
    };
    _proto.add = function add(slides, index) {
        this._C.Slides.add(slides, index);
        return this;
    };
    _proto.remove = function remove(matcher) {
        this._C.Slides.remove(matcher);
        return this;
    };
    _proto.is = function is(type) {
        return this._o.type === type;
    };
    _proto.refresh = function refresh() {
        this.emit($7bbd5095d4c1197b$export$7f4701ac5e05e39f);
        return this;
    };
    _proto.destroy = function destroy(completely) {
        if (completely === void 0) completely = true;
        var event = this.event, state = this.state;
        if (state.is($7bbd5095d4c1197b$var$CREATED)) $7bbd5095d4c1197b$export$f188226459c8a3ff(this).on($7bbd5095d4c1197b$export$d8dac49b4532735a, this.destroy.bind(this, completely));
        else {
            $7bbd5095d4c1197b$var$forOwn(this._C, function(component) {
                component.destroy && component.destroy(completely);
            }, true);
            event.emit($7bbd5095d4c1197b$export$88c4cf7419e470cd);
            event.destroy();
            completely && $7bbd5095d4c1197b$var$empty(this.splides);
            state.set($7bbd5095d4c1197b$var$DESTROYED);
        }
        return this;
    };
    $7bbd5095d4c1197b$var$_createClass(_Splide, [
        {
            key: "options",
            get: function get() {
                return this._o;
            },
            set: function set(options) {
                this._C.Media.set(options, true, true);
            }
        },
        {
            key: "length",
            get: function get() {
                return this._C.Slides.getLength(true);
            }
        },
        {
            key: "index",
            get: function get() {
                return this._C.Controller.getIndex();
            }
        }
    ]);
    return _Splide;
}();
var $7bbd5095d4c1197b$export$24494c7438c070bf = $7bbd5095d4c1197b$var$_Splide;
$7bbd5095d4c1197b$export$24494c7438c070bf.defaults = {};
$7bbd5095d4c1197b$export$24494c7438c070bf.STATES = $7bbd5095d4c1197b$var$STATES;
var $7bbd5095d4c1197b$var$CLASS_RENDERED = "is-rendered";
var $7bbd5095d4c1197b$var$RENDERER_DEFAULT_CONFIG = {
    listTag: "ul",
    slideTag: "li"
};
var $7bbd5095d4c1197b$var$Style = /*#__PURE__*/ function() {
    var Style = function Style(id, options) {
        this.styles = {};
        this.id = id;
        this.options = options;
    };
    var _proto2 = Style.prototype;
    _proto2.rule = function rule(selector, prop, value, breakpoint) {
        breakpoint = breakpoint || "default";
        var selectors = this.styles[breakpoint] = this.styles[breakpoint] || {};
        var styles = selectors[selector] = selectors[selector] || {};
        styles[prop] = value;
    };
    _proto2.build = function build() {
        var _this2 = this;
        var css = "";
        if (this.styles["default"]) css += this.buildSelectors(this.styles["default"]);
        Object.keys(this.styles).sort(function(n, m) {
            return _this2.options.mediaQuery === "min" ? +n - +m : +m - +n;
        }).forEach(function(breakpoint) {
            if (breakpoint !== "default") {
                css += "@media screen and (max-width: " + breakpoint + "px) {";
                css += _this2.buildSelectors(_this2.styles[breakpoint]);
                css += "}";
            }
        });
        return css;
    };
    _proto2.buildSelectors = function buildSelectors(selectors) {
        var _this3 = this;
        var css = "";
        $7bbd5095d4c1197b$var$forOwn(selectors, function(styles, selector) {
            selector = ("#" + _this3.id + " " + selector).trim();
            css += selector + " {";
            $7bbd5095d4c1197b$var$forOwn(styles, function(value, prop) {
                if (value || value === 0) css += prop + ": " + value + ";";
            });
            css += "}";
        });
        return css;
    };
    return Style;
}();
var $7bbd5095d4c1197b$export$c0daaea79e41d7df = /*#__PURE__*/ function() {
    var SplideRenderer = function SplideRenderer(contents, options, config, defaults) {
        this.slides = [];
        this.options = {};
        this.breakpoints = [];
        $7bbd5095d4c1197b$var$merge($7bbd5095d4c1197b$export$f484e977a69c6ba6, defaults || {});
        $7bbd5095d4c1197b$var$merge($7bbd5095d4c1197b$var$merge(this.options, $7bbd5095d4c1197b$export$f484e977a69c6ba6), options || {});
        this.contents = contents;
        this.config = $7bbd5095d4c1197b$var$assign({}, $7bbd5095d4c1197b$var$RENDERER_DEFAULT_CONFIG, config || {});
        this.id = this.config.id || $7bbd5095d4c1197b$var$uniqueId("splide");
        this.Style = new $7bbd5095d4c1197b$var$Style(this.id, this.options);
        this.Direction = $7bbd5095d4c1197b$var$Direction(null, null, this.options);
        $7bbd5095d4c1197b$var$assert(this.contents.length, "Provide at least 1 content.");
        this.init();
    };
    SplideRenderer.clean = function clean(splide) {
        var _EventInterface14 = $7bbd5095d4c1197b$export$f188226459c8a3ff(splide), on = _EventInterface14.on;
        var root = splide.root;
        var clones = $7bbd5095d4c1197b$var$queryAll(root, "." + $7bbd5095d4c1197b$export$2c1ba4a4f1aa4947);
        on($7bbd5095d4c1197b$export$d300dc1a2634364b, function() {
            $7bbd5095d4c1197b$var$remove($7bbd5095d4c1197b$var$child(root, "style"));
        });
        $7bbd5095d4c1197b$var$remove(clones);
    };
    var _proto3 = SplideRenderer.prototype;
    _proto3.init = function init() {
        this.parseBreakpoints();
        this.initSlides();
        this.registerRootStyles();
        this.registerTrackStyles();
        this.registerSlideStyles();
        this.registerListStyles();
    };
    _proto3.initSlides = function initSlides() {
        var _this4 = this;
        $7bbd5095d4c1197b$var$push(this.slides, this.contents.map(function(content, index) {
            content = $7bbd5095d4c1197b$var$isString(content) ? {
                html: content
            } : content;
            content.styles = content.styles || {};
            content.attrs = content.attrs || {};
            _this4.cover(content);
            var classes = _this4.options.classes.slide + " " + (index === 0 ? $7bbd5095d4c1197b$export$72d36ecf3758cb4b : "");
            $7bbd5095d4c1197b$var$assign(content.attrs, {
                "class": (classes + " " + (content.attrs["class"] || "")).trim(),
                style: _this4.buildStyles(content.styles)
            });
            return content;
        }));
        if (this.isLoop()) this.generateClones(this.slides);
    };
    _proto3.registerRootStyles = function registerRootStyles() {
        var _this5 = this;
        this.breakpoints.forEach(function(_ref2) {
            var width = _ref2[0], options = _ref2[1];
            _this5.Style.rule(" ", "max-width", $7bbd5095d4c1197b$var$unit(options.width), width);
        });
    };
    _proto3.registerTrackStyles = function registerTrackStyles() {
        var _this6 = this;
        var Style2 = this.Style;
        var selector = "." + $7bbd5095d4c1197b$export$7738b09ac0a98952;
        this.breakpoints.forEach(function(_ref3) {
            var width = _ref3[0], options = _ref3[1];
            Style2.rule(selector, _this6.resolve("paddingLeft"), _this6.cssPadding(options, false), width);
            Style2.rule(selector, _this6.resolve("paddingRight"), _this6.cssPadding(options, true), width);
            Style2.rule(selector, "height", _this6.cssTrackHeight(options), width);
        });
    };
    _proto3.registerListStyles = function registerListStyles() {
        var _this7 = this;
        var Style2 = this.Style;
        var selector = "." + $7bbd5095d4c1197b$export$19cc2a5451235cae;
        this.breakpoints.forEach(function(_ref4) {
            var width = _ref4[0], options = _ref4[1];
            Style2.rule(selector, "transform", _this7.buildTranslate(options), width);
            if (!_this7.cssSlideHeight(options)) Style2.rule(selector, "aspect-ratio", _this7.cssAspectRatio(options), width);
        });
    };
    _proto3.registerSlideStyles = function registerSlideStyles() {
        var _this8 = this;
        var Style2 = this.Style;
        var selector = "." + $7bbd5095d4c1197b$export$8d922915837a38d3;
        this.breakpoints.forEach(function(_ref5) {
            var width = _ref5[0], options = _ref5[1];
            Style2.rule(selector, "width", _this8.cssSlideWidth(options), width);
            Style2.rule(selector, "height", _this8.cssSlideHeight(options) || "100%", width);
            Style2.rule(selector, _this8.resolve("marginRight"), $7bbd5095d4c1197b$var$unit(options.gap) || "0px", width);
            Style2.rule(selector + " > img", "display", options.cover ? "none" : "inline", width);
        });
    };
    _proto3.buildTranslate = function buildTranslate(options) {
        var _this$Direction = this.Direction, resolve = _this$Direction.resolve, orient = _this$Direction.orient;
        var values = [];
        values.push(this.cssOffsetClones(options));
        values.push(this.cssOffsetGaps(options));
        if (this.isCenter(options)) {
            values.push(this.buildCssValue(orient(-50), "%"));
            values.push.apply(values, this.cssOffsetCenter(options));
        }
        return values.filter(Boolean).map(function(value) {
            return "translate" + resolve("X") + "(" + value + ")";
        }).join(" ");
    };
    _proto3.cssOffsetClones = function cssOffsetClones(options) {
        var _this$Direction2 = this.Direction, resolve = _this$Direction2.resolve, orient = _this$Direction2.orient;
        var cloneCount = this.getCloneCount();
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue.value, unit2 = _this$parseCssValue.unit;
            return this.buildCssValue(orient(value) * cloneCount, unit2);
        }
        var percent = 100 * cloneCount / options.perPage;
        return orient(percent) + "%";
    };
    _proto3.cssOffsetCenter = function cssOffsetCenter(options) {
        var _this$Direction3 = this.Direction, resolve = _this$Direction3.resolve, orient = _this$Direction3.orient;
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue2 = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue2.value, unit2 = _this$parseCssValue2.unit;
            return [
                this.buildCssValue(orient(value / 2), unit2)
            ];
        }
        var values = [];
        var perPage = options.perPage, gap = options.gap;
        values.push(orient(50 / perPage) + "%");
        if (gap) {
            var _this$parseCssValue3 = this.parseCssValue(gap), _value = _this$parseCssValue3.value, _unit = _this$parseCssValue3.unit;
            var gapOffset = (_value / perPage - _value) / 2;
            values.push(this.buildCssValue(orient(gapOffset), _unit));
        }
        return values;
    };
    _proto3.cssOffsetGaps = function cssOffsetGaps(options) {
        var cloneCount = this.getCloneCount();
        if (cloneCount && options.gap) {
            var orient = this.Direction.orient;
            var _this$parseCssValue4 = this.parseCssValue(options.gap), value = _this$parseCssValue4.value, unit2 = _this$parseCssValue4.unit;
            if (this.isFixedWidth(options)) return this.buildCssValue(orient(value * cloneCount), unit2);
            var perPage = options.perPage;
            var gaps = cloneCount / perPage;
            return this.buildCssValue(orient(gaps * value), unit2);
        }
        return "";
    };
    _proto3.resolve = function resolve(prop) {
        return $7bbd5095d4c1197b$var$camelToKebab(this.Direction.resolve(prop));
    };
    _proto3.cssPadding = function cssPadding(options, right) {
        var padding = options.padding;
        var prop = this.Direction.resolve(right ? "right" : "left", true);
        return padding && $7bbd5095d4c1197b$var$unit(padding[prop] || ($7bbd5095d4c1197b$var$isObject(padding) ? 0 : padding)) || "0px";
    };
    _proto3.cssTrackHeight = function cssTrackHeight(options) {
        var height = "";
        if (this.isVertical()) {
            height = this.cssHeight(options);
            $7bbd5095d4c1197b$var$assert(height, '"height" is missing.');
            height = "calc(" + height + " - " + this.cssPadding(options, false) + " - " + this.cssPadding(options, true) + ")";
        }
        return height;
    };
    _proto3.cssHeight = function cssHeight(options) {
        return $7bbd5095d4c1197b$var$unit(options.height);
    };
    _proto3.cssSlideWidth = function cssSlideWidth(options) {
        return options.autoWidth ? "" : $7bbd5095d4c1197b$var$unit(options.fixedWidth) || (this.isVertical() ? "" : this.cssSlideSize(options));
    };
    _proto3.cssSlideHeight = function cssSlideHeight(options) {
        return $7bbd5095d4c1197b$var$unit(options.fixedHeight) || (this.isVertical() ? options.autoHeight ? "" : this.cssSlideSize(options) : this.cssHeight(options));
    };
    _proto3.cssSlideSize = function cssSlideSize(options) {
        var gap = $7bbd5095d4c1197b$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    };
    _proto3.cssAspectRatio = function cssAspectRatio(options) {
        var heightRatio = options.heightRatio;
        return heightRatio ? "" + 1 / heightRatio : "";
    };
    _proto3.buildCssValue = function buildCssValue(value, unit2) {
        return "" + value + unit2;
    };
    _proto3.parseCssValue = function parseCssValue(value) {
        if ($7bbd5095d4c1197b$var$isString(value)) {
            var number = parseFloat(value) || 0;
            var unit2 = value.replace(/\d*(\.\d*)?/, "") || "px";
            return {
                value: number,
                unit: unit2
            };
        }
        return {
            value: value,
            unit: "px"
        };
    };
    _proto3.parseBreakpoints = function parseBreakpoints() {
        var _this9 = this;
        var breakpoints = this.options.breakpoints;
        this.breakpoints.push([
            "default",
            this.options
        ]);
        if (breakpoints) $7bbd5095d4c1197b$var$forOwn(breakpoints, function(options, width) {
            _this9.breakpoints.push([
                width,
                $7bbd5095d4c1197b$var$merge($7bbd5095d4c1197b$var$merge({}, _this9.options), options)
            ]);
        });
    };
    _proto3.isFixedWidth = function isFixedWidth(options) {
        return !!options[this.Direction.resolve("fixedWidth")];
    };
    _proto3.isLoop = function isLoop() {
        return this.options.type === $7bbd5095d4c1197b$export$f42383286ed1223d;
    };
    _proto3.isCenter = function isCenter(options) {
        if (options.focus === "center") {
            if (this.isLoop()) return true;
            if (this.options.type === $7bbd5095d4c1197b$export$e5a58a5ee5b54c22) return !this.options.trimSpace;
        }
        return false;
    };
    _proto3.isVertical = function isVertical() {
        return this.options.direction === $7bbd5095d4c1197b$export$97170d9824b89709;
    };
    _proto3.buildClasses = function buildClasses() {
        var options = this.options;
        return [
            $7bbd5095d4c1197b$export$93b21159ad85c843,
            $7bbd5095d4c1197b$export$93b21159ad85c843 + "--" + options.type,
            $7bbd5095d4c1197b$export$93b21159ad85c843 + "--" + options.direction,
            options.drag && $7bbd5095d4c1197b$export$93b21159ad85c843 + "--draggable",
            options.isNavigation && $7bbd5095d4c1197b$export$93b21159ad85c843 + "--nav",
            $7bbd5095d4c1197b$export$72d36ecf3758cb4b,
            !this.config.hidden && $7bbd5095d4c1197b$var$CLASS_RENDERED
        ].filter(Boolean).join(" ");
    };
    _proto3.buildAttrs = function buildAttrs(attrs) {
        var attr = "";
        $7bbd5095d4c1197b$var$forOwn(attrs, function(value, key) {
            attr += value ? " " + $7bbd5095d4c1197b$var$camelToKebab(key) + '="' + value + '"' : "";
        });
        return attr.trim();
    };
    _proto3.buildStyles = function buildStyles(styles) {
        var style = "";
        $7bbd5095d4c1197b$var$forOwn(styles, function(value, key) {
            style += " " + $7bbd5095d4c1197b$var$camelToKebab(key) + ":" + value + ";";
        });
        return style.trim();
    };
    _proto3.renderSlides = function renderSlides() {
        var _this10 = this;
        var tag = this.config.slideTag;
        return this.slides.map(function(content) {
            return "<" + tag + " " + _this10.buildAttrs(content.attrs) + ">" + (content.html || "") + "</" + tag + ">";
        }).join("");
    };
    _proto3.cover = function cover(content) {
        var styles = content.styles, _content$html = content.html, html = _content$html === void 0 ? "" : _content$html;
        if (this.options.cover && !this.options.lazyLoad) {
            var src = html.match(/<img.*?src\s*=\s*(['"])(.+?)\1.*?>/);
            if (src && src[2]) styles.background = "center/cover no-repeat url('" + src[2] + "')";
        }
    };
    _proto3.generateClones = function generateClones(contents) {
        var classes = this.options.classes;
        var count = this.getCloneCount();
        var slides = contents.slice();
        while(slides.length < count)$7bbd5095d4c1197b$var$push(slides, slides);
        $7bbd5095d4c1197b$var$push(slides.slice(-count).reverse(), slides.slice(0, count)).forEach(function(content, index) {
            var attrs = $7bbd5095d4c1197b$var$assign({}, content.attrs, {
                "class": content.attrs["class"] + " " + classes.clone
            });
            var clone = $7bbd5095d4c1197b$var$assign({}, content, {
                attrs: attrs
            });
            index < count ? contents.unshift(clone) : contents.push(clone);
        });
    };
    _proto3.getCloneCount = function getCloneCount() {
        if (this.isLoop()) {
            var options = this.options;
            if (options.clones) return options.clones;
            var perPage = $7bbd5095d4c1197b$var$max.apply(void 0, this.breakpoints.map(function(_ref6) {
                var options2 = _ref6[1];
                return options2.perPage;
            }));
            return perPage * ((options.flickMaxPages || 1) + 1);
        }
        return 0;
    };
    _proto3.renderArrows = function renderArrows() {
        var html = "";
        html += '<div class="' + this.options.classes.arrows + '">';
        html += this.renderArrow(true);
        html += this.renderArrow(false);
        html += "</div>";
        return html;
    };
    _proto3.renderArrow = function renderArrow(prev) {
        var _this$options = this.options, classes = _this$options.classes, i18n = _this$options.i18n;
        var attrs = {
            "class": classes.arrow + " " + (prev ? classes.prev : classes.next),
            type: "button",
            ariaLabel: prev ? i18n.prev : i18n.next
        };
        return "<button " + this.buildAttrs(attrs) + '><svg xmlns="' + $7bbd5095d4c1197b$var$XML_NAME_SPACE + '" viewBox="0 0 ' + $7bbd5095d4c1197b$var$SIZE + " " + $7bbd5095d4c1197b$var$SIZE + '" width="' + $7bbd5095d4c1197b$var$SIZE + '" height="' + $7bbd5095d4c1197b$var$SIZE + '"><path d="' + (this.options.arrowPath || $7bbd5095d4c1197b$var$PATH) + '" /></svg></button>';
    };
    _proto3.html = function html() {
        var _this$config = this.config, rootClass = _this$config.rootClass, listTag = _this$config.listTag, arrows = _this$config.arrows, beforeTrack = _this$config.beforeTrack, afterTrack = _this$config.afterTrack, slider = _this$config.slider, beforeSlider = _this$config.beforeSlider, afterSlider = _this$config.afterSlider;
        var html = "";
        html += '<div id="' + this.id + '" class="' + this.buildClasses() + " " + (rootClass || "") + '">';
        html += "<style>" + this.Style.build() + "</style>";
        if (slider) {
            html += beforeSlider || "";
            html += '<div class="splide__slider">';
        }
        html += beforeTrack || "";
        if (arrows) html += this.renderArrows();
        html += '<div class="splide__track">';
        html += "<" + listTag + ' class="splide__list">';
        html += this.renderSlides();
        html += "</" + listTag + ">";
        html += "</div>";
        html += afterTrack || "";
        if (slider) {
            html += "</div>";
            html += afterSlider || "";
        }
        html += "</div>";
        return html;
    };
    return SplideRenderer;
}();


if (document.querySelector(".message")) new (0, $7bbd5095d4c1197b$export$24494c7438c070bf)(".splide", {
    type: "loop",
    autoplay: true,
    arrows: false,
    pagination: false,
    perPage: 1
}).mount();


/*! @license ScrollReveal v4.0.9

	Copyright 2021 Fisssion LLC.

	Licensed under the GNU General Public License 3.0 for
	compatible open source projects and non-commercial use.

	For commercial sites, themes, projects, and applications,
	keep your source code private/proprietary by purchasing
	a commercial license from https://scrollrevealjs.org/
*/ /*! @license Tealight v0.3.6

	Copyright 2018 Fisssion LLC.

	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:

	The above copyright notice and this permission notice shall be included in all
	copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	SOFTWARE.

*/ /*! @license is-dom-node v1.0.4

	Copyright 2018 Fisssion LLC.

	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:

	The above copyright notice and this permission notice shall be included in all
	copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	SOFTWARE.

*/ function $3ad8d678f9d186ab$var$isDomNode(x) {
    return typeof window.Node === "object" ? x instanceof window.Node : x !== null && typeof x === "object" && typeof x.nodeType === "number" && typeof x.nodeName === "string";
}
var $3ad8d678f9d186ab$export$2e2bcd8739ae039 = $3ad8d678f9d186ab$var$isDomNode;


/*! @license is-dom-node-list v1.2.1

	Copyright 2018 Fisssion LLC.

	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:

	The above copyright notice and this permission notice shall be included in all
	copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	SOFTWARE.

*/ 
function $c379d0eafbc55d24$var$isDomNodeList(x) {
    var prototypeToString = Object.prototype.toString.call(x);
    var regex = /^\[object (HTMLCollection|NodeList|Object)\]$/;
    return typeof window.NodeList === "object" ? x instanceof window.NodeList : x !== null && typeof x === "object" && typeof x.length === "number" && regex.test(prototypeToString) && (x.length === 0 || (0, $3ad8d678f9d186ab$export$2e2bcd8739ae039)(x[0]));
}
var $c379d0eafbc55d24$export$2e2bcd8739ae039 = $c379d0eafbc55d24$var$isDomNodeList;


function $2b977cc170b19cf9$var$tealight(target, context) {
    if (context === void 0) context = document;
    if (target instanceof Array) return target.filter((0, $3ad8d678f9d186ab$export$2e2bcd8739ae039));
    if ((0, $3ad8d678f9d186ab$export$2e2bcd8739ae039)(target)) return [
        target
    ];
    if ((0, $c379d0eafbc55d24$export$2e2bcd8739ae039)(target)) return Array.prototype.slice.call(target);
    if (typeof target === "string") try {
        var query = context.querySelectorAll(target);
        return Array.prototype.slice.call(query);
    } catch (err) {
        return [];
    }
    return [];
}
var $2b977cc170b19cf9$export$2e2bcd8739ae039 = $2b977cc170b19cf9$var$tealight;


/*! @license Rematrix v0.3.0

	Copyright 2018 Julian Lloyd.

	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:

	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
*/ /**
 * @module Rematrix
 */ /**
 * Transformation matrices in the browser come in two flavors:
 *
 *  - `matrix` using 6 values (short)
 *  - `matrix3d` using 16 values (long)
 *
 * This utility follows this [conversion guide](https://goo.gl/EJlUQ1)
 * to expand short form matrices to their equivalent long form.
 *
 * @param  {array} source - Accepts both short and long form matrices.
 * @return {array}
 */ function $81a94c2483c37243$export$d9468344d3651243(source) {
    if (source.constructor !== Array) throw new TypeError("Expected array.");
    if (source.length === 16) return source;
    if (source.length === 6) {
        var matrix = $81a94c2483c37243$export$f0954fd7d5368655();
        matrix[0] = source[0];
        matrix[1] = source[1];
        matrix[4] = source[2];
        matrix[5] = source[3];
        matrix[12] = source[4];
        matrix[13] = source[5];
        return matrix;
    }
    throw new RangeError("Expected array with either 6 or 16 values.");
}
/**
 * Returns a matrix representing no transformation. The product of any matrix
 * multiplied by the identity matrix will be the original matrix.
 *
 * > **Tip:** Similar to how `5 * 1 === 5`, where `1` is the identity.
 *
 * @return {array}
 */ function $81a94c2483c37243$export$f0954fd7d5368655() {
    var matrix = [];
    for(var i = 0; i < 16; i++)i % 5 == 0 ? matrix.push(1) : matrix.push(0);
    return matrix;
}
/**
 * Returns a matrix describing the inverse transformation of the source
 * matrix. The product of any matrix multiplied by its inverse will be the
 * identity matrix.
 *
 * > **Tip:** Similar to how `5 * (1/5) === 1`, where `1/5` is the inverse.
 *
 * @param  {array} source - Accepts both short and long form matrices.
 * @return {array}
 */ function $81a94c2483c37243$export$70ae2c07e401031b(source) {
    var m = $81a94c2483c37243$export$d9468344d3651243(source);
    var s0 = m[0] * m[5] - m[4] * m[1];
    var s1 = m[0] * m[6] - m[4] * m[2];
    var s2 = m[0] * m[7] - m[4] * m[3];
    var s3 = m[1] * m[6] - m[5] * m[2];
    var s4 = m[1] * m[7] - m[5] * m[3];
    var s5 = m[2] * m[7] - m[6] * m[3];
    var c5 = m[10] * m[15] - m[14] * m[11];
    var c4 = m[9] * m[15] - m[13] * m[11];
    var c3 = m[9] * m[14] - m[13] * m[10];
    var c2 = m[8] * m[15] - m[12] * m[11];
    var c1 = m[8] * m[14] - m[12] * m[10];
    var c0 = m[8] * m[13] - m[12] * m[9];
    var determinant = 1 / (s0 * c5 - s1 * c4 + s2 * c3 + s3 * c2 - s4 * c1 + s5 * c0);
    if (isNaN(determinant) || determinant === Infinity) throw new Error("Inverse determinant attempted to divide by zero.");
    return [
        (m[5] * c5 - m[6] * c4 + m[7] * c3) * determinant,
        (-m[1] * c5 + m[2] * c4 - m[3] * c3) * determinant,
        (m[13] * s5 - m[14] * s4 + m[15] * s3) * determinant,
        (-m[9] * s5 + m[10] * s4 - m[11] * s3) * determinant,
        (-m[4] * c5 + m[6] * c2 - m[7] * c1) * determinant,
        (m[0] * c5 - m[2] * c2 + m[3] * c1) * determinant,
        (-m[12] * s5 + m[14] * s2 - m[15] * s1) * determinant,
        (m[8] * s5 - m[10] * s2 + m[11] * s1) * determinant,
        (m[4] * c4 - m[5] * c2 + m[7] * c0) * determinant,
        (-m[0] * c4 + m[1] * c2 - m[3] * c0) * determinant,
        (m[12] * s4 - m[13] * s2 + m[15] * s0) * determinant,
        (-m[8] * s4 + m[9] * s2 - m[11] * s0) * determinant,
        (-m[4] * c3 + m[5] * c1 - m[6] * c0) * determinant,
        (m[0] * c3 - m[1] * c1 + m[2] * c0) * determinant,
        (-m[12] * s3 + m[13] * s1 - m[14] * s0) * determinant,
        (m[8] * s3 - m[9] * s1 + m[10] * s0) * determinant
    ];
}
/**
 * Returns a 4x4 matrix describing the combined transformations
 * of both arguments.
 *
 * > **Note:** Order is very important. For example, rotating 45°
 * along the Z-axis, followed by translating 500 pixels along the
 * Y-axis... is not the same as translating 500 pixels along the
 * Y-axis, followed by rotating 45° along on the Z-axis.
 *
 * @param  {array} m - Accepts both short and long form matrices.
 * @param  {array} x - Accepts both short and long form matrices.
 * @return {array}
 */ function $81a94c2483c37243$export$2060d2db72cce88f(m, x) {
    var fm = $81a94c2483c37243$export$d9468344d3651243(m);
    var fx = $81a94c2483c37243$export$d9468344d3651243(x);
    var product = [];
    for(var i = 0; i < 4; i++){
        var row = [
            fm[i],
            fm[i + 4],
            fm[i + 8],
            fm[i + 12]
        ];
        for(var j = 0; j < 4; j++){
            var k = j * 4;
            var col = [
                fx[k],
                fx[k + 1],
                fx[k + 2],
                fx[k + 3]
            ];
            var result = row[0] * col[0] + row[1] * col[1] + row[2] * col[2] + row[3] * col[3];
            product[i + k] = result;
        }
    }
    return product;
}
/**
 * Attempts to return a 4x4 matrix describing the CSS transform
 * matrix passed in, but will return the identity matrix as a
 * fallback.
 *
 * > **Tip:** This method is used to convert a CSS matrix (retrieved as a
 * `string` from computed styles) to its equivalent array format.
 *
 * @param  {string} source - `matrix` or `matrix3d` CSS Transform value.
 * @return {array}
 */ function $81a94c2483c37243$export$98e6a39c04603d36(source) {
    if (typeof source === "string") {
        var match = source.match(/matrix(3d)?\(([^)]+)\)/);
        if (match) {
            var raw = match[2].split(", ").map(parseFloat);
            return $81a94c2483c37243$export$d9468344d3651243(raw);
        }
    }
    return $81a94c2483c37243$export$f0954fd7d5368655();
}
/**
 * Returns a 4x4 matrix describing Z-axis rotation.
 *
 * > **Tip:** This is just an alias for `Rematrix.rotateZ` for parity with CSS
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $81a94c2483c37243$export$bb628a54ab399bc9(angle) {
    return $81a94c2483c37243$export$ea6eae3365de5b9c(angle);
}
/**
 * Returns a 4x4 matrix describing X-axis rotation.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $81a94c2483c37243$export$a59c8716592e09af(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $81a94c2483c37243$export$f0954fd7d5368655();
    matrix[5] = matrix[10] = Math.cos(theta);
    matrix[6] = matrix[9] = Math.sin(theta);
    matrix[9] *= -1;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis rotation.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $81a94c2483c37243$export$cf71e4d4ca4d1cfd(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $81a94c2483c37243$export$f0954fd7d5368655();
    matrix[0] = matrix[10] = Math.cos(theta);
    matrix[2] = matrix[8] = Math.sin(theta);
    matrix[2] *= -1;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Z-axis rotation.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $81a94c2483c37243$export$ea6eae3365de5b9c(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $81a94c2483c37243$export$f0954fd7d5368655();
    matrix[0] = matrix[5] = Math.cos(theta);
    matrix[1] = matrix[4] = Math.sin(theta);
    matrix[4] *= -1;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing 2D scaling. The first argument
 * is used for both X and Y-axis scaling, unless an optional
 * second argument is provided to explicitly define Y-axis scaling.
 *
 * @param  {number} scalar    - Decimal multiplier.
 * @param  {number} [scalarY] - Decimal multiplier.
 * @return {array}
 */ function $81a94c2483c37243$export$dcdf75081b88279d(scalar, scalarY) {
    var matrix = $81a94c2483c37243$export$f0954fd7d5368655();
    matrix[0] = scalar;
    matrix[5] = typeof scalarY === "number" ? scalarY : scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing X-axis scaling.
 *
 * @param  {number} scalar - Decimal multiplier.
 * @return {array}
 */ function $81a94c2483c37243$export$55295ade51f88202(scalar) {
    var matrix = $81a94c2483c37243$export$f0954fd7d5368655();
    matrix[0] = scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis scaling.
 *
 * @param  {number} scalar - Decimal multiplier.
 * @return {array}
 */ function $81a94c2483c37243$export$2092e2a44ac13bb2(scalar) {
    var matrix = $81a94c2483c37243$export$f0954fd7d5368655();
    matrix[5] = scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Z-axis scaling.
 *
 * @param  {number} scalar - Decimal multiplier.
 * @return {array}
 */ function $81a94c2483c37243$export$13034b1ece9569d5(scalar) {
    var matrix = $81a94c2483c37243$export$f0954fd7d5368655();
    matrix[10] = scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing shear. The first argument
 * defines X-axis shearing, and an optional second argument
 * defines Y-axis shearing.
 *
 * @param  {number} angleX   - Measured in degrees.
 * @param  {number} [angleY] - Measured in degrees.
 * @return {array}
 */ function $81a94c2483c37243$export$dd2d5a892675faf1(angleX, angleY) {
    var thetaX = Math.PI / 180 * angleX;
    var matrix = $81a94c2483c37243$export$f0954fd7d5368655();
    matrix[4] = Math.tan(thetaX);
    if (angleY) {
        var thetaY = Math.PI / 180 * angleY;
        matrix[1] = Math.tan(thetaY);
    }
    return matrix;
}
/**
 * Returns a 4x4 matrix describing X-axis shear.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $81a94c2483c37243$export$e446fc4c2803fd1b(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $81a94c2483c37243$export$f0954fd7d5368655();
    matrix[4] = Math.tan(theta);
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis shear.
 *
 * @param  {number} angle - Measured in degrees
 * @return {array}
 */ function $81a94c2483c37243$export$1649e48e73861f36(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $81a94c2483c37243$export$f0954fd7d5368655();
    matrix[1] = Math.tan(theta);
    return matrix;
}
/**
 * Returns a CSS Transform property value equivalent to the source matrix.
 *
 * @param  {array} source - Accepts both short and long form matrices.
 * @return {string}
 */ function $81a94c2483c37243$export$f84e8e69fd4488a5(source) {
    return "matrix3d(" + $81a94c2483c37243$export$d9468344d3651243(source).join(", ") + ")";
}
/**
 * Returns a 4x4 matrix describing 2D translation. The first
 * argument defines X-axis translation, and an optional second
 * argument defines Y-axis translation.
 *
 * @param  {number} distanceX   - Measured in pixels.
 * @param  {number} [distanceY] - Measured in pixels.
 * @return {array}
 */ function $81a94c2483c37243$export$d73ee8ef04f5226a(distanceX, distanceY) {
    var matrix = $81a94c2483c37243$export$f0954fd7d5368655();
    matrix[12] = distanceX;
    if (distanceY) matrix[13] = distanceY;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing X-axis translation.
 *
 * @param  {number} distance - Measured in pixels.
 * @return {array}
 */ function $81a94c2483c37243$export$5667f2d3f182f284(distance) {
    var matrix = $81a94c2483c37243$export$f0954fd7d5368655();
    matrix[12] = distance;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis translation.
 *
 * @param  {number} distance - Measured in pixels.
 * @return {array}
 */ function $81a94c2483c37243$export$a1f0f3245f0cf0a4(distance) {
    var matrix = $81a94c2483c37243$export$f0954fd7d5368655();
    matrix[13] = distance;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Z-axis translation.
 *
 * @param  {number} distance - Measured in pixels.
 * @return {array}
 */ function $81a94c2483c37243$export$6e43fd17fc519956(distance) {
    var matrix = $81a94c2483c37243$export$f0954fd7d5368655();
    matrix[14] = distance;
    return matrix;
}


/*! @license miniraf v1.0.0

	Copyright 2018 Fisssion LLC.

	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:

	The above copyright notice and this permission notice shall be included in all
	copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	SOFTWARE.

*/ var $ca22651f70a4702e$var$polyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            return $ca22651f70a4702e$var$polyfill(callback);
        }, 0);
    };
}();
var $ca22651f70a4702e$var$index = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $ca22651f70a4702e$var$polyfill;
var $ca22651f70a4702e$export$2e2bcd8739ae039 = $ca22651f70a4702e$var$index;


var $98730e1faeae3dc5$var$defaults = {
    delay: 0,
    distance: "0",
    duration: 600,
    easing: "cubic-bezier(0.5, 0, 0, 1)",
    interval: 0,
    opacity: 0,
    origin: "bottom",
    rotate: {
        x: 0,
        y: 0,
        z: 0
    },
    scale: 1,
    cleanup: false,
    container: document.documentElement,
    desktop: true,
    mobile: true,
    reset: false,
    useDelay: "always",
    viewFactor: 0.0,
    viewOffset: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    },
    afterReset: function afterReset() {},
    afterReveal: function afterReveal() {},
    beforeReset: function beforeReset() {},
    beforeReveal: function beforeReveal() {}
};
function $98730e1faeae3dc5$var$failure() {
    document.documentElement.classList.remove("sr");
    return {
        clean: function clean() {},
        destroy: function destroy() {},
        reveal: function reveal() {},
        sync: function sync() {},
        get noop () {
            return true;
        }
    };
}
function $98730e1faeae3dc5$var$success() {
    document.documentElement.classList.add("sr");
    if (document.body) document.body.style.height = "100%";
    else document.addEventListener("DOMContentLoaded", function() {
        document.body.style.height = "100%";
    });
}
var $98730e1faeae3dc5$var$mount = {
    success: $98730e1faeae3dc5$var$success,
    failure: $98730e1faeae3dc5$var$failure
};
function $98730e1faeae3dc5$var$isObject(x) {
    return x !== null && x instanceof Object && (x.constructor === Object || Object.prototype.toString.call(x) === "[object Object]");
}
function $98730e1faeae3dc5$var$each(collection, callback) {
    if ($98730e1faeae3dc5$var$isObject(collection)) {
        var keys = Object.keys(collection);
        return keys.forEach(function(key) {
            return callback(collection[key], key, collection);
        });
    }
    if (collection instanceof Array) return collection.forEach(function(item, i) {
        return callback(item, i, collection);
    });
    throw new TypeError("Expected either an array or object literal.");
}
function $98730e1faeae3dc5$var$logger(message) {
    var details = [], len = arguments.length - 1;
    while(len-- > 0)details[len] = arguments[len + 1];
    if (this.constructor.debug && console) {
        var report = "%cScrollReveal: " + message;
        details.forEach(function(detail) {
            return report += "\n — " + detail;
        });
        console.log(report, "color: #ea654b;"); // eslint-disable-line no-console
    }
}
function $98730e1faeae3dc5$var$rinse() {
    var this$1 = this;
    var struct = function struct() {
        return {
            active: [],
            stale: []
        };
    };
    var elementIds = struct();
    var sequenceIds = struct();
    var containerIds = struct();
    /**
	 * Take stock of active element IDs.
	 */ try {
        $98730e1faeae3dc5$var$each((0, $2b977cc170b19cf9$export$2e2bcd8739ae039)("[data-sr-id]"), function(node) {
            var id = parseInt(node.getAttribute("data-sr-id"));
            elementIds.active.push(id);
        });
    } catch (e) {
        throw e;
    }
    /**
	 * Destroy stale elements.
	 */ $98730e1faeae3dc5$var$each(this.store.elements, function(element) {
        if (elementIds.active.indexOf(element.id) === -1) elementIds.stale.push(element.id);
    });
    $98730e1faeae3dc5$var$each(elementIds.stale, function(staleId) {
        return delete this$1.store.elements[staleId];
    });
    /**
	 * Take stock of active container and sequence IDs.
	 */ $98730e1faeae3dc5$var$each(this.store.elements, function(element) {
        if (containerIds.active.indexOf(element.containerId) === -1) containerIds.active.push(element.containerId);
        if (element.hasOwnProperty("sequence")) {
            if (sequenceIds.active.indexOf(element.sequence.id) === -1) sequenceIds.active.push(element.sequence.id);
        }
    });
    /**
	 * Destroy stale containers.
	 */ $98730e1faeae3dc5$var$each(this.store.containers, function(container) {
        if (containerIds.active.indexOf(container.id) === -1) containerIds.stale.push(container.id);
    });
    $98730e1faeae3dc5$var$each(containerIds.stale, function(staleId) {
        var stale = this$1.store.containers[staleId].node;
        stale.removeEventListener("scroll", this$1.delegate);
        stale.removeEventListener("resize", this$1.delegate);
        delete this$1.store.containers[staleId];
    });
    /**
	 * Destroy stale sequences.
	 */ $98730e1faeae3dc5$var$each(this.store.sequences, function(sequence) {
        if (sequenceIds.active.indexOf(sequence.id) === -1) sequenceIds.stale.push(sequence.id);
    });
    $98730e1faeae3dc5$var$each(sequenceIds.stale, function(staleId) {
        return delete this$1.store.sequences[staleId];
    });
}
var $98730e1faeae3dc5$var$getPrefixedCssProp = function() {
    var getPrefixedCssProperty = function getPrefixedCssProperty(name, source) {
        if (source === void 0) source = style;
        if (name && typeof name === "string") {
            if (properties[name]) return properties[name];
            if (typeof source[name] === "string") return properties[name] = name;
            if (typeof source["-webkit-" + name] === "string") return properties[name] = "-webkit-" + name;
            throw new RangeError('Unable to find "' + name + '" style property.');
        }
        throw new TypeError("Expected a string.");
    };
    var properties = {};
    var style = document.documentElement.style;
    getPrefixedCssProperty.clearCache = function() {
        return properties = {};
    };
    return getPrefixedCssProperty;
}();
function $98730e1faeae3dc5$var$style(element) {
    var computed = window.getComputedStyle(element.node);
    var position = computed.position;
    var config = element.config;
    /**
	 * Generate inline styles
	 */ var inline = {};
    var inlineStyle = element.node.getAttribute("style") || "";
    var inlineMatch = inlineStyle.match(/[\w-]+\s*:\s*[^;]+\s*/gi) || [];
    inline.computed = inlineMatch ? inlineMatch.map(function(m) {
        return m.trim();
    }).join("; ") + ";" : "";
    inline.generated = inlineMatch.some(function(m) {
        return m.match(/visibility\s?:\s?visible/i);
    }) ? inline.computed : inlineMatch.concat([
        "visibility: visible"
    ]).map(function(m) {
        return m.trim();
    }).join("; ") + ";";
    /**
	 * Generate opacity styles
	 */ var computedOpacity = parseFloat(computed.opacity);
    var configOpacity = !isNaN(parseFloat(config.opacity)) ? parseFloat(config.opacity) : parseFloat(computed.opacity);
    var opacity = {
        computed: computedOpacity !== configOpacity ? "opacity: " + computedOpacity + ";" : "",
        generated: computedOpacity !== configOpacity ? "opacity: " + configOpacity + ";" : ""
    };
    /**
	 * Generate transformation styles
	 */ var transformations = [];
    if (parseFloat(config.distance)) {
        var axis = config.origin === "top" || config.origin === "bottom" ? "Y" : "X";
        /**
		 * Let’s make sure our our pixel distances are negative for top and left.
		 * e.g. { origin: 'top', distance: '25px' } starts at `top: -25px` in CSS.
		 */ var distance = config.distance;
        if (config.origin === "top" || config.origin === "left") distance = /^-/.test(distance) ? distance.substr(1) : "-" + distance;
        var ref = distance.match(/(^-?\d+\.?\d?)|(em$|px$|%$)/g);
        var value = ref[0];
        var unit = ref[1];
        switch(unit){
            case "em":
                distance = parseInt(computed.fontSize) * value;
                break;
            case "px":
                distance = value;
                break;
            case "%":
                /**
				 * Here we use `getBoundingClientRect` instead of
				 * the existing data attached to `element.geometry`
				 * because only the former includes any transformations
				 * current applied to the element.
				 *
				 * If that behavior ends up being unintuitive, this
				 * logic could instead utilize `element.geometry.height`
				 * and `element.geoemetry.width` for the distance calculation
				 */ distance = axis === "Y" ? element.node.getBoundingClientRect().height * value / 100 : element.node.getBoundingClientRect().width * value / 100;
                break;
            default:
                throw new RangeError("Unrecognized or missing distance unit.");
        }
        if (axis === "Y") transformations.push((0, $81a94c2483c37243$export$a1f0f3245f0cf0a4)(distance));
        else transformations.push((0, $81a94c2483c37243$export$5667f2d3f182f284)(distance));
    }
    if (config.rotate.x) transformations.push((0, $81a94c2483c37243$export$a59c8716592e09af)(config.rotate.x));
    if (config.rotate.y) transformations.push((0, $81a94c2483c37243$export$cf71e4d4ca4d1cfd)(config.rotate.y));
    if (config.rotate.z) transformations.push((0, $81a94c2483c37243$export$ea6eae3365de5b9c)(config.rotate.z));
    if (config.scale !== 1) {
        if (config.scale === 0) /**
			 * The CSS Transforms matrix interpolation specification
			 * basically disallows transitions of non-invertible
			 * matrixes, which means browsers won't transition
			 * elements with zero scale.
			 *
			 * That’s inconvenient for the API and developer
			 * experience, so we simply nudge their value
			 * slightly above zero; this allows browsers
			 * to transition our element as expected.
			 *
			 * `0.0002` was the smallest number
			 * that performed across browsers.
			 */ transformations.push((0, $81a94c2483c37243$export$dcdf75081b88279d)(0.0002));
        else transformations.push((0, $81a94c2483c37243$export$dcdf75081b88279d)(config.scale));
    }
    var transform = {};
    if (transformations.length) {
        transform.property = $98730e1faeae3dc5$var$getPrefixedCssProp("transform");
        /**
		 * The default computed transform value should be one of:
		 * undefined || 'none' || 'matrix()' || 'matrix3d()'
		 */ transform.computed = {
            raw: computed[transform.property],
            matrix: (0, $81a94c2483c37243$export$98e6a39c04603d36)(computed[transform.property])
        };
        transformations.unshift(transform.computed.matrix);
        var product = transformations.reduce((0, $81a94c2483c37243$export$2060d2db72cce88f));
        transform.generated = {
            initial: transform.property + ": matrix3d(" + product.join(", ") + ");",
            final: transform.property + ": matrix3d(" + transform.computed.matrix.join(", ") + ");"
        };
    } else transform.generated = {
        initial: "",
        final: ""
    };
    /**
	 * Generate transition styles
	 */ var transition = {};
    if (opacity.generated || transform.generated.initial) {
        transition.property = $98730e1faeae3dc5$var$getPrefixedCssProp("transition");
        transition.computed = computed[transition.property];
        transition.fragments = [];
        var delay = config.delay;
        var duration = config.duration;
        var easing = config.easing;
        if (opacity.generated) transition.fragments.push({
            delayed: "opacity " + duration / 1000 + "s " + easing + " " + delay / 1000 + "s",
            instant: "opacity " + duration / 1000 + "s " + easing + " 0s"
        });
        if (transform.generated.initial) transition.fragments.push({
            delayed: transform.property + " " + duration / 1000 + "s " + easing + " " + delay / 1000 + "s",
            instant: transform.property + " " + duration / 1000 + "s " + easing + " 0s"
        });
        /**
		 * The default computed transition property should be undefined, or one of:
		 * '' || 'none 0s ease 0s' || 'all 0s ease 0s' || 'all 0s 0s cubic-bezier()'
		 */ var hasCustomTransition = transition.computed && !transition.computed.match(/all 0s|none 0s/);
        if (hasCustomTransition) transition.fragments.unshift({
            delayed: transition.computed,
            instant: transition.computed
        });
        var composed = transition.fragments.reduce(function(composition, fragment, i) {
            composition.delayed += i === 0 ? fragment.delayed : ", " + fragment.delayed;
            composition.instant += i === 0 ? fragment.instant : ", " + fragment.instant;
            return composition;
        }, {
            delayed: "",
            instant: ""
        });
        transition.generated = {
            delayed: transition.property + ": " + composed.delayed + ";",
            instant: transition.property + ": " + composed.instant + ";"
        };
    } else transition.generated = {
        delayed: "",
        instant: ""
    };
    return {
        inline: inline,
        opacity: opacity,
        position: position,
        transform: transform,
        transition: transition
    };
}
/**
 * apply a CSS string to an element using the CSSOM (element.style) rather
 * than setAttribute, which may violate the content security policy.
 *
 * @param {Node}   [el]  Element to receive styles.
 * @param {string} [declaration] Styles to apply.
 */ function $98730e1faeae3dc5$var$applyStyle(el, declaration) {
    declaration.split(";").forEach(function(pair) {
        var ref = pair.split(":");
        var property = ref[0];
        var value = ref.slice(1);
        if (property && value) el.style[property.trim()] = value.join(":");
    });
}
function $98730e1faeae3dc5$var$clean(target) {
    var this$1 = this;
    var dirty;
    try {
        $98730e1faeae3dc5$var$each((0, $2b977cc170b19cf9$export$2e2bcd8739ae039)(target), function(node) {
            var id = node.getAttribute("data-sr-id");
            if (id !== null) {
                dirty = true;
                var element = this$1.store.elements[id];
                if (element.callbackTimer) window.clearTimeout(element.callbackTimer.clock);
                $98730e1faeae3dc5$var$applyStyle(element.node, element.styles.inline.generated);
                node.removeAttribute("data-sr-id");
                delete this$1.store.elements[id];
            }
        });
    } catch (e) {
        return $98730e1faeae3dc5$var$logger.call(this, "Clean failed.", e.message);
    }
    if (dirty) try {
        $98730e1faeae3dc5$var$rinse.call(this);
    } catch (e) {
        return $98730e1faeae3dc5$var$logger.call(this, "Clean failed.", e.message);
    }
}
function $98730e1faeae3dc5$var$destroy() {
    var this$1 = this;
    /**
	 * Remove all generated styles and element ids
	 */ $98730e1faeae3dc5$var$each(this.store.elements, function(element) {
        $98730e1faeae3dc5$var$applyStyle(element.node, element.styles.inline.generated);
        element.node.removeAttribute("data-sr-id");
    });
    /**
	 * Remove all event listeners.
	 */ $98730e1faeae3dc5$var$each(this.store.containers, function(container) {
        var target = container.node === document.documentElement ? window : container.node;
        target.removeEventListener("scroll", this$1.delegate);
        target.removeEventListener("resize", this$1.delegate);
    });
    /**
	 * Clear all data from the store
	 */ this.store = {
        containers: {},
        elements: {},
        history: [],
        sequences: {}
    };
}
function $98730e1faeae3dc5$var$deepAssign(target) {
    var sources = [], len = arguments.length - 1;
    while(len-- > 0)sources[len] = arguments[len + 1];
    if ($98730e1faeae3dc5$var$isObject(target)) {
        $98730e1faeae3dc5$var$each(sources, function(source) {
            $98730e1faeae3dc5$var$each(source, function(data, key) {
                if ($98730e1faeae3dc5$var$isObject(data)) {
                    if (!target[key] || !$98730e1faeae3dc5$var$isObject(target[key])) target[key] = {};
                    $98730e1faeae3dc5$var$deepAssign(target[key], data);
                } else target[key] = data;
            });
        });
        return target;
    } else throw new TypeError("Target must be an object literal.");
}
function $98730e1faeae3dc5$var$isMobile(agent) {
    if (agent === void 0) agent = navigator.userAgent;
    return /Android|iPhone|iPad|iPod/i.test(agent);
}
var $98730e1faeae3dc5$var$nextUniqueId = function() {
    var uid = 0;
    return function() {
        return uid++;
    };
}();
function $98730e1faeae3dc5$var$initialize() {
    var this$1 = this;
    $98730e1faeae3dc5$var$rinse.call(this);
    $98730e1faeae3dc5$var$each(this.store.elements, function(element) {
        var styles = [
            element.styles.inline.generated
        ];
        if (element.visible) {
            styles.push(element.styles.opacity.computed);
            styles.push(element.styles.transform.generated["final"]);
            element.revealed = true;
        } else {
            styles.push(element.styles.opacity.generated);
            styles.push(element.styles.transform.generated.initial);
            element.revealed = false;
        }
        $98730e1faeae3dc5$var$applyStyle(element.node, styles.filter(function(s) {
            return s !== "";
        }).join(" "));
    });
    $98730e1faeae3dc5$var$each(this.store.containers, function(container) {
        var target = container.node === document.documentElement ? window : container.node;
        target.addEventListener("scroll", this$1.delegate);
        target.addEventListener("resize", this$1.delegate);
    });
    /**
	 * Manually invoke delegate once to capture
	 * element and container dimensions, container
	 * scroll position, and trigger any valid reveals
	 */ this.delegate();
    /**
	 * Wipe any existing `setTimeout` now
	 * that initialization has completed.
	 */ this.initTimeout = null;
}
function $98730e1faeae3dc5$var$animate(element, force) {
    if (force === void 0) force = {};
    var pristine = force.pristine || this.pristine;
    var delayed = element.config.useDelay === "always" || element.config.useDelay === "onload" && pristine || element.config.useDelay === "once" && !element.seen;
    var shouldReveal = element.visible && !element.revealed;
    var shouldReset = !element.visible && element.revealed && element.config.reset;
    if (force.reveal || shouldReveal) return $98730e1faeae3dc5$var$triggerReveal.call(this, element, delayed);
    if (force.reset || shouldReset) return $98730e1faeae3dc5$var$triggerReset.call(this, element);
}
function $98730e1faeae3dc5$var$triggerReveal(element, delayed) {
    var styles = [
        element.styles.inline.generated,
        element.styles.opacity.computed,
        element.styles.transform.generated["final"]
    ];
    if (delayed) styles.push(element.styles.transition.generated.delayed);
    else styles.push(element.styles.transition.generated.instant);
    element.revealed = element.seen = true;
    $98730e1faeae3dc5$var$applyStyle(element.node, styles.filter(function(s) {
        return s !== "";
    }).join(" "));
    $98730e1faeae3dc5$var$registerCallbacks.call(this, element, delayed);
}
function $98730e1faeae3dc5$var$triggerReset(element) {
    var styles = [
        element.styles.inline.generated,
        element.styles.opacity.generated,
        element.styles.transform.generated.initial,
        element.styles.transition.generated.instant
    ];
    element.revealed = false;
    $98730e1faeae3dc5$var$applyStyle(element.node, styles.filter(function(s) {
        return s !== "";
    }).join(" "));
    $98730e1faeae3dc5$var$registerCallbacks.call(this, element);
}
function $98730e1faeae3dc5$var$registerCallbacks(element, isDelayed) {
    var this$1 = this;
    var duration = isDelayed ? element.config.duration + element.config.delay : element.config.duration;
    var beforeCallback = element.revealed ? element.config.beforeReveal : element.config.beforeReset;
    var afterCallback = element.revealed ? element.config.afterReveal : element.config.afterReset;
    var elapsed = 0;
    if (element.callbackTimer) {
        elapsed = Date.now() - element.callbackTimer.start;
        window.clearTimeout(element.callbackTimer.clock);
    }
    beforeCallback(element.node);
    element.callbackTimer = {
        start: Date.now(),
        clock: window.setTimeout(function() {
            afterCallback(element.node);
            element.callbackTimer = null;
            if (element.revealed && !element.config.reset && element.config.cleanup) $98730e1faeae3dc5$var$clean.call(this$1, element.node);
        }, duration - elapsed)
    };
}
function $98730e1faeae3dc5$var$sequence(element, pristine) {
    if (pristine === void 0) pristine = this.pristine;
    /**
	 * We first check if the element should reset.
	 */ if (!element.visible && element.revealed && element.config.reset) return $98730e1faeae3dc5$var$animate.call(this, element, {
        reset: true
    });
    var seq = this.store.sequences[element.sequence.id];
    var i = element.sequence.index;
    if (seq) {
        var visible = new $98730e1faeae3dc5$var$SequenceModel(seq, "visible", this.store);
        var revealed = new $98730e1faeae3dc5$var$SequenceModel(seq, "revealed", this.store);
        seq.models = {
            visible: visible,
            revealed: revealed
        };
        /**
		 * If the sequence has no revealed members,
		 * then we reveal the first visible element
		 * within that sequence.
		 *
		 * The sequence then cues a recursive call
		 * in both directions.
		 */ if (!revealed.body.length) {
            var nextId = seq.members[visible.body[0]];
            var nextElement = this.store.elements[nextId];
            if (nextElement) {
                $98730e1faeae3dc5$var$cue.call(this, seq, visible.body[0], -1, pristine);
                $98730e1faeae3dc5$var$cue.call(this, seq, visible.body[0], 1, pristine);
                return $98730e1faeae3dc5$var$animate.call(this, nextElement, {
                    reveal: true,
                    pristine: pristine
                });
            }
        }
        /**
		 * If our element isn’t resetting, we check the
		 * element sequence index against the head, and
		 * then the foot of the sequence.
		 */ if (!seq.blocked.head && i === [].concat(revealed.head).pop() && i >= [].concat(visible.body).shift()) {
            $98730e1faeae3dc5$var$cue.call(this, seq, i, -1, pristine);
            return $98730e1faeae3dc5$var$animate.call(this, element, {
                reveal: true,
                pristine: pristine
            });
        }
        if (!seq.blocked.foot && i === [].concat(revealed.foot).shift() && i <= [].concat(visible.body).pop()) {
            $98730e1faeae3dc5$var$cue.call(this, seq, i, 1, pristine);
            return $98730e1faeae3dc5$var$animate.call(this, element, {
                reveal: true,
                pristine: pristine
            });
        }
    }
}
function $98730e1faeae3dc5$var$Sequence(interval) {
    var i = Math.abs(interval);
    if (!isNaN(i)) {
        this.id = $98730e1faeae3dc5$var$nextUniqueId();
        this.interval = Math.max(i, 16);
        this.members = [];
        this.models = {};
        this.blocked = {
            head: false,
            foot: false
        };
    } else throw new RangeError("Invalid sequence interval.");
}
function $98730e1faeae3dc5$var$SequenceModel(seq, prop, store) {
    var this$1 = this;
    this.head = [];
    this.body = [];
    this.foot = [];
    $98730e1faeae3dc5$var$each(seq.members, function(id, index) {
        var element = store.elements[id];
        if (element && element[prop]) this$1.body.push(index);
    });
    if (this.body.length) $98730e1faeae3dc5$var$each(seq.members, function(id, index) {
        var element = store.elements[id];
        if (element && !element[prop]) {
            if (index < this$1.body[0]) this$1.head.push(index);
            else this$1.foot.push(index);
        }
    });
}
function $98730e1faeae3dc5$var$cue(seq, i, direction, pristine) {
    var this$1 = this;
    var blocked = [
        "head",
        null,
        "foot"
    ][1 + direction];
    var nextId = seq.members[i + direction];
    var nextElement = this.store.elements[nextId];
    seq.blocked[blocked] = true;
    setTimeout(function() {
        seq.blocked[blocked] = false;
        if (nextElement) $98730e1faeae3dc5$var$sequence.call(this$1, nextElement, pristine);
    }, seq.interval);
}
function $98730e1faeae3dc5$var$reveal(target, options, syncing) {
    var this$1 = this;
    if (options === void 0) options = {};
    if (syncing === void 0) syncing = false;
    var containerBuffer = [];
    var sequence$$1;
    var interval = options.interval || $98730e1faeae3dc5$var$defaults.interval;
    try {
        if (interval) sequence$$1 = new $98730e1faeae3dc5$var$Sequence(interval);
        var nodes = (0, $2b977cc170b19cf9$export$2e2bcd8739ae039)(target);
        if (!nodes.length) throw new Error("Invalid reveal target.");
        var elements = nodes.reduce(function(elementBuffer, elementNode) {
            var element = {};
            var existingId = elementNode.getAttribute("data-sr-id");
            if (existingId) {
                $98730e1faeae3dc5$var$deepAssign(element, this$1.store.elements[existingId]);
                /**
				 * In order to prevent previously generated styles
				 * from throwing off the new styles, the style tag
				 * has to be reverted to its pre-reveal state.
				 */ $98730e1faeae3dc5$var$applyStyle(element.node, element.styles.inline.computed);
            } else {
                element.id = $98730e1faeae3dc5$var$nextUniqueId();
                element.node = elementNode;
                element.seen = false;
                element.revealed = false;
                element.visible = false;
            }
            var config = $98730e1faeae3dc5$var$deepAssign({}, element.config || this$1.defaults, options);
            if (!config.mobile && $98730e1faeae3dc5$var$isMobile() || !config.desktop && !$98730e1faeae3dc5$var$isMobile()) {
                if (existingId) $98730e1faeae3dc5$var$clean.call(this$1, element);
                return elementBuffer // skip elements that are disabled
                ;
            }
            var containerNode = (0, $2b977cc170b19cf9$export$2e2bcd8739ae039)(config.container)[0];
            if (!containerNode) throw new Error("Invalid container.");
            if (!containerNode.contains(elementNode)) return elementBuffer // skip elements found outside the container
            ;
            var containerId;
            containerId = $98730e1faeae3dc5$var$getContainerId(containerNode, containerBuffer, this$1.store.containers);
            if (containerId === null) {
                containerId = $98730e1faeae3dc5$var$nextUniqueId();
                containerBuffer.push({
                    id: containerId,
                    node: containerNode
                });
            }
            element.config = config;
            element.containerId = containerId;
            element.styles = $98730e1faeae3dc5$var$style(element);
            if (sequence$$1) {
                element.sequence = {
                    id: sequence$$1.id,
                    index: sequence$$1.members.length
                };
                sequence$$1.members.push(element.id);
            }
            elementBuffer.push(element);
            return elementBuffer;
        }, []);
        /**
		 * Modifying the DOM via setAttribute needs to be handled
		 * separately from reading computed styles in the map above
		 * for the browser to batch DOM changes (limiting reflows)
		 */ $98730e1faeae3dc5$var$each(elements, function(element) {
            this$1.store.elements[element.id] = element;
            element.node.setAttribute("data-sr-id", element.id);
        });
    } catch (e) {
        return $98730e1faeae3dc5$var$logger.call(this, "Reveal failed.", e.message);
    }
    /**
	 * Now that element set-up is complete...
	 * Let’s commit any container and sequence data we have to the store.
	 */ $98730e1faeae3dc5$var$each(containerBuffer, function(container) {
        this$1.store.containers[container.id] = {
            id: container.id,
            node: container.node
        };
    });
    if (sequence$$1) this.store.sequences[sequence$$1.id] = sequence$$1;
    /**
	 * If reveal wasn't invoked by sync, we want to
	 * make sure to add this call to the history.
	 */ if (syncing !== true) {
        this.store.history.push({
            target: target,
            options: options
        });
        /**
		 * Push initialization to the event queue, giving
		 * multiple reveal calls time to be interpreted.
		 */ if (this.initTimeout) window.clearTimeout(this.initTimeout);
        this.initTimeout = window.setTimeout($98730e1faeae3dc5$var$initialize.bind(this), 0);
    }
}
function $98730e1faeae3dc5$var$getContainerId(node) {
    var collections = [], len = arguments.length - 1;
    while(len-- > 0)collections[len] = arguments[len + 1];
    var id = null;
    $98730e1faeae3dc5$var$each(collections, function(collection) {
        $98730e1faeae3dc5$var$each(collection, function(container) {
            if (id === null && container.node === node) id = container.id;
        });
    });
    return id;
}
/**
 * Re-runs the reveal method for each record stored in history,
 * for capturing new content asynchronously loaded into the DOM.
 */ function $98730e1faeae3dc5$var$sync() {
    var this$1 = this;
    $98730e1faeae3dc5$var$each(this.store.history, function(record) {
        $98730e1faeae3dc5$var$reveal.call(this$1, record.target, record.options, true);
    });
    $98730e1faeae3dc5$var$initialize.call(this);
}
var $98730e1faeae3dc5$var$polyfill = function polyfill(x) {
    return (x > 0) - (x < 0) || +x;
};
var $98730e1faeae3dc5$var$mathSign = Math.sign || $98730e1faeae3dc5$var$polyfill;
function $98730e1faeae3dc5$var$getGeometry(target, isContainer) {
    /**
	 * We want to ignore padding and scrollbars for container elements.
	 * More information here: https://goo.gl/vOZpbz
	 */ var height = isContainer ? target.node.clientHeight : target.node.offsetHeight;
    var width = isContainer ? target.node.clientWidth : target.node.offsetWidth;
    var offsetTop = 0;
    var offsetLeft = 0;
    var node = target.node;
    do {
        if (!isNaN(node.offsetTop)) offsetTop += node.offsetTop;
        if (!isNaN(node.offsetLeft)) offsetLeft += node.offsetLeft;
        node = node.offsetParent;
    }while (node);
    return {
        bounds: {
            top: offsetTop,
            right: offsetLeft + width,
            bottom: offsetTop + height,
            left: offsetLeft
        },
        height: height,
        width: width
    };
}
function $98730e1faeae3dc5$var$getScrolled(container) {
    var top, left;
    if (container.node === document.documentElement) {
        top = window.pageYOffset;
        left = window.pageXOffset;
    } else {
        top = container.node.scrollTop;
        left = container.node.scrollLeft;
    }
    return {
        top: top,
        left: left
    };
}
function $98730e1faeae3dc5$var$isElementVisible(element) {
    if (element === void 0) element = {};
    var container = this.store.containers[element.containerId];
    if (!container) return;
    var viewFactor = Math.max(0, Math.min(1, element.config.viewFactor));
    var viewOffset = element.config.viewOffset;
    var elementBounds = {
        top: element.geometry.bounds.top + element.geometry.height * viewFactor,
        right: element.geometry.bounds.right - element.geometry.width * viewFactor,
        bottom: element.geometry.bounds.bottom - element.geometry.height * viewFactor,
        left: element.geometry.bounds.left + element.geometry.width * viewFactor
    };
    var containerBounds = {
        top: container.geometry.bounds.top + container.scroll.top + viewOffset.top,
        right: container.geometry.bounds.right + container.scroll.left - viewOffset.right,
        bottom: container.geometry.bounds.bottom + container.scroll.top - viewOffset.bottom,
        left: container.geometry.bounds.left + container.scroll.left + viewOffset.left
    };
    return elementBounds.top < containerBounds.bottom && elementBounds.right > containerBounds.left && elementBounds.bottom > containerBounds.top && elementBounds.left < containerBounds.right || element.styles.position === "fixed";
}
function $98730e1faeae3dc5$var$delegate(event, elements) {
    var this$1 = this;
    if (event === void 0) event = {
        type: "init"
    };
    if (elements === void 0) elements = this.store.elements;
    (0, $ca22651f70a4702e$export$2e2bcd8739ae039)(function() {
        var stale = event.type === "init" || event.type === "resize";
        $98730e1faeae3dc5$var$each(this$1.store.containers, function(container) {
            if (stale) container.geometry = $98730e1faeae3dc5$var$getGeometry.call(this$1, container, true);
            var scroll = $98730e1faeae3dc5$var$getScrolled.call(this$1, container);
            if (container.scroll) container.direction = {
                x: $98730e1faeae3dc5$var$mathSign(scroll.left - container.scroll.left),
                y: $98730e1faeae3dc5$var$mathSign(scroll.top - container.scroll.top)
            };
            container.scroll = scroll;
        });
        /**
		 * Due to how the sequencer is implemented, it’s
		 * important that we update the state of all
		 * elements, before any animation logic is
		 * evaluated (in the second loop below).
		 */ $98730e1faeae3dc5$var$each(elements, function(element) {
            if (stale || element.geometry === undefined) element.geometry = $98730e1faeae3dc5$var$getGeometry.call(this$1, element);
            element.visible = $98730e1faeae3dc5$var$isElementVisible.call(this$1, element);
        });
        $98730e1faeae3dc5$var$each(elements, function(element) {
            if (element.sequence) $98730e1faeae3dc5$var$sequence.call(this$1, element);
            else $98730e1faeae3dc5$var$animate.call(this$1, element);
        });
        this$1.pristine = false;
    });
}
function $98730e1faeae3dc5$var$isTransformSupported() {
    var style = document.documentElement.style;
    return "transform" in style || "WebkitTransform" in style;
}
function $98730e1faeae3dc5$var$isTransitionSupported() {
    var style = document.documentElement.style;
    return "transition" in style || "WebkitTransition" in style;
}
var $98730e1faeae3dc5$var$version = "4.0.9";
var $98730e1faeae3dc5$var$boundDelegate;
var $98730e1faeae3dc5$var$boundDestroy;
var $98730e1faeae3dc5$var$boundReveal;
var $98730e1faeae3dc5$var$boundClean;
var $98730e1faeae3dc5$var$boundSync;
var $98730e1faeae3dc5$var$config;
var $98730e1faeae3dc5$var$debug;
var $98730e1faeae3dc5$var$instance;
function $98730e1faeae3dc5$var$ScrollReveal(options) {
    if (options === void 0) options = {};
    var invokedWithoutNew = typeof this === "undefined" || Object.getPrototypeOf(this) !== $98730e1faeae3dc5$var$ScrollReveal.prototype;
    if (invokedWithoutNew) return new $98730e1faeae3dc5$var$ScrollReveal(options);
    if (!$98730e1faeae3dc5$var$ScrollReveal.isSupported()) {
        $98730e1faeae3dc5$var$logger.call(this, "Instantiation failed.", "This browser is not supported.");
        return $98730e1faeae3dc5$var$mount.failure();
    }
    var buffer;
    try {
        buffer = $98730e1faeae3dc5$var$config ? $98730e1faeae3dc5$var$deepAssign({}, $98730e1faeae3dc5$var$config, options) : $98730e1faeae3dc5$var$deepAssign({}, $98730e1faeae3dc5$var$defaults, options);
    } catch (e) {
        $98730e1faeae3dc5$var$logger.call(this, "Invalid configuration.", e.message);
        return $98730e1faeae3dc5$var$mount.failure();
    }
    try {
        var container = (0, $2b977cc170b19cf9$export$2e2bcd8739ae039)(buffer.container)[0];
        if (!container) throw new Error("Invalid container.");
    } catch (e) {
        $98730e1faeae3dc5$var$logger.call(this, e.message);
        return $98730e1faeae3dc5$var$mount.failure();
    }
    $98730e1faeae3dc5$var$config = buffer;
    if (!$98730e1faeae3dc5$var$config.mobile && $98730e1faeae3dc5$var$isMobile() || !$98730e1faeae3dc5$var$config.desktop && !$98730e1faeae3dc5$var$isMobile()) {
        $98730e1faeae3dc5$var$logger.call(this, "This device is disabled.", "desktop: " + $98730e1faeae3dc5$var$config.desktop, "mobile: " + $98730e1faeae3dc5$var$config.mobile);
        return $98730e1faeae3dc5$var$mount.failure();
    }
    $98730e1faeae3dc5$var$mount.success();
    this.store = {
        containers: {},
        elements: {},
        history: [],
        sequences: {}
    };
    this.pristine = true;
    $98730e1faeae3dc5$var$boundDelegate = $98730e1faeae3dc5$var$boundDelegate || $98730e1faeae3dc5$var$delegate.bind(this);
    $98730e1faeae3dc5$var$boundDestroy = $98730e1faeae3dc5$var$boundDestroy || $98730e1faeae3dc5$var$destroy.bind(this);
    $98730e1faeae3dc5$var$boundReveal = $98730e1faeae3dc5$var$boundReveal || $98730e1faeae3dc5$var$reveal.bind(this);
    $98730e1faeae3dc5$var$boundClean = $98730e1faeae3dc5$var$boundClean || $98730e1faeae3dc5$var$clean.bind(this);
    $98730e1faeae3dc5$var$boundSync = $98730e1faeae3dc5$var$boundSync || $98730e1faeae3dc5$var$sync.bind(this);
    Object.defineProperty(this, "delegate", {
        get: function get() {
            return $98730e1faeae3dc5$var$boundDelegate;
        }
    });
    Object.defineProperty(this, "destroy", {
        get: function get() {
            return $98730e1faeae3dc5$var$boundDestroy;
        }
    });
    Object.defineProperty(this, "reveal", {
        get: function get() {
            return $98730e1faeae3dc5$var$boundReveal;
        }
    });
    Object.defineProperty(this, "clean", {
        get: function get() {
            return $98730e1faeae3dc5$var$boundClean;
        }
    });
    Object.defineProperty(this, "sync", {
        get: function get() {
            return $98730e1faeae3dc5$var$boundSync;
        }
    });
    Object.defineProperty(this, "defaults", {
        get: function get() {
            return $98730e1faeae3dc5$var$config;
        }
    });
    Object.defineProperty(this, "version", {
        get: function get() {
            return $98730e1faeae3dc5$var$version;
        }
    });
    Object.defineProperty(this, "noop", {
        get: function get() {
            return false;
        }
    });
    return $98730e1faeae3dc5$var$instance ? $98730e1faeae3dc5$var$instance : $98730e1faeae3dc5$var$instance = this;
}
$98730e1faeae3dc5$var$ScrollReveal.isSupported = function() {
    return $98730e1faeae3dc5$var$isTransformSupported() && $98730e1faeae3dc5$var$isTransitionSupported();
};
Object.defineProperty($98730e1faeae3dc5$var$ScrollReveal, "debug", {
    get: function get() {
        return $98730e1faeae3dc5$var$debug || false;
    },
    set: function set(value) {
        return $98730e1faeae3dc5$var$debug = typeof value === "boolean" ? value : $98730e1faeae3dc5$var$debug;
    }
});
$98730e1faeae3dc5$var$ScrollReveal();
var $98730e1faeae3dc5$export$2e2bcd8739ae039 = $98730e1faeae3dc5$var$ScrollReveal;


document.addEventListener("DOMContentLoaded", function() {
    var sr = (0, $98730e1faeae3dc5$export$2e2bcd8739ae039)();
    sr.reveal(".reveal", {
        delay: 100,
        interval: 100,
        reset: true
    });
    var sr2 = (0, $98730e1faeae3dc5$export$2e2bcd8739ae039)();
    sr2.reveal(".revealup", {
        delay: 0,
        distance: "10%",
        origin: "bottom",
        interval: 100,
        scale: 1.2
    });
});


var $c01877568e2cad66$exports = {};
/*! lazysizes - v5.3.2 */ !function(e) {
    var t = function(u, D, f) {
        "use strict";
        var k, H;
        if (function() {
            var _$e;
            var t = {
                lazyClass: "lazyload",
                loadedClass: "lazyloaded",
                loadingClass: "lazyloading",
                preloadClass: "lazypreload",
                errorClass: "lazyerror",
                autosizesClass: "lazyautosizes",
                fastLoadedClass: "ls-is-cached",
                iframeLoadMode: 0,
                srcAttr: "data-src",
                srcsetAttr: "data-srcset",
                sizesAttr: "data-sizes",
                minSize: 40,
                customMedia: {},
                init: true,
                expFactor: 1.5,
                hFac: 0.8,
                loadMode: 2,
                loadHidden: true,
                ricTimeout: 0,
                throttleDelay: 125
            };
            H = u.lazySizesConfig || u.lazysizesConfig || {};
            for(_$e in t)if (!(_$e in H)) H[_$e] = t[_$e];
        }(), !D || !D.getElementsByClassName) return {
            init: function init() {},
            cfg: H,
            noSupport: true
        };
        var O = D.documentElement, i = u.HTMLPictureElement, P = "addEventListener", $ = "getAttribute", q = u[P].bind(u), I = u.setTimeout, U = u.requestAnimationFrame || I, o = u.requestIdleCallback, j = /^picture$/i, r = [
            "load",
            "error",
            "lazyincluded",
            "_lazyloaded"
        ], a = {}, G = Array.prototype.forEach, J = function J(e, t) {
            if (!a[t]) a[t] = new RegExp("(\\s|^)" + t + "(\\s|$)");
            return a[t].test(e[$]("class") || "") && a[t];
        }, K = function K(e, t) {
            if (!J(e, t)) e.setAttribute("class", (e[$]("class") || "").trim() + " " + t);
        }, Q = function Q(e, t) {
            var a;
            if (a = J(e, t)) e.setAttribute("class", (e[$]("class") || "").replace(a, " "));
        }, V = function V1(t, a, e) {
            var i = e ? P : "removeEventListener";
            if (e) V(t, a);
            r.forEach(function(e) {
                t[i](e, a);
            });
        }, X = function X(e, t, a, i, r) {
            var n = D.createEvent("Event");
            if (!a) a = {};
            a.instance = k;
            n.initEvent(t, !i, !r);
            n.detail = a;
            e.dispatchEvent(n);
            return n;
        }, Y = function Y(e, t) {
            var a;
            if (!i && (a = u.picturefill || H.pf)) {
                if (t && t.src && !e[$]("srcset")) e.setAttribute("srcset", t.src);
                a({
                    reevaluate: true,
                    elements: [
                        e
                    ]
                });
            } else if (t && t.src) e.src = t.src;
        }, Z = function Z(e, t) {
            return (getComputedStyle(e, null) || {})[t];
        }, s = function s(e, t, a) {
            a = a || e.offsetWidth;
            while(a < H.minSize && t && !e._lazysizesWidth){
                a = t.offsetWidth;
                t = t.parentNode;
            }
            return a;
        }, ee = function() {
            var a, i;
            var t = [];
            var r = [];
            var n = t;
            var s = function s() {
                var _$e = n;
                n = t.length ? r : t;
                a = true;
                i = false;
                while(_$e.length)_$e.shift()();
                a = false;
            };
            var _$e = function e(e, t) {
                if (a && !t) e.apply(this, arguments);
                else {
                    n.push(e);
                    if (!i) {
                        i = true;
                        (D.hidden ? I : U)(s);
                    }
                }
            };
            _$e._lsFlush = s;
            return _$e;
        }(), te = function te(a, e) {
            return e ? function() {
                ee(a);
            } : function() {
                var _$e = this;
                var t = arguments;
                ee(function() {
                    a.apply(_$e, t);
                });
            };
        }, ae = function ae(e) {
            var a;
            var i = 0;
            var r = H.throttleDelay;
            var n = H.ricTimeout;
            var t = function t() {
                a = false;
                i = f.now();
                e();
            };
            var s = o && n > 49 ? function s() {
                o(t, {
                    timeout: n
                });
                if (n !== H.ricTimeout) n = H.ricTimeout;
            } : te(function() {
                I(t);
            }, true);
            return function(e) {
                var t;
                if (e = e === true) n = 33;
                if (a) return;
                a = true;
                t = r - (f.now() - i);
                if (t < 0) t = 0;
                if (e || t < 9) s();
                else I(s, t);
            };
        }, ie = function ie(e) {
            var t, a;
            var i = 99;
            var r = function r() {
                t = null;
                e();
            };
            var n = function n1() {
                var _$e = f.now() - a;
                if (_$e < i) I(n, i - _$e);
                else (o || r)(r);
            };
            return function() {
                a = f.now();
                if (!t) t = I(n, i);
            };
        }, _$e = function() {
            var v, m, c, h, _$e;
            var y, z, g, p, C, b, A;
            var n = /^img$/i;
            var d = /^iframe$/i;
            var E = "onscroll" in u && !/(gle|ing)bot/.test(navigator.userAgent);
            var _ = 0;
            var w = 0;
            var M = 0;
            var N = -1;
            var L = function L(e) {
                M--;
                if (!e || M < 0 || !e.target) M = 0;
            };
            var x = function x(e) {
                if (A == null) A = Z(D.body, "visibility") == "hidden";
                return A || !(Z(e.parentNode, "visibility") == "hidden" && Z(e, "visibility") == "hidden");
            };
            var W = function W(e, t) {
                var a;
                var i = e;
                var r = x(e);
                g -= t;
                b += t;
                p -= t;
                C += t;
                while(r && (i = i.offsetParent) && i != D.body && i != O){
                    r = (Z(i, "opacity") || 1) > 0;
                    if (r && Z(i, "overflow") != "visible") {
                        a = i.getBoundingClientRect();
                        r = C > a.left && p < a.right && b > a.top - 1 && g < a.bottom + 1;
                    }
                }
                return r;
            };
            var t = function t() {
                var _$e, t, a, i, r, n, s, o, l, _$u, f, c;
                var d = k.elements;
                if ((h = H.loadMode) && M < 8 && (_$e = d.length)) {
                    t = 0;
                    N++;
                    for(; t < _$e; t++){
                        if (!d[t] || d[t]._lazyRace) continue;
                        if (!E || k.prematureUnveil && k.prematureUnveil(d[t])) {
                            R(d[t]);
                            continue;
                        }
                        if (!(o = d[t][$]("data-expand")) || !(n = o * 1)) n = w;
                        if (!_$u) {
                            _$u = !H.expand || H.expand < 1 ? O.clientHeight > 500 && O.clientWidth > 500 ? 500 : 370 : H.expand;
                            k._defEx = _$u;
                            f = _$u * H.expFactor;
                            c = H.hFac;
                            A = null;
                            if (w < f && M < 1 && N > 2 && h > 2 && !D.hidden) {
                                w = f;
                                N = 0;
                            } else if (h > 1 && N > 1 && M < 6) w = _$u;
                            else w = _;
                        }
                        if (l !== n) {
                            y = innerWidth + n * c;
                            z = innerHeight + n;
                            s = n * -1;
                            l = n;
                        }
                        a = d[t].getBoundingClientRect();
                        if ((b = a.bottom) >= s && (g = a.top) <= z && (C = a.right) >= s * c && (p = a.left) <= y && (b || C || p || g) && (H.loadHidden || x(d[t])) && (m && M < 3 && !o && (h < 3 || N < 4) || W(d[t], n))) {
                            R(d[t]);
                            r = true;
                            if (M > 9) break;
                        } else if (!r && m && !i && M < 4 && N < 4 && h > 2 && (v[0] || H.preloadAfterLoad) && (v[0] || !o && (b || C || p || g || d[t][$](H.sizesAttr) != "auto"))) i = v[0] || d[t];
                    }
                    if (i && !r) R(i);
                }
            };
            var a = ae(t);
            var S = function S(e) {
                var t = e.target;
                if (t._lazyCache) {
                    delete t._lazyCache;
                    return;
                }
                L(e);
                K(t, H.loadedClass);
                Q(t, H.loadingClass);
                V(t, B);
                X(t, "lazyloaded");
            };
            var i = te(S);
            var B = function B(e) {
                i({
                    target: e.target
                });
            };
            var T = function T(e, t) {
                var a = e.getAttribute("data-load-mode") || H.iframeLoadMode;
                if (a == 0) e.contentWindow.location.replace(t);
                else if (a == 1) e.src = t;
            };
            var F = function F(e) {
                var t;
                var a = e[$](H.srcsetAttr);
                if (t = H.customMedia[e[$]("data-media") || e[$]("media")]) e.setAttribute("media", t);
                if (a) e.setAttribute("srcset", a);
            };
            var s = te(function(t, e, a, i, r) {
                var n, s, o, l, _$u, f;
                if (!(_$u = X(t, "lazybeforeunveil", e)).defaultPrevented) {
                    if (i) {
                        if (a) K(t, H.autosizesClass);
                        else t.setAttribute("sizes", i);
                    }
                    s = t[$](H.srcsetAttr);
                    n = t[$](H.srcAttr);
                    if (r) {
                        o = t.parentNode;
                        l = o && j.test(o.nodeName || "");
                    }
                    f = e.firesLoad || "src" in t && (s || n || l);
                    _$u = {
                        target: t
                    };
                    K(t, H.loadingClass);
                    if (f) {
                        clearTimeout(c);
                        c = I(L, 2500);
                        V(t, B, true);
                    }
                    if (l) G.call(o.getElementsByTagName("source"), F);
                    if (s) t.setAttribute("srcset", s);
                    else if (n && !l) {
                        if (d.test(t.nodeName)) T(t, n);
                        else t.src = n;
                    }
                    if (r && (s || l)) Y(t, {
                        src: n
                    });
                }
                if (t._lazyRace) delete t._lazyRace;
                Q(t, H.lazyClass);
                ee(function() {
                    var _$e = t.complete && t.naturalWidth > 1;
                    if (!f || _$e) {
                        if (_$e) K(t, H.fastLoadedClass);
                        S(_$u);
                        t._lazyCache = true;
                        I(function() {
                            if ("_lazyCache" in t) delete t._lazyCache;
                        }, 9);
                    }
                    if (t.loading == "lazy") M--;
                }, true);
            });
            var R = function R(e) {
                if (e._lazyRace) return;
                var t;
                var a = n.test(e.nodeName);
                var i = a && (e[$](H.sizesAttr) || e[$]("sizes"));
                var r = i == "auto";
                if ((r || !m) && a && (e[$]("src") || e.srcset) && !e.complete && !J(e, H.errorClass) && J(e, H.lazyClass)) return;
                t = X(e, "lazyunveilread").detail;
                if (r) re.updateElem(e, true, e.offsetWidth);
                e._lazyRace = true;
                M++;
                s(e, t, r, i, a);
            };
            var r = ie(function() {
                H.loadMode = 3;
                a();
            });
            var o = function o() {
                if (H.loadMode == 3) H.loadMode = 2;
                r();
            };
            var l = function l1() {
                if (m) return;
                if (f.now() - _$e < 999) {
                    I(l, 999);
                    return;
                }
                m = true;
                H.loadMode = 3;
                a();
                q("scroll", o, true);
            };
            return {
                _: function _() {
                    _$e = f.now();
                    k.elements = D.getElementsByClassName(H.lazyClass);
                    v = D.getElementsByClassName(H.lazyClass + " " + H.preloadClass);
                    q("scroll", a, true);
                    q("resize", a, true);
                    q("pageshow", function(e) {
                        if (e.persisted) {
                            var t = D.querySelectorAll("." + H.loadingClass);
                            if (t.length && t.forEach) U(function() {
                                t.forEach(function(e) {
                                    if (e.complete) R(e);
                                });
                            });
                        }
                    });
                    if (u.MutationObserver) new MutationObserver(a).observe(O, {
                        childList: true,
                        subtree: true,
                        attributes: true
                    });
                    else {
                        O[P]("DOMNodeInserted", a, true);
                        O[P]("DOMAttrModified", a, true);
                        setInterval(a, 999);
                    }
                    q("hashchange", a, true);
                    [
                        "focus",
                        "mouseover",
                        "click",
                        "load",
                        "transitionend",
                        "animationend"
                    ].forEach(function(e) {
                        D[P](e, a, true);
                    });
                    if (/d$|^c/.test(D.readyState)) l();
                    else {
                        q("load", l);
                        D[P]("DOMContentLoaded", a);
                        I(l, 2e4);
                    }
                    if (k.elements.length) {
                        t();
                        ee._lsFlush();
                    } else a();
                },
                checkElems: a,
                unveil: R,
                _aLSL: o
            };
        }(), re = function() {
            var a;
            var n = te(function(e, t, a, i) {
                var r, n, s;
                e._lazysizesWidth = i;
                i += "px";
                e.setAttribute("sizes", i);
                if (j.test(t.nodeName || "")) {
                    r = t.getElementsByTagName("source");
                    for(n = 0, s = r.length; n < s; n++)r[n].setAttribute("sizes", i);
                }
                if (!a.detail.dataAttr) Y(e, a.detail);
            });
            var i = function i(e, t, a) {
                var i;
                var r = e.parentNode;
                if (r) {
                    a = s(e, r, a);
                    i = X(e, "lazybeforesizes", {
                        width: a,
                        dataAttr: !!t
                    });
                    if (!i.defaultPrevented) {
                        a = i.detail.width;
                        if (a && a !== e._lazysizesWidth) n(e, r, i, a);
                    }
                }
            };
            var _$e = function e() {
                var _$e;
                var t = a.length;
                if (t) {
                    _$e = 0;
                    for(; _$e < t; _$e++)i(a[_$e]);
                }
            };
            var t = ie(_$e);
            return {
                _: function _() {
                    a = D.getElementsByClassName(H.autosizesClass);
                    q("resize", t);
                },
                checkElems: t,
                updateElem: i
            };
        }(), t = function t1() {
            if (!t.i && D.getElementsByClassName) {
                t.i = true;
                re._();
                _$e._();
            }
        };
        return I(function() {
            H.init && t();
        }), k = {
            cfg: H,
            autoSizer: re,
            loader: _$e,
            init: t,
            uP: Y,
            aC: K,
            rC: Q,
            hC: J,
            fire: X,
            gW: s,
            rAF: ee
        };
    }(e, e.document, Date);
    e.lazySizes = t, (0, $c01877568e2cad66$exports) && ($c01877568e2cad66$exports = t);
}("undefined" != typeof window ? window : {});





})();
//# sourceMappingURL=main.js.map
